import React, {useState, useImperativeHandle, useContext} from "react";
import {
    AppClassProperties,
    DataURL, DisplayMode,
    ExcalidrawImperativeAPI,
    Gesture,
    NormalizedZoomValue, PageSizeValues, FrameSize, ExcalidrawInitialDataState
} from "../../../@excalidraw/packages/excalidraw/types";

//这些玩意，怎么引入。
import {Image, message, Popover, Tooltip} from "antd";
import {
    MainMenu,
    Excalidraw,
    loadFromBlob,
    exportToClipboard,
    serializeAsJSON,
    exportToBlob, sceneCoordsToViewportCoords, newElementWith, mutateElement, MIME_TYPES
} from "../../../@excalidraw/packages/excalidraw";
import html2canvas from "html2canvas";
import History from "../../../@excalidraw/packages/excalidraw/history";
import {addEventListener, postMessage, recvMessage, triggerEvent, unSubscribe, useEventListener} from "@/common/event";
import {
    ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG,
    ARRAY_IFRAME_SIZE,
    COLOR_E5E5E5,
    COLOR_TRANSPARENT,
    DEFAULT_CANVAS_BACKGROUND,
    DEFAULT_CANVAS_BACKGROUND_DARK, DEFAULT_ELEMENT_STROKE_WITHD,
    DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT,
    DEFAULT_EMBEDABLE_BOOKMARK_WIDTH,
    DEFAULT_EMBEDABLE_ELEMENT_HEIGHT,
    DEFAULT_EMBEDABLE_ELEMENT_WIDTH,
    DEFAULT_NOTE_HEIGHT, DEFAULT_NOTE_HEIGHT_1, DEFAULT_NOTE_HEIGHT_2,
    DEFAULT_NOTE_WIDTH,
    DEFAULT_TOOLBAR_HEIGHT,
    DRAW_TOOLS_HEIGHT,
    ELEMENT_POPOVER_TOOLS_OFFSET_Y,
    EVENT_ACTIVE_CARD_EDIT,
    EVENT_ADD_NOTE,
    EVENT_CANVAS_COPY_ADD_IFRAME,
    EVENT_CANVAS_DELETE_ELEMENT,
    EVENT_CANVAS_EXPAND_STATS_CHANGED,
    EVENT_CANVAS_REFRESH_ELEMENT_COUNT,
    EVENT_CANVAS_SELECT_IFRAME,
    EVENT_CARD_CLOSED,
    EVENT_DELETE_ELEMENT,
    EVENT_DELETE_ELEMENT_BY_ID,
    EVENT_DELETE_LEFT_CARD,
    EVENT_DELETE_LEFT_CARD_BAT,
    EVENT_ELEMENT_DELETE,
    EVENT_ELEMENT_DELETE_FROM_ACTION,
    EVENT_FAVIRIATE_CHANGE,
    EVENT_FRAME_MAKE_COPY,
    EVENT_FRAME_POINTER_UP,
    EVENT_HIDDEN_FLOAT_MENU,
    EVENT_MINDMAP_REMOVE_ATTACH,
    EVENT_NAVIGATE_DEEPLINK,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_ONSCROLL_TO_ELEMENT,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_OPEN_VIDEO_IN_POPUP,
    EVENT_PASTE_DEEP_LINK,EVENT_PASTE_MINDMAP_PLAINT_TEXT,
    EVENT_PASTE_URL,
    EVENT_PDF_ON_SLIDER_RIGHT,
    EVENT_PROJECT_ON_SlIDER_RIGHT, EVENT_REFRESH_CONTENT_BOOKMARK_,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_RESIZING_CARD,
    EVENT_SAVE_TO_SERVER,
    EVENT_SHOW_CONTEXT_MENU,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    EVENT_SHOW_SNAP_LINE,
    EVENT_TEST_ONDRAG_NOTE,
    EVENT_UPDATE_ELEMENT_BOUND,
    EVENT_UPDATE_ELEMENT_HAS_UPDATE,
    EVENT_UPDATE_FONT_SIZE,
    EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,
    EVENT_UPDATE_FRAME_LIST,
    EVENT_UPDATE_FRAME_NAME,
    EVENT_UPDATE_FRAME_SORT,
    EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,
    EVENT_UPDATE_NOTE_HEIGHT,
    EVENT_UPDATE_PDF_NAME,
    EVENT_VIDEO_ON_SLIDER_RIGHT, EVENT_WEBLINK_ON_SLIDER_RIGHT,
    FROM_HISTORY,
    FROM_LIBRARY,
    FROM_LINK_TO_PROJECT,
    getBookmarkBackgroundColor,
    getNoteElementBackgroundColor,
    getNoteElementStrokeColor,
    getNoteElementStrokeColor250724, HAS_ENABLE_TIPTAP_TEXT,
    INFO_NOTES_EXTRA_HEIGHT,
    KEY_CARD_ELEMENT_DEFAULT_STYLE, KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,
    KEY_DONOT_SHOW_REMOVE_IMAGE_TIP,
    KEY_FILE_DIR,
    KEY_GLOBAL_CONNECTOR_TYPE,
    KEY_GLOBAL_SNAP_LINE_VISIBLE,
    KEY_ISCTRL_CMD_PRESSED,
    KEY_NEW_PROJECT_ID, LASTEST_NOTE_DOC,
    LEFT_MENU_WIDTH,
    LINK_INFO_TYPE_ELEMENT,
    LINK_INFO_TYPE_FILE,
    LINK_INFO_TYPE_FRAME,
    LINK_INFO_TYPE_JOURNAL,
    LINK_INFO_TYPE_NOTE,
    LINK_INFO_TYPE_PAGE,
    LINK_INFO_TYPE_PDF,
    LINK_INFO_TYPE_URL,
    MARGIN_TOP_CONTENT,
    MAX_CARD_COUNT, MAX_NOTES_HEIGHT,
    MENU_SEPARATOR,
    POST_MESSAGE_RENAME_SUB_NOTENAME,
    SYS_CONFIG_KEY_THEME
} from "@/Const";
import {
    base64ImgToSVGSimple,
    base64ToBlob,
    calcTextAreaHeight, calcTextAreaInfoNotesHeight,
    calcTextHeight,
    calcVideoAnnoHeight,
    checkIfAbsolute,
    createCopyLink,
    createCopyLinkByLibraryItem,
    createEmptyProject,
    createNoteElementByNote,
    createPdfAnnoTextElement,
    decodeDeeplink,
    extFromMineType,
    firstLetterUpper,
    generateRandomPageKey,
    generateUUID2,
    getAudioFilterExt,
    getBase64ImageSize,
    getCtrlOrAlt,
    getFileName,
    getImagePathWithTheme, getImagePathWithThemeSvg, getItem,
    getLocalFilePath,
    getQueryParam,
    getUrlQueryParam,
    getYoutubeThumbUrl, hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix,
    imgToBase64,
    isAbsoluteFilePath, isAnnoElement, isAnnoType,
    isAudio,
    isAudioAnnoElement,
    isAudioFileElement, isBaiduVideoUrl,
    isBilibiliUrl,
    isCardAnnoElement, isCardBlockDeeplink,
    isCardEmptyCard,
    isDarkMode,
    isDeepLink,
    isFileElement,
    isFileVideoElement,
    isFreeCreateCardMode, isImage, isInSidebar, isJournalElement,
    isJson,
    isLinkAndNotExist, isLiveVideoElement, isLiveVideoType, isMdFileElement,
    isNoteElement,
    isPdf,
    isPdfAnnoElement,
    isPdfFileElement,
    isStringNullOrEmpty,
    isSupportVideoAnnoUrl,
    isSvg,
    isVideo,
    isVideoAnnoElement,
    isYoutubeUrl, removeHtmlTags,
    svgStringToBase64
} from "@/utils";
import {ipcInvoke, ipcOn, ipcSend} from "@/common/ipc";
import "./MyExcalidraw.css"
import i18n, {t} from "i18next";
import DialogWordCount from "@/views/Draw/DialogWordCount";
import {IMAGE_MIME_TYPES, ROUNDNESS} from "../../../@excalidraw/packages/excalidraw/constants";
import Global from "@/global"
import {APP_WEB, APP_WEB_WWW, DEBUG, isWeb, isWebApp} from "@/electron_interactive";
import {getShareDataUrl} from "@/api/Aws";
import {
    isArrowElement, isEmbedableBookmarkElement,
    isEmbeddableElement, isFrameElement, isFreeDrawElement,
    isImageElement,
    isMindmapElement, isProjectLinkElement, isShapeElement, isStickyNotesElement, isTextElement, isUsingAdaptiveRadius
} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {ActionToolbar_Menu} from "../../../@excalidraw/packages/excalidraw/components/ActionToolbar_Menu";
import style from "../../../@excalidraw/packages/excalidraw/components/ActionToolbar.module.scss";
import {
    calculateScrollCenter, getSelectedElements,
    getTargetElements
} from "../../../@excalidraw/packages/excalidraw/scene";
import {isMobile} from "react-device-detect";
import {apiDeleteElement, apiElementDeleteByIds, apiUpdateElement} from "@/api/AppApi";
import {
    deleteCard,
    getCardById,
    getCardCount,
    getCardDoc, getCardList,
    getCardListByLibraryId, renameCardById,
    updateCard,
    updateChangeSource
} from "@model/card";
import {mPublishId, PROJECT_ID} from "@/views/Draw/DrawIndex";
import clipboard from "clipboardy";
import {quickFlowElementsType} from "../../../@excalidraw/packages/excalidraw/renderer/renderScene";
import {getNoteById, updateNote, updateProject} from "@model/note";
import {editDoc} from "@model/doc";
import JSZip from "jszip";
import {getNoteName, noteServer} from "@/common/notesServer";
import { saveAs } from 'file-saver';
import global from "@/global";
import i18next from "i18next";
import {getEmbedLink} from "../../../@excalidraw/packages/excalidraw/element/embeddable";
import {toValidURL} from "../../../@excalidraw/packages/excalidraw/data/url";
import {isZh} from "@/language";
import {createBreadcrumb, deepLinkToLinkInfo, getCardPath, isMac, isSupportLink} from "@/Utility";
import {randomInteger} from "../../../@excalidraw/packages/excalidraw/random";
import {dbGetHighlight, dbGetHighlightByLibraryId, updateHighlight} from "@model/highlight";
import {
    mindMapCache,
    mindMapId_Data, mousedownedNode,
    renderNodesToolBar
} from "../../../@excalidraw/packages/excalidraw/element/mindMap";
import cardLink from "../../../@excalidraw/packages/excalidraw/element/cardLink";
import {apiBilibiliCover, fetchPageTitle} from "@/api/ThirdApi";
import {copyImageFullPathToClipboard, copyImageToClipboard, getBaiduVideoNameByUrl} from "@/Utility0";
import {ARRAY_CARD_DEFAULT_COLORS, ARRAY_STICKYNOTES_DEFAULT_COLORS} from "@/ColorUtility";
import {getImageElementIcon} from "@/Icon";
import {nodeIconList} from "../../../@excalidraw/packages/excalidraw/components/MindMap/icons";
import {loop} from "@/TreeUtils";
import {getBoardById, updateBoard} from "@model/board";
import {shareCardData} from "@/views/Utils/CardUtils";
import {downloadImageAsBlob, serializeProseMirrorToMarkdown} from "@/components/EditorV2/markdownSerializer";
import {LinearElementEditor} from "../../../@excalidraw/packages/excalidraw/element/linearElementEditor";

let fs:any = null;
let ipcRenderer:any = null;

const GRID_SIZE_CUSTOM = 25;
let mapHistroy:any = {};
let isCanvasReadonly:boolean = false;
//鼠标左键按下
let isPointerDownPressed:boolean = false;

const menuItemHeight = 34;
const DEFAULT_GRID_SIZE = 10;

//左侧菜单是否折叠
let mIsLeftMenuCollapse:any = false;

let mContextMenuPosition = {x:0,y:0}

/**
 * 已经更新过的draw,text....
 */
let mHasSavedElementIds:any = {};
/**
 * 橡皮擦已经删除过的元素
 */
let mHasDeletedElementIds:any = {};

/**
 * 正常更新过的元素。
 */
let mHasNormalUpdateElementIds:any = {};

//上次的更新时间
let mLastUpdateTime:any = 0;
let mLastUpdateTimeUp:any = 0;

//当前打开的pdf的注记...信息
let mOpenPdfData:any = null;
//当前粘贴的deeplink链接，可以转换成embed....
let mPasteDeeplinkElement:any = null;

const ARRAY_LAYOUT_ITEM = ()=>  {
    return [
        {
            id:'alignHorizontal',
            image:'toolbar_layout_horizontal.svg',
            name:t('Horizontal')
        },
        {
            id:'alignVertical',
            image:'toolbar_layout_vertical.svg',
            name:t('Vertical')
        },
        {
            id:'alignGrid',
            image:'toolbar_layout_grid.svg',
            name:t('Grid')
        }
    ]
}
// gridSize:GRID_SIZE_CUSTOM,
//   viewMode:true
// const excalidrawInitData:ExcalidrawInitialDataState = {
//     elements:[
//     ],
//     appState:{
//         currentItemStrokeWidth:1,
//         currentItemRoughness:0,
//         viewBackgroundColor: DEFAULT_CANVAS_BACKGROUND,
//         width:400,
//         height:600,
//         // gridModeEnabled:true,
//         // gridSize:10
//         viewModeEnabled:APP_WEB,
//         leftMenuWidth:LEFT_MENU_WIDTH,//左边栏宽度---
//         zoom:{value:1.0}
//     },
//     scrollToContent:false,
//     libraryItems:[]
// }

interface AppProps {
    //code related to your props goes here
    value: any,
    onRef:any,
    parentOnCanvasChange:any,
    parentOnEditNoteData:any,
    parentOnExcalidrawInitComplete:any,
    parentOnLinkNav:any,
    parentOnResetTool:any,
    parentOnPointDown:any,
    parentOnPointerUp:any,
    parentOnSelectElement:any,
    parentOnSelectElementChanged:any,
    parentOnSceneElementUpdate:any,
    parentOnOpenPdfFile:any,
    setDisplayMode: (displayMode: DisplayMode) => void;
    parentOnShowTip:(szType:string,szTitle:string,szContent:string)=>void;
    parentOnGetSelectedBoard:()=>any;
    parentOnSaveNotes:()=>any;
    parentOnMenuAction:(action:string|null,data:any)=>void;
    parentOnLoadBoardFinished:()=>any;
    parentOnFirstLoadFinished:()=>any;//第一次加载完成
    parentOnZoomChanged:()=>void;
}

interface AppState {
    isImagePreviewVisible: any,
    imagePreviewData: any,
    excalidrawAutofocus: boolean,
    isReadOnlyStatus: boolean,
    isShowGridMode: boolean,
    menuPosition: any,
    isShowMenu:boolean,
    arrayMoreMenus:any,
    isShowMoreMenu:boolean,
    isShowPopoverMoreMenu:boolean,
    isShowPopoverLineType:boolean,
    isShowStartArrowPopover:boolean,
    isShowEndArrowPopover:boolean,
    isShowContextMenu:boolean,
    isShowFileNoExistMenu:boolean,
    arrayImages:any,
    currentPreviewIndex:any,
    contextMenuPosition:any,
    mCurrentSelectedElement:any,
    projectId:string,
    isBorderColorPopover:boolean,
    isBorderStylePopover:boolean,
    isOpacityPopover:boolean,
    isPositionPopover:boolean,
    isLayerPopover:boolean,
    isAlignPopover:boolean,
    randomKey:string,
    isOutsideContent:boolean,
    arrayCardContextMenuColors:any,
    arrayStickyNotesMenuColors:any,
    isFramePopoverOpen:boolean,
    arrayCurrentElementTags:any[],
    isShowStrokeColorPopup:boolean,
    loadDrawJsonTimes:number
}
let excalidrawAPI:ExcalidrawImperativeAPI;
let lastTime:any = 0;
let szFirstCanvasId:any = null;
// let visible = false;

//当前工具，全屏展示的返回的时候还原。。。不然绘制的时候那个 属性框会闪来闪去的。。。。
let mCurrentActiveTool="";

let dialogWordCountRef:any;
class MyExcalidraw extends React.Component<AppProps, AppState> {
    constructor(AppProps: any) {
        super(AppProps);
        this.state = {
            isImagePreviewVisible: false,
            imagePreviewData: null,
            excalidrawAutofocus: true,
            isReadOnlyStatus: false,
            isShowGridMode: true,
            menuPosition:{left:'0px',top:'0px',moreLeft:'0px',moreTop:'0px'},
            isShowMenu:false,
            arrayMoreMenus:[],
            isShowMoreMenu:false,
            isShowPopoverMoreMenu:false,
            isShowPopoverLineType:false,
            isShowFileNoExistMenu:false,
            arrayImages:[],
            currentPreviewIndex:0,
            isShowContextMenu:false,
            contextMenuPosition:{left:'0px',top:'0px'},
            //当前选中的元素
            mCurrentSelectedElement:null,
            projectId:'',
            isBorderColorPopover:false,
            isBorderStylePopover:false,
            isOpacityPopover:false,
            isPositionPopover:false,
            isLayerPopover:false,
            isAlignPopover:false,
            randomKey:'1',
            isOutsideContent:false,
            arrayCardContextMenuColors:ARRAY_CARD_DEFAULT_COLORS,
            arrayStickyNotesMenuColors:ARRAY_STICKYNOTES_DEFAULT_COLORS,
            isFramePopoverOpen:false,
            arrayCurrentElementTags:[],
            isShowStrokeColorPopup:false,
            loadDrawJsonTimes:0
        }
    }

    private mArrayTimeoutIds:any = [];
    private mLastPointerDown:number = 0;

    onDialogWordCountRef(ref){
        dialogWordCountRef = ref;
    }

    componentDidUpdate(prevProps: Readonly<AppProps>, prevState: Readonly<AppState>, snapshot?: any) {
        // var canvas = document.getElementById("canvas");
        // window.addEventListener("keydown",(e)=>{
        //     if (e.key === 'd'){
        //         this.setState({
        //             isShowMenu:false,
        //             isShowMoreMenu:false
        //         })
        //     }
        // })
        // if (prevState.isShowMenu != this.state.isShowMenu){
        //     console.log('xxxx')
        // }
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Error boundary caught an error', error, errorInfo);
    }

    static getDerivedStateFromError(error) {
        // 更新 state 以反映错误，例如显示一个 fallback UI
        return { hasError: true };
    }

    componentDidMount() {
        mHasNormalUpdateElementIds = {};
        mHasSavedElementIds = {};
        mHasDeletedElementIds = {};

        this.props.onRef && this.props.onRef(this);
        this.onInitData();

        // addEventListener(EVENT_CANVAS_DELETE_NOTE, (data:any)=>{
        //     this.onDeleteElement(data.detail);
        // });


        recvMessage(EVENT_ELEMENT_DELETE,async (msg,data)=> {
            //如果当前选中的card
            //如果是卡片，空白卡片，左侧栏删除-库中删除.
            // const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (data.data?.arrayNoteIds){
                for (let i=0;i<data.data.arrayNoteIds.length;i++){
                    const szId = data.data.arrayNoteIds[i];
                    const card = await getCardById(szId);
                    if (card){
                        if (isCardEmptyCard(card)){
                            deleteCard(card.id);
                            postMessage(EVENT_DELETE_LEFT_CARD,{id:card.id})
                        }
                    }
                }
            }


            this.setState({
                isShowMenu: false,
                isShowMoreMenu: false
            })
        })

        //执行删除
        recvMessage(EVENT_DELETE_ELEMENT,(msg,data)=>{
            this.onMenuClick('delete');
        },true);

        //根据ID删除元素
        recvMessage(EVENT_DELETE_ELEMENT_BY_ID,(msg,data)=>{
            const szId = data.data.id;
            excalidrawAPI.getApp().removeElementById(szId);
            this.hidePopupMenu();
        },true)

        //更新界面上的元素的排序...
        recvMessage(EVENT_UPDATE_FRAME_SORT,(msg,data)=>{
            var arrayElements = excalidrawAPI.getSceneElements();
            var arrayNewElements = [];
            for (let i=0;i<arrayElements.length;i++){
                const item = arrayElements[i];
                if (item.type == 'frame'){

                }else{
                    arrayNewElements.push(item);
                }
            }
            for (let i=0;i<data.data.arrayTreeFrameList.length;i++){
                arrayNewElements.push(data.data.arrayTreeFrameList[i].element);
            }

            excalidrawAPI.updateScene({
                elements: arrayNewElements,
            });
        },true)

        //更新 已更新标识
        recvMessage(EVENT_UPDATE_ELEMENT_HAS_UPDATE,(msg,data)=>{
            var arrayElements = excalidrawAPI.getSceneElements();
            var arrayNewElements = [];
            for (let i=0;i<arrayElements.length;i++){
                const item = arrayElements[i];
                arrayNewElements.push({
                    ...item,
                    hasUpdate:false
                });
            }

            excalidrawAPI.updateScene({
                elements: arrayNewElements,
            });
        },true)

        recvMessage(EVENT_CANVAS_COPY_ADD_IFRAME,(msg,data)=>{
            //复制画布
            var arrayElements:any = excalidrawAPI.getSceneElements();
            var elements = arrayElements.filter(p=>p.id == data.data.oldKey);
            if(elements != undefined && elements.length>0){
                const ele = elements[0];
                var newEle = {
                    ...ele,
                    x:ele.x+10,
                    y:ele.y+10,
                    id: data.data.data.newKey,
                    customData: {
                        generationData: {
                            status: 'done',
                            html: ele.customData.generationData.html
                        }
                    }
                }
                arrayElements.push(newEle);

                excalidrawAPI.updateScene({
                    elements:arrayElements,
                    appState: {
                        ...excalidrawAPI.getAppState(),
                    }
                })
            }
        })
        //
        recvMessage(EVENT_CANVAS_DELETE_ELEMENT,(msg,data)=>{
            //删除子笔记-删除画布笔记元素
            this.onDeleteElement(data.data);
        })

        //更新元素的名称
        recvMessage(EVENT_UPDATE_FRAME_NAME,(msg,data)=>{
            excalidrawAPI.getApp().onUpdateElement(data.data.element,{name:data.data.name});
        })

        recvMessage(EVENT_FRAME_POINTER_UP,(msg,data)=>{
            isPointerDownPressed = false;
        })

        recvMessage(EVENT_FRAME_MAKE_COPY,(msg,data)=>{
            this.onMenuClick("duplicate");
            const nTimeoutId = setTimeout(()=>{
                postMessage(EVENT_UPDATE_FRAME_LIST);
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        })

        recvMessage(EVENT_UPDATE_PDF_NAME,(msg,data)=>{
            let newName = data.data.name;
            this.state.mCurrentSelectedElement.customData.generationData.name = this.state.mCurrentSelectedElement.customData.generationData.showName = newName;
        },true);

        recvMessage(EVENT_CARD_CLOSED,(msg,data)=>{
            if (mContextMenuPosition.action == 'note'){
                const note = data.data.data;
                let x,y;
                if (mContextMenuPosition.action == 'note'){
                    x = mContextMenuPosition.x;
                    y = mContextMenuPosition.y;
                }
                this.onInsertNoteData(note,true,mContextMenuPosition.x,mContextMenuPosition.y);
                mContextMenuPosition.action = '';
            }
        },true);

        //更新元素到服务端...
        recvMessage(EVENT_SAVE_TO_SERVER,(msg,data)=>{
            if (isWebApp()){
                var board = {
                    ...this.props.parentOnGetSelectedBoard(),
                    // appState:excalidrawAPI.getAppState()
                }
                if (!board.drawJson.appState){
                    board.drawJson.appState = excalidrawAPI.getAppState();
                }
                var arraySelectElements = [data.data];
                apiUpdateElement(PROJECT_ID,board,arraySelectElements).then(res=>{
                    if (res.code == 0){
                        arraySelectElements.forEach(p=>{
                            mHasSavedElementIds[p.id] = true;
                            mHasNormalUpdateElementIds[p.id] = true;
                        })
                    }
                });
            }
        })

        recvMessage(POST_MESSAGE_RENAME_SUB_NOTENAME,async (msg,data)=>{
            for (let i=0;i<excalidrawAPI.getSceneElements().length;i++){
                const element:any = excalidrawAPI.getSceneElements()[i];
                if (isNoteElement(element)){
                    if (element.customData.generationData.id == data.data.key){
                        const card = await window.methodGetNoteById(data.data.key);
                        if (card){
                            card.name = data.data.name;
                            const szDoc = card.doc;
                            excalidrawAPI.getApp().onUpdateElement(element,{
                                customData:{
                                    generationData:{
                                        status: 'done',
                                        id:data.data.key,
                                        type:'note',
                                        name : data.data.name,
                                        html : createNoteElementByNote(data.data.name,szDoc)
                                    }
                                }
                            })

                            updateCard(card);
                        }

                    }
                }
            }
        })

        recvMessage(EVENT_ONSCROLL_TO_ELEMENT,(msg,data)=>{
            this.onScrollToElement(data.data.elementId);
        })

        recvMessage(EVENT_SHOW_CONTEXT_MENU,async (msg,data)=>{
            const element = data.data;
            this.setState({
                mCurrentSelectedElement:element,
            })
            excalidrawAPI.getApp().setSelectElements(element)
            const arrayNewMenus = await this.onSetContextMenu(element);
            const menuHeight = (arrayNewMenus.filter(p=>p.label != MENU_SEPARATOR).length+1)*menuItemHeight;
            const nTimeoutId = setTimeout(()=>{
                let nWidth = document.body.clientWidth;
                let nHeight = document.body.clientHeight;
                let nLeft = (element.x +  excalidrawAPI.getAppState().scrollX + element.width)*excalidrawAPI.getAppState().zoom.value;
                let nTop = (element.y + excalidrawAPI.getAppState().scrollY + 20)*excalidrawAPI.getAppState().zoom.value;
                if (nLeft + 320 > nWidth){
                    nLeft = nWidth - 320;
                }
                if (nTop + menuHeight > nHeight){
                    nTop = nHeight - menuHeight;
                }
                this.setState({
                    isShowContextMenu:true,
                    contextMenuPosition: {
                        left: nLeft + 'px',
                        top: nTop + 'px'
                    }
                })
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        })

        /**
         * 粘贴deeplink弹窗的菜单 paste as
         * 粘贴deeplink弹窗的菜单 paste as
         * 粘贴deeplink弹窗的菜单 paste as
         * 粘贴deeplink弹窗的菜单 paste as粘贴deeplink弹窗的菜单 paste as
         * 粘贴deeplink弹窗的菜单 paste as
         *
         */
        recvMessage(EVENT_PASTE_DEEP_LINK,(msg,data)=>{
            const element = data.data.element;
            const deeplink = decodeDeeplink(element.originalText);
            if ((deeplink.type == 'project' ||
                deeplink.childType == 'board' ||
                (deeplink.type == 'highlight' && deeplink.childType == 'videoNote') ||
                (deeplink.type == 'library' && deeplink.childType == 'pdfAnno') ||
                deeplink.childType == 'cardAnno' || deeplink.childType == 'card' ||
                (deeplink.type == 'library' && deeplink.childType == 'video') ||
                    (deeplink.type == 'library' && deeplink.childType == 'audio') ||
                    (deeplink.type == 'library' && deeplink.childType == 'pdf') ||
                    (deeplink.type == 'library' && deeplink.childType == 'youtube') ||
                    (deeplink.type == 'library' && deeplink.childType == 'bilibili') ||
                    (deeplink.type == 'library' && deeplink.childType == 'file'))
                && !deeplink.elementType){

                mPasteDeeplinkElement = element;

                const arrayNewMenus = this.getPasteDeepLinkMenuList();
                this.setState({
                    arrayMoreMenus: arrayNewMenus
                })

                const menuHeight = (arrayNewMenus.filter(p=>p.label != MENU_SEPARATOR).length+1)*menuItemHeight;
                let nTimeoutId = setTimeout(()=>{
                    let nWidth = document.body.clientWidth;
                    let nHeight = document.body.clientHeight;
                    let nLeft = (element.x +  excalidrawAPI.getAppState().scrollX /*+ element.width*/)*excalidrawAPI.getAppState().zoom.value;
                    let nTop = (element.y + excalidrawAPI.getAppState().scrollY + 30)*excalidrawAPI.getAppState().zoom.value;
                    if (nLeft + 320 > nWidth){
                        nLeft = nWidth - 320;
                    }
                    if (nTop + menuHeight > nHeight){
                        nTop = nHeight - menuHeight;
                    }
                    this.setState({
                        isShowContextMenu:true,
                        contextMenuPosition: {
                            left: nLeft + 'px',
                            top: nTop + 'px'
                        }
                    })
                },100);
                this.mArrayTimeoutIds.push(nTimeoutId);
            }
        })

        /**
         * 粘贴链接...
         */
        recvMessage(EVENT_PASTE_URL,(msg,data)=>{
            const arrayElements = data.data.elements;
            const element = arrayElements[0];
            const arrayNewMenus = this.getPastUrlMenuList();
            this.setState({
                arrayMoreMenus: arrayNewMenus,
                mCurrentSelectedElement:element
            })
            const menuHeight = (arrayNewMenus.filter(p=>p.label != MENU_SEPARATOR).length+1)*menuItemHeight;
            const nTimeoutId = setTimeout(()=>{
                let nWidth = document.body.clientWidth;
                let nHeight = document.body.clientHeight;
                let nLeft = (element.x +  excalidrawAPI.getAppState().scrollX /*+ element.width*/)*excalidrawAPI.getAppState().zoom.value;
                let nTop = (element.y + excalidrawAPI.getAppState().scrollY + 30)*excalidrawAPI.getAppState().zoom.value;
                if (nLeft + 320 > nWidth){
                    nLeft = nWidth - 320;
                }
                if (nTop + menuHeight > nHeight){
                    nTop = nHeight - menuHeight;
                }
                this.setState({
                    isShowContextMenu:true,
                    contextMenuPosition: {
                        left: nLeft + 'px',
                        top: nTop + 'px'
                    }
                })
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        })

        /**
         * 粘贴mindmap//plainttext...
         */
        recvMessage(EVENT_PASTE_MINDMAP_PLAINT_TEXT,(msg,data)=>{
            const arrayNewMenus = this.getPasteMindmapPlainTextMenuList();
            this.setState({
                arrayMoreMenus: arrayNewMenus,
            })
            const menuHeight = (arrayNewMenus.filter(p=>p.label != MENU_SEPARATOR).length+1)*menuItemHeight;
            const nTimeoutId = setTimeout(()=>{
                let nWidth = document.body.clientWidth;
                let nHeight = document.body.clientHeight;
                let nLeft = data.data.sceneX;//(element.x +  excalidrawAPI.getAppState().scrollX /*+ element.width*/)*excalidrawAPI.getAppState().zoom.value;
                let nTop = data.data.sceneY;//(element.y + excalidrawAPI.getAppState().scrollY + 30)*excalidrawAPI.getAppState().zoom.value;
                if (nLeft + 320 > nWidth){
                    nLeft = nWidth - 320;
                }
                if (nTop + menuHeight > nHeight){
                    nTop = nHeight - menuHeight;
                }
                this.setState({
                    isShowContextMenu:true,
                    contextMenuPosition: {
                        left: nLeft + 'px',
                        top: nTop + 'px'
                    }
                })
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        })

        recvMessage(EVENT_SHOW_SNAP_LINE,(msg,data)=>{
            excalidrawAPI.updateScene({
                appState: {
                    ...excalidrawAPI.getAppState(),
                    showSnapLines: localStorage.getItem(KEY_GLOBAL_SNAP_LINE_VISIBLE) !== 'invisible'
                }
            })

        })

        /**
         * 隐藏菜单
         */
        recvMessage(EVENT_HIDDEN_FLOAT_MENU,(msg,data)=>{
            this.hidePopupMenu();
        })

        recvMessage(EVENT_UPDATE_ELEMENT_BOUND,(msg,data)=>{
            excalidrawAPI.getApp().updateBoundElements(data.data.element);
        })

        window.hiddenCanvasFloatMenu = ()=>{
            this.hidePopupMenu();
        }
        window.showCanvasFolatMenu = ()=>{
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectedElements.length > 0){
                this.onUpdateMenuPosition(arraySelectedElements[0],null,null)
                this.setState({
                    isShowMenu:true,
                })
            }
        }
    }

    componentWillUnmount() {
        unSubscribe(EVENT_ELEMENT_DELETE);
        unSubscribe(EVENT_DELETE_ELEMENT);
        unSubscribe(EVENT_DELETE_ELEMENT_BY_ID);
        unSubscribe(EVENT_UPDATE_FRAME_SORT);
        unSubscribe(EVENT_UPDATE_ELEMENT_HAS_UPDATE);
        unSubscribe(EVENT_CANVAS_COPY_ADD_IFRAME);
        unSubscribe(EVENT_CANVAS_DELETE_ELEMENT);
        unSubscribe(EVENT_UPDATE_FRAME_NAME);
        unSubscribe(EVENT_FRAME_POINTER_UP);
        unSubscribe(EVENT_FRAME_MAKE_COPY);
        unSubscribe(EVENT_UPDATE_PDF_NAME);
        unSubscribe(EVENT_CARD_CLOSED);
        unSubscribe(EVENT_CANVAS_COPY_ADD_IFRAME);
        unSubscribe(EVENT_SAVE_TO_SERVER);
        unSubscribe(POST_MESSAGE_RENAME_SUB_NOTENAME);
        unSubscribe(EVENT_ONSCROLL_TO_ELEMENT);
        unSubscribe(EVENT_SHOW_CONTEXT_MENU);
        unSubscribe(EVENT_ELEMENT_DELETE);
        unSubscribe(EVENT_PASTE_DEEP_LINK);
        unSubscribe(EVENT_PASTE_URL);
        unSubscribe(EVENT_SHOW_SNAP_LINE);
        unSubscribe(EVENT_HIDDEN_FLOAT_MENU);
        unSubscribe(EVENT_UPDATE_ELEMENT_BOUND);

        excalidrawAPI = null;
        dialogWordCountRef = null;

        /**
         * 已经更新过的draw,text....
         */
        mHasSavedElementIds = {};
        /**
         * 橡皮擦已经删除过的元素
         */
        mHasDeletedElementIds = {};

        /**
         * 正常更新过的元素。
         */
        mHasNormalUpdateElementIds = {};

//上次的更新时间
        mLastUpdateTime = 0;

//当前打开的pdf的注记...信息
        mOpenPdfData = null;
//当前粘贴的deeplink链接，可以转换成embed....
        mPasteDeeplinkElement = null;

        this.mArrayTimeoutIds.forEach(p=>{
            clearTimeout(p);
        })
        this.mArrayTimeoutIds.length = 0;

        // delete window.onRemoveImage;
        delete window.hiddenCanvasFloatMenu;
    }


    //获取焦点。。。。HOW
    onAutoFocus = () => {

    }

    onFocus = ()=>{
        excalidrawAPI?.getApp().focusContainer();
    }

    newProject = () => {
        isCanvasReadonly = false;
        excalidrawAPI.resetScene();
        this.setState({
            isReadOnlyStatus: false,
            isShowGridMode: true
        })
        excalidrawAPI.updateScene({
            appState: {
                ...excalidrawAPI.getAppState(),
                theme:isDarkMode()?'dark':'light',
                gridSize: null,
                zoom:{value:1}
            }
        })
    }

    onUpdateTheme = ()=>{
        excalidrawAPI.updateScene({
            appState: {
                ...excalidrawAPI.getAppState(),
                theme:isDarkMode()?'dark':'light',
            }
        })
        //刷新所有的mindmap....
        excalidrawAPI.getApp()?.refreshMindmap();
    }

    initFirstBlankProject = ()=>{
        excalidrawAPI.updateScene({
            appState:{
                ...excalidrawAPI.getAppState(),
                gridModeEnabled:true,
                gridSize:DEFAULT_GRID_SIZE
            }
        })
    }

    onCloseContextMenu = ()=>{
        this.setState({
            isShowMenu:false,
            isShowMoreMenu:false,
            isShowContextMenu:false,
            isShowFileNoExistMenu:false
        })
    }

    onSetReadonlyStatus = (isReadOnly: boolean) => {
        // console.log('isreadonlystatus:'+isReadOnly);
        isCanvasReadonly = isReadOnly;
        this.setState({
            isReadOnlyStatus: isReadOnly,
            isShowMenu:false,
            isShowMoreMenu:false,
            isShowContextMenu:false,
            isShowFileNoExistMenu:false
        })

        Global.g_isPresentMode = isReadOnly;
        if (isReadOnly){
            if (isStringNullOrEmpty(mCurrentActiveTool)){
                mCurrentActiveTool = this.getAppState()?.activeTool?.type as string;
            }
            this.onSetActiveTool("hand");
        }

        const nTimeoutId = setTimeout(()=>{
            excalidrawAPI?.updateScene({
                appState:{
                    ...excalidrawAPI.getAppState(),
                    viewModeEnabled:isCanvasReadonly,
                    objectsSnapModeEnabled:(isCanvasReadonly?false:true),
                    extra:{isPresentMode:isReadOnly},
                    cardEditMenu:{
                        ...excalidrawAPI.getAppState().cardEditMenu,
                        visibility:false
                    }
                }
            })
        },100);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    onRestoreActiveTool = ()=>{
        const nTimeoutId = setTimeout(()=>{
            if (!isStringNullOrEmpty(mCurrentActiveTool)){
                this.onSetActiveTool(mCurrentActiveTool);
            }
            mCurrentActiveTool = '';
        },1000);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    getExcalidrawApi = ()=>{
        return excalidrawAPI;
    }

    /**
     * 是否是婵模式
     */
    isZenMode = ()=>{
        return excalidrawAPI?.getAppState().zenModeEnabled;
    }

    setProjectId = (szProjectId)=>{
        this.setState({
            projectId:szProjectId
        })
    }

    hidePopupMenu = ()=>{
        this.setState({
            isShowMenu:false,
            isShowContextMenu:false,
            isShowPopoverMoreMenu:false,
            isShowMoreMenu:false,
            isShowFileNoExistMenu:false
        })
    }

    hiddenMenu = ()=>{
        this.hidePopupMenu();
    }

    showTextElementPopupMenu = ()=>{
        if (!this.state.isShowMenu){
            this.setState({
                mCurrentSelectedElement:excalidrawAPI.getAppState().editingElement,
                // isShowMenu:true,
                arrayMoreMenus:this.getTextMenuList(this.state.mCurrentSelectedElement)
            })
            const nTimeoutId = setTimeout(()=>{
                this.onUpdateMenuPosition(excalidrawAPI.getAppState().editingElement);
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        }
    }

    /**
     * 正常更新元素的id集合...
     */
    getNormalUpdateElementIds = ()=>{
        return mHasNormalUpdateElementIds;
    }

    setUpdateElementId = (szId:string)=>{
        mHasNormalUpdateElementIds[szId] = true;
    }


    /**
     * 菜单是否折叠
     * @param isCollapse
     */
    setLeftMenuIsCollapse = (isCollapse:boolean)=>{
        mIsLeftMenuCollapse = isCollapse;
        excalidrawAPI.updateScene({
            appState:{
                leftMenuWidth: isCollapse?0:LEFT_MENU_WIDTH
            }
        })
    }

    /**
     * 插入链接......
     * @param linkInfo
     */
    onUpdateLink = (linkInfo)=>{
        let szLinkInfo = linkInfo;
        if (isJson(linkInfo)){
            szLinkInfo = JSON.stringify(linkInfo);
        }
        const arraySelectedIds:any = excalidrawAPI.getAppState().selectedElementIds;
        if(arraySelectedIds.length === 0)return;
        var arrayElements = [...excalidrawAPI.getSceneElements()];
        const element = arrayElements.find(p=>arraySelectedIds[p.id] != undefined);
        if (element){
            if (isEmbedableBookmarkElement(element)){
                //没法更新---删除重新搞一个。
                const newElement = {...element,id:crypto.randomUUID(),link:szLinkInfo};
                let nIndex = arrayElements.indexOf(element);
                arrayElements.splice(nIndex,1,newElement);
                excalidrawAPI.updateScene({
                    elements:arrayElements
                })

                setTimeout(()=>{
                    const node = document.getElementById(`${newElement.id}-card`)!;
                    if (node){
                        cardLink([node],newElement);
                    }
                },100)
            }else{
                mutateElement(element,{link:szLinkInfo});
            }
        }

        // for(var i=0;i<arrayElements.length;i++) {
        //     var ele = arrayElements[i];
        //     if (arraySelectedIds[ele.id] != undefined) {
        //         arrayElements[i] = {
        //             ...ele,
        //             link:szLinkInfo
        //         }
        //         break;
        //     }
        // }
        //
        // excalidrawAPI.updateScene({
        //     elements:arrayElements
        // })
    }

    /**
     * 更新card
     * @param card
     */
    onUpdateCardElement = (card:any)=>{
        const element = excalidrawAPI.getSceneElements().find(p=>p.customData?.generationData?.id == card.id);
        if (element){
            const customData:any = {...element.customData};
            customData.generationData = {...element.customData?.generationData || {}};
            customData.generationData.name = card.name;
            customData.generationData.html = card.doc;
            excalidrawAPI.getApp().onUpdateElement(element,{
                customData:customData
            })
        }
    }

    /**
     * 取当前选中的元素....
     */
    onGetCurrentSelectedElement = ()=>{
        const arraySelectedIds = excalidrawAPI.getAppState().selectedElementIds;
        if(Object.keys(arraySelectedIds).length == 0)return;
        var arrayElements = excalidrawAPI.getSceneElements();
        for(var i=0;i<arrayElements.length;i++) {
            var ele = arrayElements[i];
            if (arraySelectedIds[ele.id] != undefined) {
                return ele;
            }
        }
        return undefined;
    }

    onGetAllElements = ()=>{
        return excalidrawAPI.getSceneElements();
    }

    onUpdateAppStates = (updates:any)=>{
        return excalidrawAPI.getApp().setState({
            ...updates
        })
    }

    onScrollToElementNoDelay = (szElementId:any,nodeId:any=null,offsetX:any=0)=>{
        var arrayElements = excalidrawAPI.getSceneElements();
        const item = arrayElements.find(p=>p.id == szElementId);

        if (item){
            let opts = {animate:false,offsetX:0,fitToContent:false,isTopLeft:false};
            if (isFrameElement(item)){
                opts.offsetX = offsetX;
                opts.isTopLeft = true;
            }
            const appState = excalidrawAPI.getAppState();
            //选中
            if (global.g_selectElementIds?.length > 0){
                // 将数组转换为 {[id]: true} 格式的对象
                const selectedElementIds = global.g_selectElementIds.reduce((acc, id) => {
                    acc[id] = true;
                    return acc;
                }, {});
                excalidrawAPI.updateScene({
                    appState:{
                        ...appState,
                        selectedElementIds:selectedElementIds,
                    }
                })
                global.g_selectElementIds = [];
            }else{
                excalidrawAPI.updateScene({
                    appState:{
                        ...appState,
                        selectedElementIds:{[szElementId]:true}
                    }
                })
            }

            excalidrawAPI.scrollToContent(item,opts);
        }


        if (nodeId){
            const currentMindMap = mindMapCache.get(szElementId);
            // @ts-ignore
            const node = currentMindMap.renderer.findNodeByUid(nodeId);
            node?.active();
        }
    }

    /**
     * 滚动到一个元素
     * @param element
     */
    onScrollToElement = (szElementId:any,nodeId:any=null,offsetX:any=0,nDelay:any)=>{
        let nDelayTime = 100;
        if (nodeId){
            nDelayTime = 800;
        }
        if (nDelay){
            nDelayTime = nDelay;
        }
        let nTimeoutId = setTimeout(()=>{
            this.onScrollToElementNoDelay(szElementId,nodeId,offsetX);
        },nDelayTime)
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    /**
     * 滚动到元素
     * @param ele
     */
    onScrollToElementFromElement = (ele)=>{
        const appState = excalidrawAPI.getAppState();
        excalidrawAPI.updateScene({
            appState:{
                ...appState,
                selectedElementIds:{[ele.id]:true}
            }
        })
        excalidrawAPI.scrollToContent(ele);
    }

    /**
     * 滚动到元素
     * @param ele
     */
    onScrollToElementNoSelected = (ele)=>{
        excalidrawAPI.scrollToContent(ele);
    }

    /**
     * 删除元素
     * @param szElementId
     */
    onDeleteElement = (szElementId:any)=>{
        var arrayElements = excalidrawAPI.getSceneElements().filter(p=>p.id != szElementId && p.customData?.generationData?.id != szElementId);
        excalidrawAPI.updateScene({
            elements:arrayElements
        })
    }

    /**
     * 直接从库里面也删除
     * @param szElementId
     */
    onDeleteElementFromLibrary = (szElementId:any)=>{
        excalidrawAPI.getApp().setSelectElementsById(szElementId,()=>{
            this.onMenuClick('deleteFromLibrary')
        })
    }

    onSetActiveTool = (type: any) => {
        excalidrawAPI.getApp().setActiveTool(
            {
                type: type,
                insertOnCanvasDirectly: false,
            }
        )
        // var defaultColor = "#000000";
        // var stokeWidth = 1;
        // if (type === 'highlighter'){
        //     defaultColor = "#ffff00";
        //     stokeWidth = 5;
        // }
        // excalidrawAPI.updateScene({
        //     appState:{
        //         currentItemStrokeColor: defaultColor,
        //         currentItemStrokeWidth:stokeWidth
        //     }
        // })
        if (type === 'freedraw'){
            if(excalidrawAPI.getAppState().currentItemStrokeColor.toLowerCase() === 'transparent'){
                excalidrawAPI.updateScene({
                    appState:{
                        currentItemStrokeColor: '#000000',
                    }
                })
            }
        }else if (type === 'rectangle' || type === 'roundedRectangle' ||  type === 'ellipse'  ||
            type === 'triangle' ||  type === 'diamond' ||  type === 'bubble' ||  type === 'parallelogram' ||  type === 'pentagram' || type === 'thickArrow'){
            if(excalidrawAPI.getAppState().currentItemStrokeColor.toLowerCase() === 'transparent'){
                excalidrawAPI.updateScene({
                    appState:{
                        currentItemStrokeColor: '#CECECE',
                        currentItemStrokeWidth: 1
                    }
                })
            }
        }else if(type === 'line' || type === 'arrow'){
            if(excalidrawAPI.getAppState().currentItemStrokeColor.toLowerCase() === 'transparent'){

            }

            excalidrawAPI.updateScene({
                appState:{
                    currentItemStrokeColor: '#000000',
                    currentItemStrokeWidth: 1
                }
            })
        }
    }

    /**
     * 当前激活的工具
     */
    onGetActiveTool = ()=>{
        return excalidrawAPI?.getAppState().activeTool.type;
    }


    /**
     * 插入图标元素
     * @param szImgPath
     */
    onInsertElementIcon = (szImgPath)=>{
        var element = {
            type: "image",
            version: 1,
            isDeleted: false,
            id: generateUUID2(),
            fileId:generateUUID2(),
            strokeWidth: 1,
            strokeStyle: "none",
            roughness:0,
            opacity: 100,
            angle: 0,
            groupIds:[],
            x: 100.50390625,
            y: 93.67578125,
            strokeColor: "transparent",
            backgroundColor: 'transparent',
            fillStyle:'solid',
            width: 80,
            height: 80,
            isLockRatio: true,
            locked:false,
            hasUpdate:true,
            extra:{svg:true}
        }
        excalidrawAPI.getApp().insertSVGIcon(element,szImgPath);

        // this.onAddImageFiles(element,imgPathPerfix()+szImgPath);
        // let arrayElements:any = [...excalidrawAPI.getSceneElements()];
        // arrayElements.push(element);
        // excalidrawAPI.updateScene({
        //     elements:arrayElements,
        //     appState: {
        //         ...excalidrawAPI.getAppState(),
        //     }
        // })
    }

    onAddImageFiles = async (ele,filePath)=>{
        const base64 = await imgToBase64(filePath);
        const date = new Date();
        var item = {
            mimeType: IMAGE_MIME_TYPES.svg,
            id: ele.fileId,
            dataURL: base64,
            created: date ,
            lastRetrieved: date
        }
        var arrayFuckEx = [];
        arrayFuckEx.push(item);
        excalidrawAPI.addFiles(arrayFuckEx);
    }

    /**
     * 设置背景色
     * @param szHexColor
     */
    onSetBackground = (szHexColor: string) => {
        const appState = excalidrawAPI.getAppState();
        excalidrawAPI.updateScene({
            appState: {
                ...appState,
                viewBackgroundColor: szHexColor
            }
        })
    }

    /**
     * 设置pagesize
     * @param pageSizeValues
     */
    onSetPageSize = (pageSizeValues: PageSizeValues) => {
        const appState = excalidrawAPI.getAppState();
        excalidrawAPI.updateScene({
            appState: {
                ...appState,
                pageSizeValues,
            },
        });
    };

    /**
     * 设置展示模式
     * @param displayMode
     */
    onSetDisplayMode = (displayMode: DisplayMode) => {
        return excalidrawAPI.updateDisplayMode(displayMode);
    };

    onUpdateDisplaySize = (isFullScreen,nLeftOffset=0)=>{
        excalidrawAPI.getApp().updateDisplaySize(isFullScreen,nLeftOffset);
    }

    /**
     * 设置frameSize
     * @param pageSizeValues
     */
    onSetFrameSize = (frameSize: FrameSize) => {
        const appState = excalidrawAPI.getAppState();
        excalidrawAPI.updateScene({
            appState: {
                ...appState,
                currentFrameSize: frameSize,
            },
        });
    };

    onUpdateDisplayMode = () => {
        this.props.setDisplayMode("edit");
    };

    /**
     * 页面大小
     */
    onGetPageSize = ()=> {
        return excalidrawAPI?.getAppState().pageSizeValues;
    }


    getAppState = ()=>{
        return excalidrawAPI?.getAppState();
    }

    getApp = ()=>{
        return excalidrawAPI?.getApp();
    }

    getTextMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const DEFAULT_TEXT_MORE_MENU = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:'convertToCard', icon:'context_menu_card.png',showIcon:true,  label:i18n.t("Convert to New Card")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'copyText', icon:'menu_copy.png', label:i18n.t("Copy text to clipboard")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            {id:'wordCount', icon:'menu_word_count.png', label:i18n.t("Word count")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return DEFAULT_TEXT_MORE_MENU;
    }

    getImageMenuList = async (ele)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (ele?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const DEFAULT_IMAGE_MORE_MENU = [
            // {id:"showName", icon:'menu_crop.png', label:this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName?i18n.t("Hide title"):i18n.t("Show title")},
            {id:"apperAndStyle", icon:'menu_appera_style.svg',showIcon:true, label:i18n.t("ApperanceAndStyle"),children:[
                    {id:'border_color', icon:'menu_border_color.svg',showIcon:true, label:i18n.t("Border color")},
                    {id:'border_style', icon:'menu_border_style.svg',showIcon:true, label:i18n.t("Border style")},
                    {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                    {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                ]},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy', icon:'menu_copy.svg',showIcon:true,  label:i18n.t("Copy")},
            {id:"duplicate", icon:'menu_duplicate.svg',showIcon:true,  label:i18n.t("Duplicate")},
            {id:'delete', icon:'menu_remove.svg',showIcon:true,  label:i18n.t("Remove")},

            // {id:"crop", icon:'menu_crop.png', label:i18n.t("Crop")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'add_to_library', icon:'menu_add_to_library.png',showIcon:true, label:i18n.t("Add to library")},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},

            {id:'copy_to_clipboard', icon:'menu_copy_as_png.svg', showIcon:true,label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
            {id:'download', icon:'menu_download.svg', showIcon:true,label:i18n.t("Download as png")},
            {id:'ocr', icon:'menu_ocr.svg',showIcon:true, label:i18n.t("OCR")},
            // {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},


            // {id:'group', icon:'menu_group.png', label:i18n.t("Group")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'moreOptions', icon:'menu_more_options.svg',showIcon:true,  label:i18n.t("MoreOptions"),children:[
                    {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                    {id:'replace', icon:'menu_replace.svg',showIcon:true, label:i18n.t("Replace")},
                    {id:'flip_horizontal', icon:'menu_filp_horizontal.svg',showIcon:true, label:i18n.t("Flip horizontal")},
                    {id:'flip_vertical', icon:'menu_filp_vertical.svg',showIcon:true, label:i18n.t("Flip vertical")},
                ]},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        const deleteFromLibrary = {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")};

        let hasInLibrary = false;
        if (ele.customData?.generationData?.id){
            const library = await getCardById(ele.customData?.generationData?.id);
            if (library?.isDeleted == 0){
                hasInLibrary = true;
                DEFAULT_IMAGE_MORE_MENU.splice(6,0,deleteFromLibrary);
                //删除添加到库..
                const nAddToLibIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'add_to_library');
                if (nAddToLibIndex != -1) {
                    DEFAULT_IMAGE_MORE_MENU.splice(nAddToLibIndex, 1);
                }
            }
        }
        if (!hasInLibrary){
            //删除copyOriginLink
            let nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'copyOriginLink');
            if (nIndex != -1) {
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex, 1);
            }

            //删除managerTag
            nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'manageTags');
            if (nIndex != -1) {
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex, 1);
            }

            //删除addToProject
            nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'addToProject');
            if (nIndex != -1){
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex,1);
            }

        }
        const files = excalidrawAPI.getFiles();
        const file = files[ele.fileId];
        if (file?.mimeType == MIME_TYPES.gif){
            let nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'crop');
            if (nIndex != -1){
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex,1);
            }

            nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'copy_to_svg');
            if (nIndex != -1) {
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex, 1);
            }

            nIndex = DEFAULT_IMAGE_MORE_MENU.findIndex(p=>p.id == 'ocr');
            if (nIndex != -1) {
                DEFAULT_IMAGE_MORE_MENU.splice(nIndex, 1);
            }
        }
        return DEFAULT_IMAGE_MORE_MENU;
    }

    getShapeMenuList = ()=>{
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
            {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:'flip_horizontal', icon:'menu_flip_horizontal.png', label:i18n.t("Flip horizontal")},
            // {id:'flip_vertical', icon:'menu_flip_vertical.png', label:i18n.t("Flip vertical")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getFreedrawMenuList = ()=>{
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
            {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:'flip_horizontal', icon:'menu_flip_horizontal.png', label:i18n.t("Flip horizontal")},
            // {id:'flip_vertical', icon:'menu_flip_vertical.png', label:i18n.t("Flip vertical")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getLinearlineMenuList = ()=>{
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
            {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:'flip_horizontal', icon:'menu_flip_horizontal.png', label:i18n.t("Flip horizontal")},
            // {id:'flip_vertical', icon:'menu_flip_vertical.png', label:i18n.t("Flip vertical")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},

            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getIFrameMenuList = (element)=>{
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
            // {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")}
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getMindmapMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getFrameMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const menu = [
            {id:"rename", icon:'menu_rename_1.png', showIcon:true,label:i18n.t("Rename")},
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
            {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            {id:'selectAllElementsInFrame', icon:'menu_select_all_frame.png', label:i18n.t("Select all elements in frame")},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            // {id:'changeBackgroundImage', icon:'menu_group.png', label:i18n.t("Change background image")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getPdfAnnoTextMenuList = ()=>{
        const menu = [
            {id:"open", icon:'menu_locate.png',showIcon:true, label:i18n.t("Locate")},
            {id:"changePdfSource", icon:'menu_change_source_1.png',showIcon:true, label:i18n.t("Change source")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            {id:'copyText', icon:'menu_link.png', label:i18n.t("Copy text")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Remove")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as svg")},
            // {id:'download_as_png', icon:'copy_to_clipboard.png', label:i18n.t("Download as png")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getCardAnnoTextMenuList = ()=>{
        const menu = [
            {id:"open", icon:'menu_locate.png',showIcon:true, label:i18n.t("Locate")},
            // {id:"changePdfSource", icon:'menu_change_source_1.png',showIcon:true, label:i18n.t("Change source")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            {id:'copyText', icon:'menu_link.png', label:i18n.t("Copy text")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Remove")},
            {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as svg")},
            // {id:'download_as_png', icon:'copy_to_clipboard.png', label:i18n.t("Download as png")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getVideoAnnoTextMenuList = ()=>{
        const menu = [
            {id:"open", icon:'menu_locate.png',showIcon:true, label:i18n.t("Locate")},
            {id:"changePdfSource", icon:'menu_change_source_1.png',showIcon:true, label:i18n.t("Change source")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            // {id:'copyText', icon:'menu_link.png', label:i18n.t("Copy to clipboard")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Remove")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as svg")},
            // {id:'download_as_png', icon:'copy_to_clipboard.png', label:i18n.t("Download as png")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getAudioAnnoTextMenuList = ()=>{
        const menu = [
            {id:"open", icon:'menu_locate.png',showIcon:true, label:i18n.t("Locate")},
            {id:"changePdfSource", icon:'menu_change_source_1.png',showIcon:true, label:i18n.t("Change source")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            // {id:'copyText', icon:'menu_link.png', label:i18n.t("Copy to clipboard")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'copy_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as svg")},
            // {id:'download_as_png', icon:'copy_to_clipboard.png', label:i18n.t("Download as png")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getPdfAnnoImageMenuList = ()=>{
        const menu = [
            {id:"open", icon:'menu_locate.png',showIcon:true, label:i18n.t("Locate")},
            {id:"changePdfSource", icon:'menu_change_source_1.png',showIcon:true, label:i18n.t("Change source")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},

            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copy_pdfanno_to_clipboard', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as png")},
            {id:'copy_pdfanno_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as svg")},
            {id:'download_pdfanno_as_png', icon:'copy_to_clipboard.png', label:i18n.t("Download as png")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getVideoMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const menu = [
            {id:'openVideoInSide', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
            {id:"openVideoInPopup", icon:'menu_open_in_popup_1.png',showIcon:true, label:i18n.t("Open in popup")},
            {id:'openVideoInFullScreen', icon:'menu_open_in_fullscreen_1.png',showIcon:true,  label:i18n.t("Open in fullscreen")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:'true', label:i18n.t("Show info")},
            {id:'delete', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Remove")},
            {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},

            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        if (!isLiveVideoElement(element)){
            menu.push({id:generateUUID2(), icon:'', label: MENU_SEPARATOR});
            menu.push({id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")});
        }
        return menu;
    }

    getSticknotesMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete")},
            {id:'convertToCard', icon:'context_menu_card.png',showIcon:true,  label:i18n.t("Convert to New Card")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'color', icon:'menu_fold.png',showIcon:false,  label:i18n.t("Color"),type:'stickyNote'},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getEmbedMenuList = async (ele)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (ele?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }

        let mmm = {id:"switchToBookmarkMode", icon:'menu_duplicate.png', label:i18n.t("TurnToBookmarkMode")};
        if (isEmbedableBookmarkElement(ele)){
            mmm =  {id:"switchToEmbedMode", icon:'menu_duplicate.png', label:i18n.t("TurnToEmbedMode")};
        }

        const menu = [
            mmm,
            {id:"add_to_library", icon:'menu_add_to_library.png',showIcon:true, label:i18n.t("Add to library")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
        ]

        let isInLibrary = false;
        if (ele.customData?.generationData?.id) {
            const library = await getCardById(ele.customData?.generationData?.id);
            if (library && library?.isDeleted == 0) {
                isInLibrary = true;
            }
        }
        //在不在都显示info
        const showInfo = {id:'showInfo', icon:'menu_show_info_1.png',showIcon:'true', label:i18n.t("Show info")};
        menu.push(showInfo);

        const menuDelete = {id:'delete', icon:'menu_delete.png', label:i18n.t("Remove")};
        menu.push(menuDelete);

        if (this.state.mCurrentSelectedElement?.embedType != 'text'){
            const nIndex = menu.findIndex(p=>p.id == 'add_to_library');
            menu.splice(nIndex,1);//不是书签，删除第一个
        }
        if (isInLibrary){
            const deleteFromLibrary = {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")};
            menu.push(deleteFromLibrary);
            //删除add to library
            const nAddToLibIndex = menu.findIndex(p=>p.id == 'add_to_library');
            if (nAddToLibIndex != -1){
                menu.splice(nAddToLibIndex,1);
            }
        }
        const more = [
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyOriginLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            // {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        menu.push(...more);

        return menu;
    }

    getDefaultMenuList = ()=>{
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getMultilpyMenuList = ()=>{
        const arrayElements = excalidrawAPI.getApp().getSelectedElements();
        const nCardCount:any = arrayElements.filter(p=>isNoteElement(p) || isArrowElement(p)).length;//卡片中的箭头忽略....
        const nImageCount:any = arrayElements.filter(p=>isImageElement(p)).length;
        const hasPdfAnno = arrayElements.some(p=>isPdfAnnoElement(p));
        const hasVideoAnno = arrayElements.some(p=>isVideoAnnoElement(p));
        const hasAudioAnno = arrayElements.some(p=>isAudioAnnoElement(p));
        const nStickCount:any = arrayElements.filter(p=>isStickyNotesElement(p) || isArrowElement(p)).length;
        // const hasJournal = arrayElements.some(p=>isJournalElement(p))
        if (nCardCount == arrayElements.length){
            //全部是card
            const menu = [
                (arrayElements[0]?.customData?.generationData?.isExpand == true)?{id:'fold', icon:'menu_fold.png',showIcon:true,  label:i18n.t("Fold")}:{id:'unfold', icon:'menu_fold.png',showIcon:true,  label:i18n.t("Unfold")},
                {id:'color', icon:'menu_fold.png',showIcon:false,  label:i18n.t("Color")},
                {id:'sep_1', icon:'', label: MENU_SEPARATOR},
                {id:'exportPdf', icon:'menu_export_pdf_1.png',showIcon:true,  label:i18n.t("ExportPDF")},
                {id:'exportMarkdown', icon:'menu_export_pdf_1.png',showIcon:true,  label:i18n.t("ExportMarkdown")},
                {id:'sep_2', icon:'', label: MENU_SEPARATOR},

                {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
                {id:'delete', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Remove")},
                {id:'sep_3', icon:'', label: MENU_SEPARATOR},

                (this.state.mCurrentSelectedElement?.customData?.generationData?.isHidden == 1)? {id:'visibleFromLibrary', icon:'contextmenu_make_visible_from_library.png',showIcon:true, label:i18n.t("Make visible in library")}:{id:'hideFromLibrary', icon:'contextmenu_hidden_from_library.png',showIcon:true, label:i18n.t("Hide from library")},
                {id:'deleteFromLibrary', icon:'context_menu_delete.png', showIcon:true, label:i18n.t("Delete from library")},
                {id:'sep_4', icon:'', label: MENU_SEPARATOR},

                // {id:'border_color', icon:'',showIcon:false, label:i18n.t("Border color")},
                // {id:'border_style', icon:'',showIcon:false, label:i18n.t("Border style")},
                // {id:'opacity', icon:'menu_opacity.png',showIcon:true, label:i18n.t("Opacity")},
                {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("PositionAndSize")},
                {id:'sep_5', icon:'', label: MENU_SEPARATOR},
                {id:'manageTags', icon:'menu_position.png',label:i18n.t("Manage tags")},
                {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
                {id:'sep_6', icon:'', label: MENU_SEPARATOR},
                {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
                {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
                {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            ]
            return menu;
        }
        if (nStickCount == arrayElements.length){
            //全是sticknotes
            const menu = [
                {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
                // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
                {id:'delete', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete")},
                {id:'convertToCard', icon:'context_menu_card.png',showIcon:true,  label:i18n.t("Convert to New Card")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'color', icon:'menu_fold.png',showIcon:false,  label:i18n.t("Color")},
                {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'copyLink', icon:'menu_position.png',label:i18n.t("Copy link")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
                {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
                {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            ]
            return menu;
        }
        if (nImageCount == arrayElements.length){
            let hasAllInLibrary = arrayElements.every(p=>p.customData?.generationData?.id);
            //全部是图片
            const DEFAULT_IMAGE_MORE_MENU = [
                {id:"apperAndStyle", icon:'menu_appera_style.svg',showIcon:true, label:i18n.t("ApperanceAndStyle"),children:[
                        {id:'border_color', icon:'menu_border_color.svg',showIcon:true, label:i18n.t("Border color")},
                        {id:'border_style', icon:'menu_border_style.svg',showIcon:true, label:i18n.t("Border style")},
                        {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                        // {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                    ]},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                // {id:'copy', icon:'menu_copy.svg',showIcon:true,  label:i18n.t("Copy")},
                {id:"duplicate", icon:'menu_duplicate.svg',showIcon:true,  label:i18n.t("Duplicate")},
                {id:'delete', icon:'menu_remove.svg',showIcon:true,  label:i18n.t("Remove")},

                // {id:"crop", icon:'menu_crop.png', label:i18n.t("Crop")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                // {id:'add_to_library', icon:'menu_add_to_library.png',showIcon:true, label:i18n.t("Add to library")},
                // {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
                // {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},

            ]
            if (!hasAllInLibrary){
                DEFAULT_IMAGE_MORE_MENU.push(
                    {id:'add_to_library', icon:'menu_add_to_library.png',showIcon:true, label:i18n.t("Add to library")},
                )
            }
            DEFAULT_IMAGE_MORE_MENU.push(
                {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
                {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
                // {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
                // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
                // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},

                // {id:'copy_to_clipboard', icon:'menu_copy_as_png.svg', showIcon:true,label:i18n.t("Copy to clipboard as png")},
                // {id:'copy_to_svg', icon:'copy_to_clipboard.png', label:i18n.t("Copy to clipboard as SVG")},
                // {id:'download', icon:'menu_download.svg', showIcon:true,label:i18n.t("Download as png")},
                // {id:'ocr', icon:'menu_ocr.svg',showIcon:true, label:i18n.t("OCR")},
                // {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},


                // {id:'group', icon:'menu_group.png', label:i18n.t("Group")},

                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'moreOptions', icon:'menu_more_options.svg',showIcon:true,  label:i18n.t("MoreOptions"),children:[
                        // {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                        // {id:'replace', icon:'menu_replace.svg',showIcon:true, label:i18n.t("Replace")},
                        {id:'flip_horizontal', icon:'menu_filp_horizontal.svg',showIcon:true, label:i18n.t("Flip horizontal")},
                        {id:'flip_vertical', icon:'menu_filp_vertical.svg',showIcon:true, label:i18n.t("Flip vertical")},
                    ]},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
                {id:'layer', icon:'menu_layer_1.png',showIcon:true,  label:i18n.t("Layer")},
            )
            return DEFAULT_IMAGE_MORE_MENU;
        }
        const menu = [
            {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},
            {id:'delete', icon:'menu_delete.png', label:i18n.t("Delete")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
            // {id:'position', icon:'menu_position.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png', showIcon:true, label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'layer', icon:'menu_layer.png',showIcon:true,  label:i18n.t("Layer")},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        if ((hasPdfAnno && hasVideoAnno) || (hasPdfAnno && hasAudioAnno) || (hasVideoAnno && hasAudioAnno)){

        }else{
            if (hasPdfAnno || hasVideoAnno || hasAudioAnno){
                menu.splice(0,0,{id:"changePdfSource", icon:'menu_duplicate.png', label:i18n.t("Change source")})
            }
        }


        return menu;
    }

    getNoteMenuList = (element:any)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const menu = [
            {id:'openIn', icon:'menu_open_in.svg',showIcon:true,  label:i18n.t("Open in"),children:[
                    {id:'openNoteInSide', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
                    {id:"openNoteInPopup", icon:'menu_open_in_popup_1.png',showIcon:true, label:i18n.t("Open in popup")},
                    {id:'openInFullScreen', icon:'menu_open_in_fullscreen_1.png',showIcon:true,  label:i18n.t("Open in fullscreen")},]},

            (this.state.mCurrentSelectedElement?.customData?.generationData?.isExpand == true)?{id:'fold', icon:'menu_fold_1.png',showIcon:true,  label:i18n.t("Fold")}:{id:'unfold', icon:'menu_fold_1.png',showIcon:true,  label:i18n.t("Unfold")},
            {id:'color', icon:'menu_fold.png',showIcon:false,  label:i18n.t("Color")},
            {id:'sep_1', icon:'', label: MENU_SEPARATOR},
            {id:'apperanceAndStyle', icon:'menu_appera_style.svg',showIcon:true,  label:i18n.t("ApperanceAndStyle"),children:[
                    {id:'border_color', icon:'menu_border_color.svg',showIcon:true, label:i18n.t("Border color")},
                    {id:'border_style', icon:'menu_border_style.svg',showIcon:true, label:i18n.t("Border style")},
                    {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                    {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("PositionAndSize")},
                ]},
            // {id:'setCurrentStyleAsDefault', icon:'menu_set_current_style_as_default.svg',showIcon:true, label:i18n.t("SetCurrentStyleAsDefault")},
            {id:'resetToOriginStyle', icon:'menu_reset_to_origin_style.svg',showIcon:true, label:i18n.t("ResetToOriginStyle")},
            {id:'sep_1_1', icon:'', label: MENU_SEPARATOR},

            {id:'copy', icon:'menu_copy.svg',showIcon:true, label:i18n.t("Copy")},
            {id:"duplicate", icon:'menu_duplicate.svg',showIcon:true, label:i18n.t("Duplicate")},
            // {id:'link', icon:'menu_link.png', label:i18n.t("Link")},

            {id:'delete', icon:'menu_remove.svg',showIcon:true, label:i18n.t("Remove")},
            {id:'sep_3', icon:'', label: MENU_SEPARATOR},

            (this.state.mCurrentSelectedElement?.customData?.generationData?.isHidden == 1)? {id:'visibleFromLibrary', icon:'contextmenu_make_visible_from_library.png',showIcon:true, label:i18n.t("Make visible in library")}:{id:'hideFromLibrary', icon:'contextmenu_hidden_from_library.png',showIcon:true, label:i18n.t("Hide from library")},
            {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
            {id:'sep_4', icon:'', label: MENU_SEPARATOR},

            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:'sep_6', icon:'', label: MENU_SEPARATOR},
            // {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            // {id:'sep_7', icon:'', label: MENU_SEPARATOR},
            {id:'moreOptions', icon:'menu_more_options.svg',showIcon:true,  label:i18n.t("MoreOptions"),children:[
                    {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                    {id:'versionHistory', icon:'version_history.png',showIcon:true,isBeta:true, label:i18n.t("Version history")},
                    {id:'sep_7_1', icon:'', label: MENU_SEPARATOR},
                    {id:'exportPdf', icon:'menu_export_pdf_1.png',showIcon:true,  label:i18n.t("ExportPDF")},
                    {id:'exportMarkdown', icon:'menu_export_pdf_1.png',showIcon:true,  label:i18n.t("ExportMarkdown")},
                    {id:'share', icon:'menu_export_pdf_1.png',showIcon:true,  label:i18n.t("Share1")},
                ]},
            {id:'sep_8', icon:'', label: MENU_SEPARATOR},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},


            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]

        if (element.customData?.generationData?.id.startsWith('j-') || element.customData?.generationData?.journalTime){
            //日记移除
            let nIndex = menu.findIndex(p=>p.id == 'visibleFromLibrary' || p.id == 'hideFromLibrary');
            menu.splice(nIndex,1);

            nIndex = menu.findIndex(p=>p.id == 'deleteFromLibrary');
            menu.splice(nIndex,1);

            nIndex = menu.findIndex(p=>p.id == 'sep_4');
            menu.splice(nIndex,1);
        }

        return menu;
    }

    getPdfFileMenuList = (element)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (element?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }
        const szShowInSystem = isMac()?t("Show in finder"):t("Show in system exporler")
        let menu = [
            {id:'openPdfInSliderRight', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
            {id:"openPdfInPopup", icon:'menu_open_in_popup_1.png',showIcon:true, label:i18n.t("Open in popup")},
            {id:'openPdfInFullScreen', icon:'menu_open_in_fullscreen_1.png',showIcon:true,  label:i18n.t("Open in fullscreen")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:"downloadFile", icon:'menu_duplicate.png', label:i18n.t("Download")},
            // {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
            // {id:"openPdfInPopup", icon:'menu_duplicate.png', label:i18n.t("Open in popup")},
            {id:"openInDefaultApp", icon:'menu_duplicate.png', label:i18n.t("Open in default app")},
            {id:"showInSystemExporler", icon:'menu_duplicate.png', label: szShowInSystem},
            {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
            {id:'delete', icon:'context_menu_delete.png',showIcon:false,  label:i18n.t("Remove")},
            {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'opacity', icon:'menu_opacity.png',showIcon:true, label:i18n.t("Opacity")},
            // {id:'position', icon:'menu_position.png',showIcon:true, label:i18n.t("Position")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
            {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
            {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
            {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
            {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
            // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
            // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
            // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
            // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
        ]
        return menu;
    }

    getFileMenuList = ()=>{
        const szShowInSystem = isMac()?t("Show in finder"):t("Show in system exporler")
        let menu = null;
        const arrayElements = excalidrawAPI.getApp().getSelectedElements();
        const nVideoCount:any = arrayElements.filter(p=>isFileVideoElement(p)).length;
        const nAudioCount:any = arrayElements.filter(p=>isAudioFileElement(p)).length;
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (arrayElements.length == 1){
            if (arrayElements[0].extra?.favor == 1){
                szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
                szBookmarkIcon = 'menu_remove_bookmark.svg'
            }
        }
        if (nVideoCount == 1 && arrayElements.length == 1){
            menu = [
                {id:'openVideoInSide', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
                {id:"openVideoInPopup", icon:'menu_open_in_popup_1.png',showIcon:true, label:i18n.t("Open in popup")},
                {id:'openVideoInFullScreen', icon:'menu_open_in_fullscreen_1.png',showIcon:true,  label:i18n.t("Open in fullscreen")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:"downloadFile", icon:'menu_duplicate.png', label:i18n.t("Download")},
                {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
                {id:"open", icon:'menu_duplicate.png', label:i18n.t("Open in default app")},
                {id:"showInSystemExporler", icon:'menu_duplicate.png', label: szShowInSystem},
                {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                {id:'delete', icon:'context_menu_delete.png',showIcon:false, label:i18n.t("Remove")},
                {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
                {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
                {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
                {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
                {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
                {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
                {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
                // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
                // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
                // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
                // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
            ]
        }else if (nAudioCount == 1 && arrayElements.length == 1){
            menu = [
                {id:'openVideoInSide', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
                {id:"openVideoInPopup", icon:'menu_open_in_popup_1.png',showIcon:true, label:i18n.t("Open in popup")},
                // {id:'openVideoInFullScreen', icon:'menu_open_in_fullscreen_1.png',showIcon:true,  label:i18n.t("Open in fullscreen")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:"downloadFile", icon:'menu_duplicate.png', label:i18n.t("Download")},
                {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
                {id:"open", icon:'menu_duplicate.png', label:i18n.t("Open in default app")},
                {id:"showInSystemExporler", icon:'menu_duplicate.png', label: szShowInSystem},
                {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                {id:'delete', icon:'context_menu_delete.png',showIcon:false, label:i18n.t("Remove")},
                {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'copyLink', icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
                {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
                {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
                {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
                {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
                {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
                {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
                // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
                // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
                // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
                // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
            ]
        }
        else{
            menu = [
                {id:"downloadFile", icon:'menu_duplicate.png', label:i18n.t("Download")},
                {id:"duplicate", icon:'menu_duplicate.png', label:i18n.t("Duplicate")},
                {id:"open", icon:'menu_duplicate.png', label:i18n.t("Open in default app")},
                {id:"showInSystemExporler", icon:'menu_duplicate.png', label: szShowInSystem},
                {id:'showInfo', icon:'menu_show_info_1.png',showIcon:true, label:i18n.t("Show info")},
                {id:'delete', icon:'context_menu_delete.png',showIcon:false, label:i18n.t("Remove")},
                {id:'deleteFromLibrary', icon:'context_menu_delete.png',showIcon:true, label:i18n.t("Delete from library")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'opacity', icon:'menu_opacity_1.png',showIcon:true, label:i18n.t("Opacity")},
                {id:'position', icon:'menu_position_1.png',showIcon:true, label:i18n.t("Position")},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'copyLink',icon:'menu_copy_link_1.png',showIcon:true,label:i18n.t("Copy link")},
                {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
                {id:'manageTags', icon:'menu_manage_tag_1.png',showIcon:true,label:i18n.t("Manage tags")},
                {id:'addToProject', icon:'menu_project.png',showIcon:true,label:i18n.t("Add to project")},
                {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
                {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                {id:'cut', icon:'menu_cut.png', label:i18n.t("Cut")},
                {id:'copy', icon:'menu_copy.png', label:i18n.t("Copy")},
                {id:'lock', icon:'menu_lock_2.png',showIcon:true,  label:i18n.t("Lock")},
                {id:'group', icon:'menu_group.png', label:i18n.t("Group")},
                // {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
                // {id:'sendBackward', icon:'menu_send_backward.png', label:i18n.t("Send backward")},
                // {id:'bringForward', icon:'menu_bring_forward.png', label:i18n.t("Bring forward")},
                // {id:'sendToBack', icon:'menu_send_to_back.png', label:i18n.t("Send to back")},
                // {id:'bringToFront', icon:'menu_bring_to_front.png', label:i18n.t("Bring to front")}
            ]
        }

        return menu;
    }

    //空白处
    getEmptyMenuList = ()=>{
        const isZenMode = excalidrawAPI?.getAppState().zenModeEnabled;
        const menu = [
            {id:"note", icon:'contextmenu_create_card.png',showIcon:true, label:i18n.t("Create card"),shortcut:'C'},
            {id:"text", icon:'contextmenu_create_text.png',showIcon:true, label:i18n.t("Create text"),shortcut:'T'},
            {id:"mindmap", icon:'contextmenu_create_mindmap.png',showIcon:true, label:i18n.t("Create mindmap")},
            {id:"createFrame", icon:'contextmenu_create_frame.png',showIcon:true, label:i18n.t("Create frame"),shortcut:'F'},
            {id:"addFile", icon:'context_menu_add_file.png',showIcon:true, label:i18n.t("Add file")},
            {id:"createStickyNotes", icon:'context_menu_sticky_notes.png',showIcon:true, label:i18n.t("Create sticky notes"),shortcut:'S'},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            // {id:"createProject", icon:'contextmenu_create_project.png',showIcon:true, label:i18n.t("Create project")},
            {id:"createBoard", icon:'contextmenu_create_project.png',showIcon:true, label:i18n.t("New board")},
            {id:"linkToProject", icon:'contextmenu_link_project.png',showIcon:true, label:i18n.t("LinkToOtherProject")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:"project_background", icon:'menu_background.png',showIcon:true, label:i18n.t("Background color")},
            {id:"project_rename", icon:'menu_rename_1.png',showIcon:true, label:i18n.t("Rename")},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:"paste", icon:'menu_paste.png', label:i18n.t("Paste"),shortcut:'Ctrl+V'},
            // {id:'selectAll', icon:'menu_select_all.png', label:i18n.t("Select all"),shortcut:'Ctrl+A'},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'zenMode', icon:'context_menu_checked.png',showIcon:isZenMode, label:i18n.t("Zen mode")},
        ]
        return menu;
    }

    /**
     * 粘贴deeplink后自动弹出的菜单
     */
    getPasteDeepLinkMenuList = ()=>{
        const menu = [
            {id:"pasteAs", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px',disabled:true, label:i18n.t("Paste as")},
            {id:"deeplinkLink", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px', label:i18n.t("Link")},
            {id:"deeplinkEmbed", icon:'contextmenu_create_text.png',marginLeft:'-12px',showIcon:false, label:i18n.t("Embed")},
            ]
        return menu;
    }

    /**
     * 粘贴deeplink后自动弹出的菜单
     */
    getPastUrlMenuList = ()=>{
        const menu = [
            {id:"pasteAs", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px',disabled:true, label:i18n.t("Paste as")},
            {id:"linkEmbed", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px', label:i18n.t("Embed")},
            {id:"linkBookmark", icon:'contextmenu_create_text.png',marginLeft:'-12px',showIcon:false, label:i18n.t("Bookmark")},
        ]
        return menu;
    }

    /**
     * 粘贴可以转成mindmap的md文件弹出的菜单
     */
    getPasteMindmapPlainTextMenuList = ()=>{
        const menu = [
            {id:"pasteAs", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px',disabled:true, label:i18n.t("Paste as")},
            {id:"pasteAsMindmap", icon:'contextmenu_create_card.png',marginLeft:'-12px',showIcon:false,width:'200px', label:i18n.t("PasteAsMindmap")},
            {id:"pasteAsPlainText", icon:'contextmenu_create_text.png',marginLeft:'-12px',showIcon:false, label:i18n.t("PasteAsPlainText")},
        ]
        return menu;
    }

    /**
     * deeplink的右键菜单
     */
    getDeeplinkMenuList = ()=>{
        const menu = [
            {id:"openProjectLink", icon:'',showIcon:false, marginLeft:'-12px',label:i18n.t("Open")},
            {id:'color', icon:'menu_fold.png',showIcon:false, marginLeft:'-19px', label:i18n.t("Color")},
            {id:'sep_1', icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_position.png',marginLeft:'-12px',label:i18n.t("Copy link")},
            {id:'delete', icon:'menu_delete.png',marginLeft:'-12px', label:i18n.t("Delete")},
        ]
        return menu;
    }

    /**
     * project link的菜单
     */
    getProjectlinkMenuList = (ele:any)=>{
        let szAddToBookmark = i18n.t("AddToBookmarkSidebar");
        let szBookmarkIcon = 'menu_add_bookmark.svg'
        if (ele?.extra?.favor == 1){
            szAddToBookmark = i18n.t("RemoveToBookmarkSidebar");
            szBookmarkIcon = 'menu_remove_bookmark.svg'
        }

        if (ele.customData?.isDeleted || ele.customData?.isBoardDeleted){
            const menu = [
                {id:'delete', icon:'menu_delete.png',label:i18n.t("Delete")},
            ]
            return menu;
        }
        const menu = [
            {id:"project_link_rename", icon:'menu_rename_1.png',showIcon:true, label:i18n.t("Rename")},
            {id:'openProjectInSiderbar', icon:'menu_add_to_sliderbar_1.png',showIcon:true,  label:i18n.t("Add to sidebar")},
            // {id:"openProjectLink", icon:'',showIcon:false, marginLeft:'-12px',label:i18n.t("Open")},
            {id:'color', icon:'menu_fold.png',showIcon:false, label:i18n.t("Color")},
            {id:'sep_1', icon:'', label: MENU_SEPARATOR},
            {id:'copyLink', icon:'menu_link_2.png',showIcon:true,label:i18n.t("Copy link")},
            {id:'copyOriginLink', icon:'menu_link_2.png', showIcon:true,label:i18n.t("CopyOriginalLink")},
            {id:'addToBookmark', icon:szBookmarkIcon,showIcon:true,label:szAddToBookmark},
            {id:generateUUID2(), icon:'', label: MENU_SEPARATOR},
            {id:'delete', icon:'menu_delete.png',label:i18n.t("Delete")},
        ]
        return menu;
    }



    onUndo = () => {
        const aaaaashitexUUUUNNNNDDDDOOOOO = excalidrawAPI.getApp().actionManager.actions['undo'];
        excalidrawAPI.getApp().actionManager.executeAction(aaaaashitexUUUUNNNNDDDDOOOOO);
    }

    onRedo = () => {
        const aaaaashitexUUUUNNNNDDDDOOOOO = excalidrawAPI.getApp().actionManager.actions['redo'];
        excalidrawAPI.getApp().actionManager.executeAction(aaaaashitexUUUUNNNNDDDDOOOOO);
    }

    onInitData = function () {
        if (ipcRenderer != null) {
            ipcRenderer.on("new-canvas", (e: object, arg: object) => {
                if (!excalidrawAPI) {
                    return;
                }
                excalidrawAPI.resetScene();
            });
        }
        // useHandleLibrary(this.state.excalidrawAPI)
    }


    onCopy = async (type: "png" | "svg" | "json") => {
        if (!excalidrawAPI) {
            return false;
        }
        await exportToClipboard({
            elements: excalidrawAPI.getSceneElements(),
            appState: excalidrawAPI.getAppState(),
            files: excalidrawAPI.getFiles(),
            type
        });
        window.alert(`Copied to clipboard as ${type} successfully`);
    };

    /**
     * 获取png
     */
    getPngData = async () => {
        return new Promise(resolve => {
            setTimeout(async ()=>{
                let elements = excalidrawAPI.getSceneElements();
                const pngData = await exportToBlob({
                    elements,
                    mimeType: "image/png",
                    appState:this.getAppState(),
                    files: excalidrawAPI.getFiles(),
                    quality: 1.0
                })
                resolve(pngData);
            },1000)
        })

        // const pngData = this.takeScreenshot(document.body);
        // return pngData;
    }

    getFramePngData = async (frameId:string)=>{
        const elements = excalidrawAPI.getSceneElements().filter(p=>(p.id == frameId || p.frameId == frameId));
        const pngData = await exportToBlob({
            elements,
            mimeType: "image/png",
            appState:this.getAppState(),
            files: excalidrawAPI.getFiles(),
            quality: 1
        })
        return pngData;
    }

    getFrameFirstPngData = async ()=>{
        const elements = excalidrawAPI.getSceneElements().filter(p=>p.type == 'frame');
        if (elements.length > 0){
            var arrayEles = [elements[0]];
            const pngData = await exportToBlob({
                elements:arrayEles,
                mimeType: "image/png",
                appState:this.getAppState(),
                files: excalidrawAPI.getFiles(),
                quality: 1
            })
            return pngData;
        }
        return '';
    }

    getFirstFrameBase64Data = async ()=>{
        const pngBlob = await this.getFrameFirstPngData();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(pngBlob);
            reader.onload = () => {
                const base64 = reader.result;
                resolve(base64);
            }
            reader.onerror = error => reject(error);
        })
    }

    getPngBase64Data = async () => {
        const pngBlob = await this.getPngData();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(pngBlob);
            reader.onload = () => {
                const base64 = reader.result;
                resolve(base64);
            }
            reader.onerror = error => reject(error);
        })

        // return new Promise((resolve, reject) => {
        //     this.getPngData().then(res=>{
        //         const pngBlob = res;
        //         const reader = new FileReader();
        //         reader.readAsDataURL(pngBlob);
        //         reader.onload = () => {
        //             const base64 = reader.result;
        //             resolve(base64);
        //         }
        //         reader.onerror = error => reject(error);
        //     })
        // })
    }

    getFrameCount = ()=>{
        return this.getApp()?.getSceneElements().filter(p=>p.type == 'frame').length;
    }

    takeScreenshot =(element)=> {
        // 创建一个Canvas元素
        // var canvas = document.createElement('canvas');
        var scale = window.devicePixelRatio; // 考虑设备像素比
        //
        // // 设置Canvas大小为元素大小，并按比例缩放
        // canvas.width = element.offsetWidth * scale;
        // canvas.height = element.offsetHeight * scale;
        // canvas.getContext('2d').scale(scale, scale);

        // 将元素绘制到Canvas上
        var opts = {
            scale: 1, // 设备像素比
            canvas: document.getElementById("canvas"), // 目标Canvas
            logging: true, // 是否在控制台输出日志
            width: element.offsetWidth, // 要截取的宽度
            height: element.offsetHeight // 要截取的高度
        };

        return new Promise((resolve, reject) => {
            html2canvas(element, opts).then(function(canvas) {
                // 回调函数返回Canvas图像数据
                resolve(canvas.toDataURL('image/png'));
            });
        })

    }

    /**
     * 保存截图
     * @param szSavePath
     */
    snapCapture = (szSavePath: any) => {
        html2canvas(document.getElementById("canvas") as HTMLElement, {
            allowTaint: true,
            width: 800,
            height: 800,
            scale: window.devicePixelRatio,
        }).then(canvas => {
            const imgData = canvas.toDataURL("image/png", 1.0);
            const imgBlob = this.dataURIToBlob(imgData);
            let reader = new FileReader();
            reader.readAsArrayBuffer(imgBlob);
            reader.onload = () => {
                // @ts-ignore
                let buf = new Buffer(reader.result);
                if (fs != null) {
                    fs.writeFile(szSavePath, buf, (err: any) => {

                    })
                }
            }
        })
    }

    /**
     * 转blob
     * @param dataURI
     * @returns {*}
     */
    dataURIToBlob = (dataURI: any) => {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], {type: mimeString});
    }

    /**
     * 创建笔记元素
     * @param noteData
     */
    createNoteElement = (noteData,positionX,positionY,deeplink) => {
        let position=excalidrawAPI.getApp().getCurrentCenterPoint();
        let x = position.x - 100;
        let y = position.y - 150;
        if (positionX != undefined){
            x = positionX;
        }
        if (positionY != undefined){
            y = positionY;
        }
        const szDefaultStyle = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
        let defaultStyle = {strokeWidth:2,strokeColor:'transparent',backgroundColor:getNoteElementBackgroundColor()};
        if (szDefaultStyle){
            const jsonDefaultStyle = JSON.parse(szDefaultStyle);

            if (jsonDefaultStyle.backgroundColor){
                defaultStyle.backgroundColor = jsonDefaultStyle.backgroundColor;
            }
            if (jsonDefaultStyle.strokeWidth){
                defaultStyle.strokeWidth = jsonDefaultStyle.strokeWidth;
            }
            if (jsonDefaultStyle.strokeColor){
                defaultStyle.strokeColor = jsonDefaultStyle.strokeColor;
            }
        }
        let szBackgroundColor = defaultStyle.backgroundColor;
        if (deeplink){
            szBackgroundColor = deeplink.backgroundColor || defaultStyle.backgroundColor;
        }
        var element = {
            type: "iframe",
            version: 1,
            isDeleted: false,
            id: generateUUID2(),//noteData.id,
            strokeWidth: defaultStyle.strokeWidth,
            strokeStyle: "solid",
            roughness:0,
            roundness: {
                type:ROUNDNESS.ADAPTIVE_RADIUS,
                value:8
            },
            opacity: 100,
            angle: 0,
            locked:false,
            x: x,
            y: y,
            backgroundColor:szBackgroundColor,//getNoteElementBackgroundColor(),
            strokeColor:defaultStyle.strokeColor,
            fillStyle:'solid',
            width: DEFAULT_NOTE_WIDTH,
            height: DEFAULT_NOTE_HEIGHT,
            groupIds: [],
            customData: {
                generationData: {
                    status: 'done',
                    html: noteData.doc,//createNoteElementByNote(noteData.name,noteData.doc),
                    name:noteData.name,
                    type:'note',
                    id:noteData.key??noteData.id,
                    isEditable:false,
                    isExpand:true,
                    isFixedSize:false,
                    libraryType:noteData.type, //库在的类型.....
                    journalTime:noteData.journalTime,
                    formatData:noteData.formatDate,
                    hasTitle:noteData.hasTitle
                }
            }
        }
        return element;
    }

    /**
     * 创建笔记元素
     * @param noteData
     */
    createPdfAnnoElement = async (pdfData:any,positionX,positionY,type,deeplink) => {

        let position=excalidrawAPI.getApp().getCurrentCenterPoint();
        let x = position.x - 100;
        let y = position.y - 150;
        if (positionX){
            x = positionX;
        }
        if (positionY){
            y = positionY;
        }

        const szHtml = createPdfAnnoTextElement(pdfData);

        let height = 210;
        let elementHeight = height;
        let isLockRadio = false;
        if (pdfData.type == 'image' || pdfData.annoType == 'image'){
            // isLockRadio = true;
            let szBase64Image = pdfData.image;
            if (!pdfData.image && pdfData.thumbImage){
                const filePath = localStorage.getItem(KEY_FILE_DIR)+pdfData.id+'.png';
                szBase64Image = 'data:image/png;base64,' + await ipcInvoke('read-file-base64',{filePath:filePath});
            }
            const size = await getBase64ImageSize(szBase64Image);
            height = (size.height/size.width) * (DEFAULT_NOTE_WIDTH);
            // if (height > 200){
            //     height = 200;
            // }
            height += 58;
            elementHeight = height;//不包含注记的高度
            height += calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),pdfData.comment);
        }else{
            //文本，计算下高度.
            const hhhhhhiiiigggggg = calcTextHeight((DEFAULT_NOTE_WIDTH - (8 + 8 + 6) * 2), szHtml);
            const nCommentHeight = calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),pdfData.comment);
            height = hhhhhhiiiigggggg  + nCommentHeight;//(2 + 8 + 6)这个是所有的padding.
            elementHeight = height;//不包含注记的高度.

            // if (height > DEFAULT_NOTE_HEIGHT){
            //     height = DEFAULT_NOTE_HEIGHT
            // }
        }

        const card = await getCardById(pdfData.libraryId);
        let fileName = pdfData?.name?.replace('.pdf','')+'.pdf'
        if (card){
            fileName = card.fileName;
        }

        let szStrokeColor = getNoteElementStrokeColor();
        let nStrokeWidth = 1;
        if (deeplink){
            if (deeplink.strokeColor){
                szStrokeColor = deeplink.strokeColor;
                nStrokeWidth = DEFAULT_ELEMENT_STROKE_WITHD;
            }
        }
        var element = {
            type: "iframe",
            version: 1,
            isDeleted: false,
            // id: pdfData.id,
            id:generateUUID2(),
            strokeWidth: nStrokeWidth,
            strokeStyle: "solid",
            roughness:0,
            roundness: {
                type:ROUNDNESS.ADAPTIVE_RADIUS,
                value:8
            },
            opacity: 100,
            angle: 0,
            locked:false,
            x: x,
            y: y,
            backgroundColor:getNoteElementBackgroundColor(),
            strokeColor:szStrokeColor,
            fillStyle:'solid',
            width: DEFAULT_NOTE_WIDTH,
            height: height,
            groupIds: [],
            customData: {
                generationData: {
                    annoHeight:elementHeight,//注记本身高度
                    status: 'done',
                    html: szHtml,
                    type:type || 'pdfAnno',
                    id:pdfData.pdfId,
                    libraryId:pdfData.id,
                    pdfData:pdfData,
                    fileName:fileName
                }
            },
            isLockRatio: isLockRadio
        }
        return element;
    }


    /**
     * 创建视频注记元素
     * @param noteData
     */
    createVideoAnnoElement = async (libraryId:any,fileName:any,videoData:any,positionX,positionY,videoName,type) => {

        let position=excalidrawAPI.getApp().getCurrentCenterPoint();
        let x = position.x - 100;
        let y = position.y - 150;
        if (positionX != undefined){
            x = positionX;
        }
        if (positionY != undefined){
            y = positionY;
        }

        let height = await calcVideoAnnoHeight(videoData,DEFAULT_NOTE_WIDTH);

        var element = {
            type: "iframe",
            version: 1,
            isDeleted: false,
            // id: videoData.id,
            id:generateUUID2(),
            strokeWidth: 1,
            strokeStyle: "solid",
            roughness:0,
            roundness: {
                type:ROUNDNESS.ADAPTIVE_RADIUS,
                value:8
            },
            opacity: 100,
            angle: 0,
            locked:false,
            x: x,
            y: y,
            backgroundColor:getNoteElementBackgroundColor(),
            strokeColor:getNoteElementStrokeColor(),
            fillStyle:'solid',
            width: DEFAULT_NOTE_WIDTH,
            height: height,
            groupIds: [],
            customData: {
                generationData: {
                    // annoHeight:elementHeight,//注记本身高度
                    status: 'done',
                    html: '',//szHtml,
                    type: type || 'videoAnno',
                    id:libraryId,
                    videoData:videoData,
                    videoName:videoName
                }
            }
        }
        return element;
    }

    /**
     * 添加url embed链接
     * @param szUrl
     */
    insertEmbedElement = async (szUrl:any,szLibraryId,initX:any,initY:any,embedType='page',deeplink)=>{
        const {x,y}=excalidrawAPI.getApp().getCurrentCenterPoint();
        let nPosX = x-190;
        let nPosY = y-130;
        if (isBilibiliUrl(szUrl)){
            // let bid = getUrlQueryParam(szUrl,"buvid");
            // let p = getUrlQueryParam(szUrl,'p');
            // if (p){
            //     szUrl = getBilibiliLink({bid, time:0, p});
            // }

        }

        if (initX){
            nPosX = initX;
        }
        if (initY) {
            nPosY = initY;
        }

        if (!szLibraryId){
            szLibraryId = generateUUID2();
        }

        let szType = '';
        let szName = '';


        if (isYoutubeUrl(szUrl)){
            szType = 'youtube'
        }else if (isBilibiliUrl(szUrl)){
            szType = 'bilibili';
        }else if (isBaiduVideoUrl(szUrl)){
            szType = 'baidu';
            szName = getBaiduVideoNameByUrl(szUrl);
        }

        const embedLink = getEmbedLink(szUrl);

        if (!embedLink) {
            return;
        }

        if (embedLink.warning) {
            this.setToast({ message: embedLink.warning, closable: true });
        }
        let width = embedLink?.intrinsicSize?.w || DEFAULT_EMBEDABLE_ELEMENT_WIDTH;
        let height = embedLink?.intrinsicSize?.h || DEFAULT_EMBEDABLE_ELEMENT_HEIGHT;

        if (isSupportVideoAnnoUrl(szUrl) && !isBilibiliUrl(szUrl) && !isBaiduVideoUrl(szUrl)){
            width = DEFAULT_NOTE_WIDTH;
            height = width*height / DEFAULT_EMBEDABLE_ELEMENT_WIDTH
        }

        const hasExist = await getCardById(szLibraryId);
        if (hasExist){
            szName = hasExist.name;
        }

        let strokeWidth = 0.9;
        let szStrokeColor = '#F0EFF5';
        if (deeplink){
            if (deeplink.strokeColor){
                strokeWidth = DEFAULT_ELEMENT_STROKE_WITHD;
                szStrokeColor = deeplink.strokeColor;
            }
        }

        var element:any = {
            type: "embeddable",
            version: 1,
            isDeleted: false,
            id: generateUUID2(),
            strokeWidth: strokeWidth,
            strokeStyle: "solid",
            roughness:0,
            roundness: {
                type:ROUNDNESS.ADAPTIVE_RADIUS,
                value:12
            },
            link:szUrl,
            opacity: 100,
            angle: 0,
            x: nPosX,
            y: nPosY,
            customData:{generationData:{id:szLibraryId,type:szType,name:szName,isShowName:true}},
            strokeColor: szStrokeColor,
            backgroundColor: getBookmarkBackgroundColor(),
            fillStyle:'solid',
            width: embedType == 'page'?width:DEFAULT_EMBEDABLE_BOOKMARK_WIDTH,
            height: embedType == 'page'?height:DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT,
            locked:false,
            groupIds: [],
            embedType:embedType,
            name:szName
        }
        excalidrawAPI.updateScene({
            elements:[...excalidrawAPI.getSceneElements(),element]
        })


        //如果是youtube链接，保存到库里面.--记得还有app.tsx中粘贴的url
        if (isSupportVideoAnnoUrl(szUrl)){
            if (!hasExist){
                const arrayLibrarys:any = await getCardList(-1,0,'liveVideo',null,null);
                const item = arrayLibrarys.find(p => p.fileName == szUrl);
                if (item){
                    const customData = {generationData:{...item,id:item.id,type:szType}};
                    element.customData = {...customData};
                    mutateElement(element,customData);
                }else{
                    let src = getEmbedLink(toValidURL(szUrl || ""));
                    const card = {
                        id:szLibraryId,
                        name:szName,
                        type:szType,
                        fileName:szUrl,
                        isDeleted:0,
                        createTime:Date.now(),
                        thumbImage:isYoutubeUrl(szUrl)?getYoutubeThumbUrl(src?.videoId):''
                    }
                    //判断highlight中是否有
                    const dbHighlight = await dbGetHighlight(szLibraryId);
                    if (dbHighlight){
                        card.name = dbHighlight.name;
                        card.thumbImage = dbHighlight.thumbImage;
                    }
                    await updateCard(card);

                    //粘贴了就切走，保存一下吧...
                    if (this.props.parentOnSaveNotes){
                        this.props.parentOnSaveNotes();
                    }

                    if (isBilibiliUrl(szUrl)) {
                        apiBilibiliCover(szUrl).then(res => {
                            //如果获取到缩略图，这里再更新一下...
                            card.name = res.title;
                            card.thumbImage = res.pic;
                            updateCard(card).then(res=>{
                                // postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                window.globalRefreshList("refreshLibraryList_");
                                //刷新content
                                if (window.onRefreshContentElement){
                                    window.onRefreshContentElement();
                                }
                            });
                            mutateElement(element,{name:card.name});
                        })
                    }
                }
            }

        }else {
            const library = await getCardById(szLibraryId);
            if (!library) {//库中没有的。。。。
                const card: any = {
                    id: szLibraryId,
                    name: szName,
                    type: 'webLink',
                    fileName: szUrl,
                    isDeleted: 2,//默认不要显示在库中....
                }
                updateCard(card);

                fetchPageTitle(element.link).then(res => {
                    if (res) {
                        card.name = element.name = res;
                        mutateElement(element, {name: res});
                        updateCard(card);
                    }
                })
            }
        }

        if (embedType == 'text'){
            const nTimeoutId = setTimeout(()=>{
                const node = document.getElementById(`${element.id}-card`)!;
                if (node){
                    cardLink([node],element);
                }
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        }
    }

    insertFileElement = async (szFileName:string,id:string,isHidden=false,file:any,elementId:any = null,url:string,isSaveToCard = true,isAbsolutePath:boolean = false,szName:any = '')=>{
        return excalidrawAPI.getApp().insertFileElement(szFileName,id,undefined,isHidden,file,elementId,url,isSaveToCard,isAbsolutePath,szName);
    }

    /**
     * 插入笔记内容到画布
     * @param noteData
     */
    onInsertNoteData = (noteData: any,isAutoInsert:boolean,positionX,positionY,deeplink,hasSelected) => {
        let arrayElements:any = [...excalidrawAPI.getSceneElements()];
        var isExist = false;
        for(var i=0;i<arrayElements.length;i++){
            var item = arrayElements[i];
            if (isCardAnnoElement(item)){
                continue;
            }
            if(item.id === noteData.id || item.customData?.generationData?.id == noteData.id){
                //replace
                const generationData = {...item.customData?.generationData};
                let newItem = {
                    ...item,
                    customData: {
                        generationData: {
                            ...generationData,
                            status: 'done',
                            html: noteData.doc,//createNoteElementByNote(noteData.name,noteData.doc),
                            name: noteData.name,
                            id:noteData.id,
                            type:'note',
                            hasTitle:noteData.hasTitle,
                        }
                    },
                }
                arrayElements[i] = newItem;
                // isExist = true;

                const nTimeoutId = setTimeout(()=>{
                    postMessage(EVENT_UPDATE_NOTE_HEIGHT,newItem);
                },100)
                this.mArrayTimeoutIds.push(nTimeoutId);
            }
        }

        if (isAutoInsert && isExist){
            message.info(t("CardIsAlreadOn").replace('{0}',t('Card')));
            return;
        }

        let element;
        if(!isExist && isAutoInsert){
            element = this.createNoteElement(noteData,positionX,positionY,deeplink);
            arrayElements.push(element);

            //这里要刷新左侧栏
            postMessage(EVENT_ELEMENT_DELETE_FROM_ACTION);
        }
        excalidrawAPI.updateScene({
            elements:arrayElements,
            appState: {
                ...excalidrawAPI.getAppState(),
                selectedElementIds:element?{[element.id]:true}:{}
            }
        })
    }

    onInsertPdfAnnotation0 = async (pdfAnno:any,positionX,positionY,type,deeplink)=>{
        const pdfData = pdfAnno.data[0];
        for (let i=0;i<pdfAnno.data.length;i++){
            const newPdf = {...pdfData,...pdfAnno.data[i]};
            await this.onInsertPdfAnnotation({data:[newPdf]},positionX+ (i*20),positionY+(i*20),type,deeplink);
        }
    }

    /**
     * 插入pdf注记,
     * @param pdfAnno
     * @param positionX
     * @param positionY
     */
    onInsertPdfAnnotation = async (pdfAnno:any,positionX,positionY,type,deeplink)=>{
        const pdfData = pdfAnno.data[0];
        if (!pdfData.fileName){
            const library = await getCardById(pdfData.pdfId);
            if (library){
                pdfData.name = library.name;
                pdfData.fileName = library.fileName;
            }
        }
        let arrayElements:any = [...excalidrawAPI.getSceneElements()];
        var isExist = false;
        for(var i=0;i<arrayElements.length;i++){
            var item = arrayElements[i];
            if(item.id === pdfData.id){
                //replace
                let newItem = {
                    ...item,
                    customData: {
                        generationData: {
                            status: 'done',
                            html: createPdfAnnoTextElement(pdfData),
                            id:pdfData.pdfId,
                            type:type || 'pdfAnno',
                            pdfData:pdfData,
                            fileName:pdfData.fileName
                        }
                    },
                }
                arrayElements[i] = newItem;
                isExist = true;
            }
        }

        let szElementId = '';

        if (isExist){
            message.info(t("PdfAnnoExist"));
            return;
        }else{
            const element = await this.createPdfAnnoElement(pdfData,positionX,positionY,type,deeplink);
            szElementId = element.id;
            arrayElements.push(element);
        }
        excalidrawAPI.updateScene({
            elements:arrayElements,
            appState: {
                ...excalidrawAPI.getAppState(),
            }
        })
        //todo 触发一次onchange事件
        let nTimeoutId = setTimeout(()=>{
            let input = document.getElementById('pdf-anno-'+szElementId);
            if (input){
                // input.fireEvent('on')
                // input.blur();
                // let event = new Event('change',{bubbles:true});
                // input.dispatchEvent(event);
                let event1 = new InputEvent('input',{bubbles:true});
                event1.isManualUpdate = true
                input.dispatchEvent(event1);
            }
        },100);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    /**
     * 插入视频注记,
     * @param libraryId 文件所在库中的ID、highlight表中的ID
     * @param fileName 实际文件名称-路径
     * @param videoData 注记内容
     * @param positionX
     * @param positionY
     */
    onInsertVideoAnnotation = async (libraryId:any,fileName:any,videoData:any,positionX,positionY,videoName,szType)=>{
        let arrayElements:any = [...excalidrawAPI.getSceneElements()];
        var isExist = false;
        for(var i=0;i<arrayElements.length;i++){
            var item = arrayElements[i];
            if(item.id === videoData.id){
                //replace
                let newItem = {
                    ...item,
                    customData: {
                        generationData: {
                            status: 'done',
                            html: '',//createPdfAnnoTextElement(pdfData),
                            id:libraryId,
                            type:szType || 'videoAnno',
                            videoData:videoData,
                            videoName:videoName
                        }
                    },
                }
                arrayElements[i] = newItem;
                // isExist = true;
            }
        }

        if (isExist){
            message.info(t("PdfAnnoExist"));
            return;
        }else{
            const element = await this.createVideoAnnoElement(libraryId,fileName,videoData,positionX,positionY,videoName,szType);
            arrayElements.push(element);
        }
        excalidrawAPI.updateScene({
            elements:arrayElements,
            appState: {
                ...excalidrawAPI.getAppState(),
            }
        })
    }

    /**
     * 获取本画布JSON串
     */
    getDrawJson = (id: string='') => {
        //histroy
        // const item: History = excalidrawAPI.getApp().getHistory();
        // let history = mapHistroy[id];
        // if (history != undefined) {
        //     Object.assign(item.elementCache, history.elementCache);
        //     Object.assign(item.redoStack, history.redoStack);
        //     Object.assign(item.stateHistory, history.stateHistory);
        //     mapHistroy[id] = history;
        // }
        if (!excalidrawAPI)return;

        //下面这3个集合，1和  2、3不一致？--mindmap的鸟东西，不是这里保存不了，就是那里保存不了。
        // const arrayElements1 = excalidrawAPI.getApp().getSceneElementsOrigin();
        const arrayElements1 = excalidrawAPI.getApp().getSceneElements();

        // console.log('************');
        // console.log(arrayElements1);

        //20250328之前使用的是下面这个。。。
        // const arrayElements3 = excalidrawAPI?.getSceneElements();

        //20250328后，换成1
        // const jsonResult = serializeAsJSON( excalidrawAPI?.getSceneElements(), excalidrawAPI.getAppState(), excalidrawAPI.getFiles(), "local");
        const szJsonResult = serializeAsJSON(arrayElements1, excalidrawAPI.getAppState(), excalidrawAPI.getApp().files, "local");
        // const sb = saveAsJSON(excalidrawAPI.getSceneElements(),excalidrawAPI.getAppState(),excalidrawAPI.getFiles());
        // alert(sb)
        const jsonResult = JSON.parse(szJsonResult);
        // if (jsonResult.appState.zoom.value == 1){
        //     console.log(jsonResult);
        // }

        return jsonResult;
    }

    /**
     * 获取状态
     */
    getExcalidrawState = () => {
        return excalidrawAPI.getAppState();
    }

    hasFrameElement = ()=>{
        return excalidrawAPI.getSceneElements().filter(p=>p.type == 'frame').length > 0;
    }

    getFrameElements = ()=>{
        return  excalidrawAPI.getSceneElements().filter(p=>p.type == 'frame');
    }

    setFirstHighlight = ()=>{
        // excalidrawAPI.updateScene({
        //     appState:{
        //         currentItemStrokeColor:'#ffff00',
        //         currentItemStrokeWidth: 5
        //     }
        // })
    }

    /**
     * 是否是在图片预览状态
     */
    isImagePreviewVisible = ()=>{
        return this.state.isImagePreviewVisible;
    }

    /**
     * 显示网格
     * @param isShow
     */
    showGrid = (isShow)=>{
        excalidrawAPI.updateScene({
            appState:{
                gridModeEnabled:isShow,
                gridSize:isShow?10:null
            }
        })
    }

    /**
     * 是否显示了网格
     */
    iShowGrid = ()=>{
        return excalidrawAPI?.getAppState().gridSize > 0;
    }

    /**
     * 打开最新的这个PDF的注记，如果有的话....
     */
    getNewestPdfAnno = ()=>{
        let pdfAnno = null;
        if (mOpenPdfData){
            pdfAnno = {...mOpenPdfData};
        }
        mOpenPdfData = null;
        return pdfAnno;
    }

    /**
     * 清空选中
     */
    clearSelectElements = ()=>{
        const nTimeoutId = setTimeout(()=>{
            excalidrawAPI.updateScene({
                appState:{
                    selectedElementIds:{}
                }
            })
            this.hidePopupMenu();
        },50);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    /**
     * 放大或缩小
     * @param isAdd
     */
    zoomFix = (isAdd: any,fPercent=0) => {
        var fZoom: number = excalidrawAPI.getAppState().zoom.value;
        if (isAdd == 1) {
            fZoom = fZoom + 0.05;
        } else if (isAdd == -1) {
            fZoom -= 0.05;
        } else {
            fZoom = 1.0;
        }
        if (fZoom < 0.01) {
            fZoom = 0.01;
        }
        if (fPercent > 0){
            fZoom = fPercent;
        }
        excalidrawAPI.getApp().zoomCanvas(fZoom);
        // excalidrawAPI.updateScene({
        //     appState: {
        //         ...excalidrawAPI.getAppState(),
        //         zoom: {
        //             value: fZoom as NormalizedZoomValue,
        //         },
        //
        //     }
        // })
        return fZoom;
    }

    //创建第一个的历史记录...
    createFistHistory = (id: string) => {
        if (excalidrawAPI != undefined) {
            let history = new History();
            mapHistroy[id] = history;
            excalidrawAPI.getApp().resetNewCanvasHistory(history, true);
        } else {
            szFirstCanvasId = id;
        }
    }

    /**
     * 更新服务端代码
     */
    onUpdateElementForServer = ()=>{
        //1s内
        if (Date.now() - mLastUpdateTime < 2000) {
            // mLastUpdateTime = Date.now();
            return;
        };
        mLastUpdateTime = Date.now();

        if (isWebApp()){
            const nTimeoutId = setTimeout(()=>{
                //获取当前选中的元素
                const arraySelectElements = excalidrawAPI?.getApp().getSelectedElements();
                const arraySceneElements = excalidrawAPI.getSceneElements();

                const lastElement = excalidrawAPI.getSceneElements()[excalidrawAPI.getSceneElements().length - 1];
                if (lastElement){
                    if (excalidrawAPI.getAppState().activeTool.type == 'freedraw' ||
                        excalidrawAPI.getAppState().activeTool.type == 'highlighter'
                    ){
                        //取最后一个...
                        if (!mHasSavedElementIds[lastElement.id]){
                            arraySelectElements.push(lastElement);
                        }
                    }else if (isTextElement(lastElement)){
                        if (lastElement.richText?.length > 0 && !mHasSavedElementIds[lastElement.id]){
                            arraySelectElements.push(lastElement);
                        }
                    }else if (isMindmapElement(lastElement)){
                        if (lastElement.data){
                            //取最后一个...
                            if (!mHasSavedElementIds[lastElement.id]){
                                arraySelectElements.push(lastElement);
                            }
                        }
                    }
                }
                if (excalidrawAPI.getAppState().activeMindMap){
                    if (excalidrawAPI.getAppState().activeMindMap?.element){
                        arraySelectElements.push(lastElement);
                    }
                }

                if (arraySelectElements.length > 0){
                    var board = {
                        ...this.props.parentOnGetSelectedBoard(),
                        // appState:excalidrawAPI.getAppState()
                    }
                    if (!board.drawJson.appState){
                        board.drawJson.appState = excalidrawAPI.getAppState();
                    }
                    apiUpdateElement(PROJECT_ID,board,arraySelectElements).then(res=>{
                        if (res.code == 0){
                            arraySelectElements.forEach(p=>{
                                mHasSavedElementIds[p.id] = true;
                                mHasNormalUpdateElementIds[p.id] = true;
                            })
                        }
                    });
                }

                //删除的元素... eraser搞的..
                const arrayIsDeleted = excalidrawAPI?.getSceneElementsIncludingDeleted().filter(p=>p.isDeleted)
                var arrayDeletedIds:any = [];
                arrayIsDeleted.forEach(p=>{
                    if (!mHasDeletedElementIds[p.id]){
                        arrayDeletedIds.push(p.id);
                    }
                });
                if (arrayDeletedIds.length > 0){
                    apiElementDeleteByIds(arrayDeletedIds).then(res=>{
                        if(res.code == 0){
                            arrayDeletedIds.forEach(p=>{
                                mHasDeletedElementIds[p] = true;
                            })
                        }
                    })
                }

            },200);
            this.mArrayTimeoutIds.push(nTimeoutId);
        }else{
            //保存
            // if (this.props.parentOnSaveNotes){
            //     this.props.parentOnSaveNotes();
            // }
        }
    }

    shitLoad = async (jsonObj:any,blob: Blob, appState: any,szViewBackgroundColor:string) => {

        let nTime = Date.now();
        // @ts-ignore
        var scene = await loadFromBlob(blob, (appState == null) ? excalidrawAPI.getAppState() : appState, excalidrawAPI.getSceneElements());

        // console.log('myExcalidraw-shitLoad:',(Date.now() - nTime))
        if (appState != undefined && appState != null) {
            appState.width = excalidrawAPI.getAppState().width;
            appState.height = excalidrawAPI.getAppState().height;
        }else{
            // appState = {
            //     scrollX:0,
            //     scrollY:0
            // }
        }

        // scene.appState = appState;
        if (jsonObj.appState != null && jsonObj.appState != undefined){
            scene.appState.scrollX = jsonObj.appState.scrollX;
            scene.appState.scrollY = jsonObj.appState.scrollY;

            // if (jsonObj.appState.zoom?.value){
            //     scene.appState.zoom = {
            //         value:jsonObj.appState.zoom.value
            //     }
            // }
        }
        //是否显示对齐线
        scene.appState.showSnapLines = localStorage.getItem(KEY_GLOBAL_SNAP_LINE_VISIBLE) !== 'invisible';

        if (!isStringNullOrEmpty(szViewBackgroundColor)){
            this.onSetBackground(szViewBackgroundColor);
        }

        if (isCanvasReadonly || this.state.isReadOnlyStatus){

        }else{
            scene.appState.displayMode = 'edit';
        }

        // @ts-ignore  IMAGE更新不出来...
        excalidrawAPI.updateScene(scene);

        this.setState({
            isReadOnlyStatus: (isCanvasReadonly || this.state.isReadOnlyStatus),
        },()=>{

        })

        //auto scroll to
        if (APP_WEB && isMobile){
            setTimeout(()=>{
                // if (excalidrawAPI.getAppState().scrolledOutside){
                //     console.log('******scrolled out side******')
                // }
                excalidrawAPI.scrollToContent(excalidrawAPI.getSceneElements(),{
                    // fitToContent: true,
                    fitToViewport: true
                });
                // var elements = excalidrawAPI.getApp().getSceneElementsOrigin();
                // zoomToFit({targetElements:elements, appState:excalidrawAPI.getAppState(), fitToViewport:true});
            },100);
        }


        //frame preview????
        if (scene.appState.displayMode == 'preview'){
            // setTimeout(()=>{
                // excalidrawAPI.getApp().updateDisplayMode('preview');
            // },100);
        }

        if (this.props.parentOnLoadBoardFinished){
            this.props.parentOnLoadBoardFinished();
        }

        //load mindmap
        if (jsonObj?.elements?.some(p=>isMindmapElement(p) || isEmbedableBookmarkElement(p))){
            await this.delayLoadMindmap(jsonObj);
        }

        if (this.state.loadDrawJsonTimes == 0){
            this.setState({
                loadDrawJsonTimes:1
            })
            if (this.props.parentOnFirstLoadFinished){
                this.props.parentOnFirstLoadFinished();
            }
        }
    }

    shitLoadWithScene = async (jsonObj:any, appState: any,szViewBackgroundColor:string,files:any) => {

        appState = {
            ...excalidrawAPI.getAppState(),
            ...jsonObj.appState,
            files:files
        };
        let nTime = Date.now();
        // @ts-ignore
        var scene = {
            elements:jsonObj.elements,
            appState:appState
        }
        // console.log('myExcalidraw-shitLoad:',(Date.now() - nTime))
        //是否显示对齐线
        scene.appState.showSnapLines = localStorage.getItem(KEY_GLOBAL_SNAP_LINE_VISIBLE) !== 'invisible';

        if (!isStringNullOrEmpty(szViewBackgroundColor)){
            if (szViewBackgroundColor == DEFAULT_CANVAS_BACKGROUND_DARK || szViewBackgroundColor == DEFAULT_CANVAS_BACKGROUND){
                szViewBackgroundColor = isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND;
            }

            scene.appState.viewBackgroundColor = szViewBackgroundColor;
        }else{
            scene.appState.viewBackgroundColor = isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND;
        }

        if (isCanvasReadonly || this.state.isReadOnlyStatus){

        }else{
            scene.appState.displayMode = 'edit';
        }

        // @ts-ignore  IMAGE更新不出来...
        excalidrawAPI.updateScene(scene);

        this.setState({
            isReadOnlyStatus: (isCanvasReadonly || this.state.isReadOnlyStatus),
        },()=>{

        })

        //auto scroll to
        if (APP_WEB && isMobile){
            setTimeout(()=>{
                // if (excalidrawAPI.getAppState().scrolledOutside){
                //     console.log('******scrolled out side******')
                // }
                excalidrawAPI.scrollToContent(excalidrawAPI.getSceneElements(),{
                    // fitToContent: true,
                    fitToViewport: true
                });
                // var elements = excalidrawAPI.getApp().getSceneElementsOrigin();
                // zoomToFit({targetElements:elements, appState:excalidrawAPI.getAppState(), fitToViewport:true});
            },100);
        }


        //frame preview????
        if (scene.appState.displayMode == 'preview'){
            // setTimeout(()=>{
            // excalidrawAPI.getApp().updateDisplayMode('preview');
            // },100);
        }

        //load mindmap
        if (jsonObj?.elements?.some(p=>isMindmapElement(p) || isEmbedableBookmarkElement(p))){
            await this.delayLoadMindmap(jsonObj);
        }

        if (this.props.parentOnLoadBoardFinished){
            this.props.parentOnLoadBoardFinished();
        }

        if (this.state.loadDrawJsonTimes == 0){
            this.setState({
                loadDrawJsonTimes:1
            })
            if (this.props.parentOnFirstLoadFinished){
                this.props.parentOnFirstLoadFinished();
            }
        }
    }

    delayLoadMindmap = (jsonObj:any)=>{
        return new Promise(resolve => {

            //将mindmap保存到缓存...
            const arrayMindmapElements = jsonObj?.elements?.filter(p=>isMindmapElement(p));
            arrayMindmapElements.forEach(p=>{
                mindMapId_Data.set(p.id,p.data);
            });

            const nTimeoutId = setTimeout(()=>{
                excalidrawAPI.getApp()?.loadMindmap();
                excalidrawAPI.getApp()?.loadEmbedLink();
                resolve('');
            },600);//延迟要长一点.....
            this.mArrayTimeoutIds.push(nTimeoutId);
        })
    }

    //切换画布
     setDrawJson = async (id: any, jsonObj: any, appState: any) => {
        let nTime = Date.now();

        // console.log("setDrawJson");
        excalidrawAPI.getApp().resetHistory0();
        this.setState({
            isShowMenu:false,
            isShowMoreMenu:false
        })
        let szViewBackgroundColor = '';
        if (jsonObj?.appState != undefined){
            szViewBackgroundColor = jsonObj.appState.viewBackgroundColor;
        }
        //*********新建project走这里*********
        if (jsonObj == undefined || jsonObj == null || jsonObj.length == 0 || Object.keys(jsonObj).length == 0) {
            excalidrawAPI.resetScene();
            excalidrawAPI.updateScene({
                appState: {
                    ...excalidrawAPI.getAppState(),
                    gridSize: null,
                    isReadOnlyStatus:(isCanvasReadonly || this.state.isReadOnlyStatus),
                    objectsSnapModeEnabled:true,
                    scrollX:0,
                    scrollY:0
                }
            })
            //创建一个新的历史记录
            let history = new History();
            mapHistroy[id] = history;
            excalidrawAPI.getApp().resetNewCanvasHistory(history, true);
            return;
        }

        var arrayFuckEx:any = [];
        for (var i = 0; i < jsonObj?.elements?.length; i++) {
            var ele = jsonObj.elements[i];
            var c = jsonObj?.files[ele.fileId];
            if (c && isWeb() && isSvg(c.mimeType)){
                c.dataURL = 'data:image/svg+xml;base64,'+ svgStringToBase64(ele.extra.svgText);
            }
            if (c != undefined && c != null && !isStringNullOrEmpty(c.dataURL)) {
                var item = {
                    mimeType: c.mimeType,
                    id: c.id,
                    dataURL: c.dataURL,
                    created: c.created,
                    lastRetrieved: c.lastRetrieved
                }
                arrayFuckEx.push(item);

                await excalidrawAPI.getApp().createImageToCache(c.id,c.dataURL,c.mimeType,c.fullPath);
            }
            //处理旧的文本内容
            if (ele.type == 'text' && !ele.richText){
                // let arrayRichText = [];
                // if (!isStringNullOrEmpty(ele.text)){
                //     for (let i=0;i<ele.text.length;i++){
                //         arrayRichText.push({
                //             bold:false,
                //             color:ele.strokeColor,
                //             fontFamily:ele.fontFamily,
                //             fontSize:16,
                //             italic:false,
                //             strikeout:false,
                //             underline:false,
                //             value:ele.text[i]
                //         })
                //     }
                //     ele.richText = null;
                // }
            }else if (isNoteElement(ele)){
                //只读.
                ele.customData.generationData.isEditable = false;
                //重新读取下doc的内容》。。。
                if (!APP_WEB){
                    const dbCard:any = await getCardById(ele.customData.generationData.id);
                    if (dbCard){
                        ele.customData.generationData.html = dbCard.doc;
                        ele.customData.generationData.name = dbCard.name;
                    }
                }
            }
        }
        //导入的，原来有的。加进来？？？？
         if (jsonObj?.files){
             const arrayFileKeys = Object.keys(jsonObj?.files);
             for (let i=0;i<arrayFileKeys.length;i++){
                 if (!arrayFuckEx.some(p=>p.id == arrayFileKeys[i])){
                     arrayFuckEx.push(jsonObj.files[arrayFileKeys[i]])
                 }
             }
         }

        excalidrawAPI?.addFiles(arrayFuckEx);
        await this.loadSelfImage(jsonObj?.files);

        await this.shitLoadWithScene(jsonObj,appState,szViewBackgroundColor,arrayFuckEx);
        //******load old******
        // const blob = new Blob([JSON.stringify(jsonObj)], {type: 'text/plain'})
        // await this.shitLoad(jsonObj,blob, appState,szViewBackgroundColor);
         //******load old******end

         excalidrawAPI.getApp().resetHistory();

         // console.log('myExcalidraw:',(Date.now() - nTime))
        //清空记录
        // let history = mapHistroy[id];
        // let isNew = false;
        // if (history == undefined) {
        //     history = new History();
        //     isNew = true;
        //     mapHistroy[id] = history;
        // }
        // excalidrawAPI.getApp().resetNewCanvasHistory(history, isNew);
    }

    loadSelfImage = async (arrayFiles:any)=>{
        if (!arrayFiles)return;
        const arrayKeys = Object.keys(arrayFiles);
        for (let i=0;i<arrayKeys.length;i++){
            const c = arrayFiles[arrayKeys[i]];
            await excalidrawAPI.getApp().createImageToCache(c.id,c.dataURL,c.mimeType,c.fullPath);
        }
    }

    /**
     * 先缓存别的画布的图片缓存.....
     */
    lazyLoadImage = async (arrayElements:any,arrayFiles:any)=>{
        if (!arrayElements)return;
        var arrayFuckEx = [];
        for (var i = 0; i < arrayElements.length; i++) {
            var ele = arrayElements[i];
            var c = arrayFiles[ele.fileId];
            if (c != undefined && c != null) {
                var item = {
                    mimeType: c.mimeType,
                    id: c.id,
                    dataURL: c.dataURL,
                    created: c.created,
                    lastRetrieved: c.lastRetrieved,
                    fullPath:c.fullPath
                }
                arrayFuckEx.push(item);

                await excalidrawAPI.getApp().createImageToCache(c.id,c.dataURL,c.mimeType,c.fullPath);
            }
        }
        excalidrawAPI.addFiles(arrayFuckEx);

    }


    //first 后...
    excalidrawFirstAfter = (api: any) => {
        excalidrawAPI = api;
        if (szFirstCanvasId != null) {
            // this.createFistHistory(szFirstCanvasId);
            szFirstCanvasId = null;
        }
        this.props?.parentOnExcalidrawInitComplete(api);
    }

    onPreviewImagesFromCanvas = (szCurrentId)=>{
        var arrayImageEles = [];
        const elements = excalidrawAPI.getSceneElements();
        let szFileId = '';
        for (var i=0;i<elements.length;i++){
            var item = elements[i];
            if ("image" === item.type){
                arrayImageEles.push(item);
                if (szCurrentId == item.id){
                    szFileId = item.fileId;
                }
            }
        }
        arrayImageEles.sort(((a, b) => {
            return a.update - b.update;
        }))



        let arrayNewImagesFiles = [];
        var files = excalidrawAPI.getFiles();
        for (var i=0;i<arrayImageEles.length;i++){
            var ele = arrayImageEles[i];
            var item = files[ele.fileId];
            if (item){
                let szFileName = item.id + '.'+extFromMineType(item.mimeType);
                if (item.fullPath){
                    item.src = getLocalFilePath(item.fullPath,true);
                }else{
                    item.src = getLocalFilePath(szFileName,false);
                }
                arrayNewImagesFiles.push(item);
            }
        }

        let nCurIndex = 0;
        for (var i=0;i<arrayNewImagesFiles.length;i++){
            var item = arrayNewImagesFiles[i];
            if (item.id === szFileId){
                nCurIndex = i;
                break;
            }
        }

        this.setState({
            isImagePreviewVisible: true,
            arrayImages:arrayNewImagesFiles,
            currentPreviewIndex:nCurIndex
        })
    }

    onUpdateMenu = ()=>{
    }
    onUpdateContextMenu = ()=>{

    }


    /*更新菜单位置更新菜单位置更新菜单位置更新菜单位置更新菜单位置更新菜单位置更新菜单位置  位置菜单 浮动菜单 位置*/
    onUpdateMenuPosition = (ele,x,y)=> {
        // console.log('onUpdateMenuPosition')
        if (!x || x === Number.MAX_VALUE){
            x = ele?.x;
        }
        if (!y || y === Number.MAX_VALUE){
            y = ele?.y;
        }
        if (isCanvasReadonly){
            this.setState({
                isShowMenu:false,
                isShowMoreMenu:false
            })
            return;
        }
        if (ele && ele.type != 'line' && (ele.width == 0 || ele.height == 0)){
            return;
        }
        var fRate = excalidrawAPI.getAppState().zoom.value;
        var fScrollX = excalidrawAPI.getAppState().scrollX * fRate;
        var fScrollY = excalidrawAPI.getAppState().scrollY * fRate;

        const menuHeight = this.state.arrayMoreMenus.length*menuItemHeight;
        const height = document.body.clientHeight;
        const width = document.body.clientWidth;

        let left = x * fRate + fScrollX;
        let top = (y * fRate - 72) + fScrollY;
        let moreTop = (ele?.y * fRate - 72) + fScrollY;
        let moreLeft = 30*4 + 18;

        if (ele?.type === 'image' && !ele?.extra?.svg){
            moreLeft += 34;
        }

        if (moreTop + menuHeight > height){
            moreTop = (moreTop + menuHeight) - height;
        }else{
            moreTop = 0;
        }
        if (top <= 0){
            top = 0;
        }

        if (mIsLeftMenuCollapse){
            if (left <= 0){
                left = 0;
            }
        }else{
            if (left <= 190){
                left = 190;
            }
        }

        if ((width - left) < 36*4){
            left = width-36*4;
        }

        if ((left + moreLeft + 140) > width){
            moreLeft = -90;
        }

        if (ele?.locked){
            moreLeft = 76;
        }

        if (isArrowElement(ele)){
            // const sss = sceneCoordsToViewportCoords({ sceneX: ele.x, sceneY: ele.y }, excalidrawAPI.getAppState());
            // if (sss.y - top < 100){
            //     top = sss.y - 100;
            // }
        }

        //带qiuck flow的。。。高一点。。。。
        if (ele){
            if (quickFlowElementsType.includes(this.state.mCurrentSelectedElement?.type) || isNoteElement(this.state.mCurrentSelectedElement)){
                // top -= 30;
            }
        }

        const nSelectElementLength = Object.keys(excalidrawAPI.getAppState().selectedElementIds).length + (ele?1:0);
        let isShowMenu = true;
        let isShowNoExistFileMenu = false;

        const nTimeoutId = setTimeout(()=>{
            if (isNoteElement(ele) && !ele.locked && Object.keys(excalidrawAPI.getAppState().selectedElementIds).length <= 1){
                isShowMenu = false;
            }
            if (isLinkAndNotExist(ele)){
                isShowMenu = false;
                //是视频文件。显示笔记注记
                if (isFileVideoElement(ele) && ele.videoNotes && ele.videoNotes.length > 0){
                    isShowNoExistFileMenu = true;
                }
            }

            const hoverModel = document.getElementById("hoverModel")!;
            if(hoverModel?.style?.display == "block" || excalidrawAPI.getApp().hasStartDragging()){
                isShowMenu = false;
            }
            if (isProjectLinkElement(ele)){
                if (ele.customData.isDeleted || ele.customData.isBoardDeleted){
                    isShowMenu = false;
                }
            }
            if (isMindmapElement(ele) && Object.keys(excalidrawAPI.getAppState().selectedElementIds).length == 0){
                isShowMenu = false;
            }
            if (this.isActiveToolDrawing()){
                isShowMenu = false;
            }
            // if (ele.boundElements){
            //     if (ele.boundElements.some(p=>p.id == excalidrawAPI.getAppState().editingElement?.id)){
            //         //框框里面的文本编辑状态下，不显示菜单
            //         isShowMenu = false;
            //     }
            // }

            if (ele?.locked){
                top += 20;
            }

            //这里额外判断，如果是连接线的话。加高...
            // 获取连接线的起点和终点的全局坐标
            if (ele == null){
                //比如连接线上选择字体的时候pointup会走这个，hitelement is null.
                const arraySelects = excalidrawAPI.getApp().getSelectedElements();
                if (arraySelects.length > 0){
                    ele = arraySelects[0];
                }
            }
            if (isArrowElement(ele)){
                const startPoint = LinearElementEditor.getPointAtIndexGlobalCoordinates(
                    ele,
                    0,
                );
                const endPoint = LinearElementEditor.getPointAtIndexGlobalCoordinates(
                    ele,
                    -1,
                );

                // 计算连接线的中点（用于定位菜单的水平位置）
                const midX = (startPoint[0] + endPoint[0]) / 2;

                // 获取两个连接点中最靠上的点（y值最小）
                // 这样可以确保菜单始终显示在连接线的上方，不管连接线是什么方向
                const topY = Math.min(startPoint[1], endPoint[1]);

                // 菜单应该显示在连接线上方，距离连接线一定距离
                // 使用连接线最靠上的点作为参考，确保菜单始终在上方
                // 这样可以避免遮挡连接线上的文字输入区域
                const menuOffsetY = -100; // 菜单距离连接线的垂直偏移（向上）

                // 将场景坐标转换为屏幕坐标
                const appState = excalidrawAPI.getAppState();
                const zoom = appState.zoom.value;
                const scrollX = appState.scrollX;
                const scrollY = appState.scrollY;

                // 使用连接线的中点x坐标，最靠上点的y坐标
                const screenX = (midX + scrollX) * zoom + appState.offsetLeft;
                const screenY = (topY + scrollY) * zoom + appState.offsetTop + menuOffsetY;

                left = screenX - 50;
                top = screenY;
            }

            //end.....
            if (nSelectElementLength > 0 || excalidrawAPI.getAppState().editingElement || (isFrameElement(ele) && ele.locked)){//为什么要加isframe这个条件，因为frame不能直接被选中，直接被选中的话里面的元素就没法直接从外面选中，所以只能这样让他显示锁定的菜单
                this.setState({
                    isShowMenu: isShowMenu,
                    isShowMoreMenu:false,
                    isShowFileNoExistMenu:isShowNoExistFileMenu,
                    isShowPopoverMoreMenu:false,
                    isShowPopoverLineType:false,
                    isShowEndArrowPopover:false,
                    isShowStartArrowPopover:false,
                    menuPosition: {
                        left: left + 'px',
                        top: top + 'px',
                        moreLeft:moreLeft+'px',
                        moreTop:-moreTop+'px'
                    }
                })
            }
        },50);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    /**
     * 单击事件
     * @param activityTool
     * @param pointerDownState
     */
    onPointerDown = (activityTool: any, pointerDownState: any) => {
        // console.log("***onPointerDown***");
        if (Date.now() - this.mLastPointerDown < 100){
            return;
        }
        this.mLastPointerDown = Date.now();

        //取消content中的选中
        if (window.onClearContentSelect){
            window.onClearContentSelect();
        }

        this.props.parentOnPointDown(activityTool,pointerDownState);// console.log(pointerDownState);
        const szActiveToolType = excalidrawAPI?.getAppState().activeTool.type;
        if (szActiveToolType == 'text' ||
            szActiveToolType == "image" ||
            szActiveToolType == "embeddable" ||
            szActiveToolType === "frame" ||
            szActiveToolType === 'selection'
        ){
            //todo  think about!!!!!!
            this.props.parentOnResetTool();
        }

        if (pointerDownState.hit.element != null && !pointerDownState.hit.element.isFrameBackgroundImage) {
            var ele = pointerDownState.hit.element;
            if (isMindmapElement(ele))return;//这里不要处理任何mindmap相关的任何东西....

            this.props.parentOnSelectElement(ele);

            this.setState({
                mCurrentSelectedElement:ele
            })
            isPointerDownPressed = true;

            this.setState({
                isShowMoreMenu:false,
                isShowContextMenu:false,
                isShowFileNoExistMenu:false
            })

            postMessage(EVENT_CANVAS_SELECT_IFRAME,ele.id);


            if (ele.type == 'image' && !ele.isFrameBackgroundImage) {
                var files = excalidrawAPI.getFiles();
                var item = files[ele.fileId];
                /*
                if (this.state.isReadOnlyStatus) {
                    if (ele.link == undefined) {
                        if (item != null && !ele.extra?.svg && !ele.locked) {
                            // this.setState({
                            //     isImagePreviewVisible: true,
                            //     imagePreviewData: item.dataURL
                            // })
                            this.onPreviewImagesFromCanvas(ele.id);
                        }
                    } else {
                        if (ipcRenderer != null) {
                            ipcRenderer.send("open-url", ele.link);
                        }
                    }
                } else */
                // if (!this.state.isReadOnlyStatus)
                {
                    const nowTime = new Date().getTime();
                    if (nowTime - lastTime < 300) {
                        if (item != null && !ele.extra?.svg) {
                            // this.setState({
                            //     isImagePreviewVisible: true,
                            //     imagePreviewData: item.dataURL
                            // })
                            this.onPreviewImagesFromCanvas(ele.id);
                        }
                    }
                }
            }
            else
            if (ele.type == "iframe"){
                if (this.state.isReadOnlyStatus){
                    if (isFileElement(ele) && !isFileVideoElement(ele)){
                        if (isPdfFileElement(ele)){
                            this.onMenuClick('open');
                        }else{
                            //文件并且非视频..
                            const nowTime = new Date().getTime();
                            if (nowTime - lastTime < 300) {
                                this.onMenuClick('open');
                            }
                        }
                    }else if (isPdfAnnoElement(ele) || isVideoAnnoElement(ele) || isCardAnnoElement(ele)){
                        this.setState({
                            mCurrentSelectedElement:ele
                        },()=>{
                            this.onMenuClick("open");
                        })

                    }else if (isFileVideoElement(ele) || isLiveVideoElement(ele)){
                        this.setState({
                            mCurrentSelectedElement:ele
                        },()=>{
                            this.onMenuClick('openVideoInSide');
                        })

                    }
                    else{
                        //打开笔记
                        this.props.parentOnEditNoteData(ele,true,'dialog');
                    }
                }
            }

            if (szActiveToolType != 'hand'){
                this.onSetContextMenu(ele);
                this.onUpdateMenuPosition(ele);
            }


            //只读模式下有链接的要跳转
            if (this.state.isReadOnlyStatus){
                if (isEmbeddableElement(ele)){
                    if (isEmbedableBookmarkElement(ele)){
                        ipcSend('open-url',ele.link);
                    }else{
                        excalidrawAPI.setActiveTool({type:'selection'});
                        const nTimeoutId = setTimeout(()=>{
                            excalidrawAPI.getApp().setState({
                                activeEmbeddable:{
                                    element:ele,
                                    state:"active"
                                },
                                selectedElementIds:{
                                    [ele.id]: true,
                                },
                            })
                        },100);
                        this.mArrayTimeoutIds.push(nTimeoutId);
                    }
                }
                if (ele.opacity != 0 && !isEmbeddableElement(ele)){//0 为 embeded 在frame预览设置的。它有问题，靠近frame的 embed 会显示，不知道为啥。。直接设置为0不可见。
                    this.onLinkOpenClick(ele.link);
                }
            }
        }else

        {
            this.setState({
                isShowMenu:false,
                isShowContextMenu:false,
                isShowFileNoExistMenu:false
            })
            postMessage(EVENT_CANVAS_SELECT_IFRAME,'');
        }

        lastTime = new Date().getTime();
        //关闭....
        window.closePopupCardList();

    }

    onPointerMove = (event)=>{
        // let selectEleIds = excalidrawAPI.getAppState().selectedElementIds;
        // if (this.state.isShowMenu && Object.keys(selectEleIds).length != 0){
        //     console.info("*****onpointermove***********");
        //     var elements = excalidrawAPI.getSceneElements();
        //     for(var i=0;i<elements.length;i++){
        //         var item = elements[i];
        //         if(excalidrawAPI.getAppState().selectedElementIds[item.id] != undefined){
        //             this.onUpdateMenuPosition(item);
        //             break;
        //         }
        //     }
        // }
        if (
            isPointerDownPressed &&
            (this.state.isShowMenu || this.state.isShowMoreMenu)
        ){
            this.setState({
                isShowMenu:false,
                isShowMoreMenu:false
            })
        }
    }

    onPointerUp = (event:any, hitElement: any,isMoving:any)=> {
        // console.log('onPointerUp...')
        isPointerDownPressed = false;
        var elements =  excalidrawAPI.getApp().visibleElements;//excalidrawAPI.getSceneElements();

        if (excalidrawAPI.getAppState().activeTool.type == 'mindmap'){
            //新建mindmap---
            return;
        }

        // const item = elements.filter(p=>!p.isFrameBackgroundImage && excalidrawAPI.getAppState().selectedElementIds[p.id] != undefined);
        // this.setState({
        //     mCurrentSelectedElement:item
        // })
        // this.onSetContextMenu(item);
        // this.onUpdateMenuPosition(item);

        let nMinYElement = null;
        let nMinX = Number.MAX_VALUE,nMinY = Number.MAX_VALUE;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (!item.isFrameBackgroundImage && excalidrawAPI.getAppState().selectedElementIds[item.id] != undefined) {
                if (nMinYElement == null){
                    nMinYElement = item;
                }else{
                    if (nMinYElement.y > item.y){
                        nMinYElement = item;
                    }
                }
                if (nMinX > item.x){
                    nMinX = item.x;
                }
                if (nMinY > item.y){
                    nMinY = item.y;
                }
            }
        }

        if (nMinYElement){
            this.setState({
                mCurrentSelectedElement:nMinYElement
            })
        }
        if (!hitElement){
            const arraySelectEle = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectEle.length <= 0){
                //清空选择
                this.setState({
                    mCurrentSelectedElement:null
                })
                excalidrawAPI.updateScene({
                    appState:{
                        selectedElementIds:{}
                    }
                })
            }
        }

        this.onSetContextMenu(hitElement);
        this.onUpdateMenuPosition(hitElement,nMinX,nMinY);

        if (this.state.mCurrentSelectedElement?.type == 'text'){
            postMessage(EVENT_UPDATE_FONT_SIZE,{fontSize:Math.floor(this.state.mCurrentSelectedElement.fontSize)});
        }

        this.props.parentOnPointerUp(event);

        //refresh menu
        this.setState({
            randomKey:generateUUID2()
        })

        //如果是多选----
        if (Object.keys(excalidrawAPI.getAppState().selectedElementIds).length > 1){
            //如果全部是文字，
            const arraySelectEle = excalidrawAPI.getApp().getSelectedElements();
            const nTextElement = arraySelectEle.filter(p=>isTextElement(p)).length;
            if (nTextElement == arraySelectEle.length){

            }else{
                this.onSetContextMenu({type:'multiply'});
            }
        }


        this.onUpdateElementForServer();

        //预览模式下--pointerdown会提前打开图片，就不能移动，所以换成up.
        var ele = hitElement;
        if (ele?.type == 'image' && !ele?.isFrameBackgroundImage) {
            var files = excalidrawAPI.getFiles();
            var item:any = files[ele.fileId];

            if (this.state.isReadOnlyStatus && !isMoving) {
                if (ele.link == undefined) {
                    if (item != null && !ele.extra?.svg && !ele.locked) {
                        // this.setState({
                        //     isImagePreviewVisible: true,
                        //     imagePreviewData: item.dataURL
                        // })
                        this.onPreviewImagesFromCanvas(ele.id);
                    }
                } else {
                    if (ipcRenderer != null) {
                        ipcRenderer.send("open-url", ele.link);
                    }
                }
            } else {
                // const nowTime = new Date().getTime();
                // if (nowTime - lastTime < 300) {
                //     if (item != null && !ele.extra?.svg) {
                //         // this.setState({
                //         //     isImagePreviewVisible: true,
                //         //     imagePreviewData: item.dataURL
                //         // })
                //         this.onPreviewImagesFromCanvas(ele.id);
                //     }
                // }
            }
        }

        if (isFrameElement(this.state.mCurrentSelectedElement)){
            setTimeout(()=>{
                if (excalidrawAPI.getAppState().selectedElementIds[this.state.mCurrentSelectedElement?.id]){
                    const element = this.state.mCurrentSelectedElement
                    this.onSetContextMenu(element);
                    this.onUpdateMenuPosition(element);

                    if (element.locked) {
                        this.onSetContextMenu(element);
                        this.onUpdateMenuPosition(element);
                    }

                    this.setState({
                        isShowMenu:true,
                        isFramePopoverOpen:false,
                        isShowStrokeColorPopup:false
                    })
                }
            },100)
        }

        //处理双击。。。--这样，那样。
        if (Date.now() - mLastUpdateTimeUp <= 300){
            if (isMindmapElement(hitElement)){
                //选中这个.
                excalidrawAPI.getApp().setSelectElements(hitElement);
                setTimeout(()=>{
                    this.onSetContextMenu(hitElement);
                    this.onUpdateMenuPosition(hitElement);
                },100);
            }
        }
        mLastUpdateTimeUp = Date.now();
    }

    /**
     * 右键菜单打开
     * @param x
     * @param y
     * @param element
     */
    onContextMenuOpen = async (x,y,element,canvasX,canvasY)=>{
        if (DEBUG){
            console.log('x:'+x+"   y:"+y);
        }

        mContextMenuPosition = {
            x:canvasX,
            y:canvasY
        }

        if (isCanvasReadonly)return;
        if (element?.isFrameBackgroundImage)return;
        if (excalidrawAPI.getAppState().activeTool.type == 'laser'){
            excalidrawAPI.updateScene({
                appState:{
                    selectedElementIds:{}
                }
            })
            return;
        }

        this.setState({
            mCurrentSelectedElement:element
        })

        var fRate = excalidrawAPI.getAppState().zoom.value;
        var fScrollX = excalidrawAPI.getAppState().scrollX * fRate;
        var fScrollY = excalidrawAPI.getAppState().scrollY * fRate;

        const arrayNewMenus = await this.onSetContextMenu(element);
        const menuHeight = (arrayNewMenus.filter(p=>p.label != MENU_SEPARATOR).length+1)*menuItemHeight;
        const height = document.body.clientHeight;
        if (y + menuHeight > height){
            y = height - menuHeight;
        }

        let hasShowContextMenu = true;
        if (isLinkAndNotExist(element)){
            hasShowContextMenu = false;
        }

        this.setState({
            isShowMenu:false,
            isShowMoreMenu:false,
            isShowStrokeColorPopup:false,
            isShowContextMenu: hasShowContextMenu,
            contextMenuPosition: {
                left: x + 'px',
                top: y + 'px'
            }
        })
    }

    onDrag = (event)=>{

    }


    /*双击事件*/
    onExcalidrawDoubleClick = (activeTools:any,selectElements:any)=>{
        if(selectElements != undefined && selectElements.length == 1){
            const element = selectElements[0];
            if ('iframe' == element.type){
                // ipcSend('open-url',element.customData?.generationData?.filePath);
                if (element.customData?.generationData?.type == 'file' ||
                    element.customData?.generationData?.type == 'pdfAnno' ||
                    element.customData?.generationData?.type == 'videoAnno' ||
                    element.customData?.generationData?.type == 'audioAnno' ||
                    element.customData?.generationData?.type == 'cardAnno'
                ){
                    if (!element.locked){
                        this.onMenuClick("open");
                    }
                }
                else if (isNoteElement(element)){
                    //设置可编辑.....
                    let customData = {...element.customData};
                    customData.generationData.isEditable = true;
                    postMessage(EVENT_ACTIVE_CARD_EDIT,{id:customData.generationData.id});
                    excalidrawAPI.getApp().onUpdateElement(element,customData)
                }
                else{
                    this.props.parentOnEditNoteData(element,false,'dialog');
                }
            }else if (isEmbeddableElement(element) && element.embedType != 'page' && !element.locked){
                ipcSend('open-url',element.link);
            }
        }
    }

    /**
     * 打开链接
     * @param link
     */
    onLinkOpenClick = async (link:string,isInSlider:any)=>{
        if(!isStringNullOrEmpty(link)){
            this.onSetReadonlyStatus(this.state.isReadOnlyStatus);

            var newLinkInfo = {};
            if (link.startsWith('{') && link.indexOf('noteey://open') >= 0){
                const jsonLink = JSON.parse(link);
                link = jsonLink.url;
            }
            if (isDeepLink(link)){
                const deeplink = decodeDeeplink(link);
                if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                    postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                        id: deeplink.id,
                        from: FROM_LIBRARY,
                        deeplink: deeplink,
                        selectedId: deeplink.childId,
                        inSlider: true,
                    })
                } else {
                    //如果是跳转到同一个项目第一个board
                    const linkInfo:any = await deepLinkToLinkInfo(deeplink);
                    linkInfo.isLink = true;
                    if (linkInfo.pageId == global.g_currentBoardId){
                        //在同一个board--，，直接转到就行了..
                        this.onScrollToElement(linkInfo.elementId,linkInfo.nodeId);
                    }else{
                        postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo:linkInfo,inSlider:isInSlider});
                    }
                }
                return;
                //deep link/判断类型，并打开...
                // const deeplink = decodeDeeplink(link);
                // if (deeplink.type == 'library'){
                //     const library = await window.methodGetNoteById(deeplink.id);
                //     //打开..
                //     if (deeplink.childType == 'card'){
                //         newLinkInfo.type = LINK_INFO_TYPE_NOTE;
                //         newLinkInfo.id = deeplink.id;
                //     }else if (deeplink.childType == 'pdf'){
                //         newLinkInfo.type = LINK_INFO_TYPE_PDF;
                //         newLinkInfo.id = deeplink.id;
                //         newLinkInfo.fileName = library.fileName;
                //     }else if (deeplink.childType == 'journal'){
                //         newLinkInfo.type = LINK_INFO_TYPE_JOURNAL;
                //         newLinkInfo.id = deeplink.id;
                //     }
                //     else{
                //         newLinkInfo.type = LINK_INFO_TYPE_FILE;
                //         newLinkInfo.id = deeplink.id;
                //         newLinkInfo.fileName = library.fileName;
                //     }
                // }else if (deeplink.type == 'project'){
                //     //表明是一个元素...
                //     //是否是当前项目的
                //     const isCurrentProject = PROJECT_ID == deeplink.id;
                //     if (deeplink.elementId){
                //         newLinkInfo.type = LINK_INFO_TYPE_ELEMENT;
                //         newLinkInfo.id = deeplink.id;
                //         newLinkInfo.pageId = deeplink.childId;
                //         newLinkInfo.elementId = deeplink.elementId;
                //     }else{
                //         newLinkInfo.type = LINK_INFO_TYPE_PAGE;
                //         newLinkInfo.id = deeplink.id;
                //         newLinkInfo.pageId = deeplink.childId;
                //     }
                //     newLinkInfo.isCurrentProject = isCurrentProject;
                // }
            }
            if (isCardBlockDeeplink(link)){
                const regex = /note=([a-zA-Z0-9-]+)&&blockid=([a-zA-Z0-9-]+)&&blocktype=([a-zA-Z0-9-]+)/
                const match = link.match(regex)
                // ======= 拦截自定义 noteeditor:// 协议 =======
                if (match) {
                    const noteid = match[1]
                    const blockid = match[2]
                    const blocktype = match[3]
                    document.dispatchEvent(new CustomEvent('blockLinkClick', {
                        detail: {
                            noteId: noteid,
                            blockId: blockid,
                            blockType: blocktype
                        }
                    }))
                }
                return;
            }
            if (Object.keys(newLinkInfo).length > 0){
                link = JSON.stringify(newLinkInfo);
            }

            if (link.indexOf("{") == 0){
                const linkInfo = JSON.parse(link);
                if(linkInfo.type == LINK_INFO_TYPE_PAGE || linkInfo.type == LINK_INFO_TYPE_ELEMENT){
                    this.props.parentOnLinkNav(linkInfo);
                }else if(linkInfo.type == LINK_INFO_TYPE_NOTE){
                    // this.props.parentOnLinkNav(linkInfo);
                    //侧边栏打开note
                    postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {data:{id:linkInfo.id},scrollRate:0});
                }else if (linkInfo.type == LINK_INFO_TYPE_JOURNAL){
                    //日记
                }
                else if(linkInfo.type == LINK_INFO_TYPE_URL){
                    //外部打开...
                    let szUrl = linkInfo.url;
                    if (/^\w:\\/.test(szUrl) || szUrl.indexOf('/') == 0){//本地路径？？？、

                    }else{
                        // if (szUrl.indexOf("http") != 0){
                        //     szUrl = "https://"+linkInfo.url;
                        // }
                    }
                    if (APP_WEB || APP_WEB_WWW){
                        window.open(szUrl,'_blank');
                    }else{
                        ipcInvoke("open-url-withwhen", szUrl).then(res=>{
                            if (res){
                                message.error(t('Open fail'))
                            }
                        })
                    }

                }else if (linkInfo.type == LINK_INFO_TYPE_FRAME){
                    if (!isCanvasReadonly){
                        //非预览
                        message.info(i18n.t("Link to frame only be"));
                        return;
                    }else{
                        //frame 预览....
                        this.props.parentOnLinkNav(linkInfo);
                    }
                }else if (linkInfo.type == LINK_INFO_TYPE_PDF){
                    //侧边栏打开pdf
                    let szFilePath = localStorage.getItem(KEY_FILE_DIR) + linkInfo.fileName;
                    if (checkIfAbsolute(linkInfo.fileName)){
                        szFilePath = linkInfo.fileName;
                    }
                    ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=> {
                        const blob = new Blob([res]);
                        const url = URL.createObjectURL(blob);
                        postMessage(EVENT_PDF_ON_SLIDER_RIGHT,{pdfPath:url,fileId:linkInfo.id,fileName:linkInfo.url??getFileName(linkInfo.fileName),pdfFileName:linkInfo.fileName});
                    })
                }else if (linkInfo.type == LINK_INFO_TYPE_FILE){
                    if (APP_WEB || APP_WEB_WWW){
                        const szUrl = getShareDataUrl() + this.state.projectId + "/notesfile/"+ linkInfo.fileName;
                        this.downloadFile(szUrl);
                    }else if (isWebApp()){
                        this.downloadFile(linkInfo.fileName);
                    }
                    else{
                        const szFilePath = localStorage.getItem(KEY_FILE_DIR) + linkInfo.fileName;
                        ipcInvoke('open-url-withwhen',szFilePath).then(res=>{
                            if (res == 'error'){
                                message.error(t("Open error"));
                            }
                        })
                    }
                }
            }
            else{
                //外部打开...
                let szUrl = link;

                if (isWeb()){
                    if (!szUrl.startsWith('http')){
                        szUrl = 'https://'+szUrl;
                    }
                    window.open(szUrl);
                }else{
                    if (isAbsoluteFilePath(link) || isSupportLink(link)){
                        ipcInvoke('open-url-withwhen',decodeURIComponent(szUrl));
                    }else{
                        if (!szUrl.startsWith('http')){
                            szUrl = 'https://'+szUrl;
                        }
                        ipcSend("open-url", szUrl)
                    }
                }
            }
        }
    }

    /**
     * 右键菜单
     * @param ele
     */
    onSetContextMenu = async (ele:any)=>{
        // console.log('onSetContextMenu:'+ele.type);
        const arraySelectEle = excalidrawAPI.getApp().getSelectedElements();

        let arrayNewMenus = [];
        if (ele === null && arraySelectEle.length <= 1){
            arrayNewMenus = this.getEmptyMenuList();
        }else{
            if (ele?.type == 'multiply' || arraySelectEle.length > 1){
                ele = {type:'multiply'}
            }

            if (ele?.type == 'image') {
                arrayNewMenus = await this.getImageMenuList(ele);
            }
            else if (isPdfFileElement(ele)){
                arrayNewMenus = this.getPdfFileMenuList(ele);
            }
            else if (isFileElement(ele)){
                arrayNewMenus = this.getFileMenuList(ele);
            }
            else if (isMindmapElement(ele)){
                arrayNewMenus = this.getMindmapMenuList(ele);
            }else if (isStickyNotesElement(ele)){
                arrayNewMenus = this.getSticknotesMenuList(ele);
            }
            else if (ele.type == "iframe"){
                if (ele.customData?.generationData?.type == 'file'){
                    arrayNewMenus = this.getIFrameMenuList(ele);
                }else if (ele.customData?.generationData?.type == 'pdfAnno'){
                    if (ele.customData.generationData.pdfData.type == 'image'){
                        arrayNewMenus = this.getPdfAnnoImageMenuList();
                    }else{
                        arrayNewMenus = this.getPdfAnnoTextMenuList();
                    }
                }else if (ele.customData?.generationData?.type == 'videoAnno'){
                    arrayNewMenus = this.getVideoAnnoTextMenuList();
                }else if (ele.customData?.generationData?.type == 'audioAnno'){
                    arrayNewMenus = this.getAudioAnnoTextMenuList();
                }else if (ele.customData?.generationData?.type == 'cardAnno'){
                    arrayNewMenus = this.getCardAnnoTextMenuList();
                }
                else{
                    arrayNewMenus = this.getNoteMenuList(ele);
                }
            }else if (ele.type === 'text'){
                arrayNewMenus = this.getTextMenuList(ele)
            }else if (ele.type == 'freedraw'){
                arrayNewMenus = this.getFreedrawMenuList()
            }else if (ele.type == "ellipse" ||
                ele.type == 'rectangle' ||
                ele.type == 'diamond' ||
                ele.type == 'roundedRectangle' ||
                ele.type == 'bubble' ||
                ele.type == 'parallelogram' ||
                ele.type == 'pentagram' ||
                ele.type == 'thickArrow'){
                arrayNewMenus = this.getShapeMenuList()
            }else if (ele.type == 'frame'){
                arrayNewMenus = this.getFrameMenuList(ele);
            }else if (ele.type == 'multiply'){
                arrayNewMenus = this.getMultilpyMenuList();
            }else if (ele.type == 'arrow' || ele.type == 'line'){
                arrayNewMenus = this.getLinearlineMenuList()
            }else if (isSupportVideoAnnoUrl(ele.link) || isFileVideoElement(ele)){
                arrayNewMenus = this.getVideoMenuList(ele);
            }else if (isProjectLinkElement(ele)){
                arrayNewMenus = this.getProjectlinkMenuList(ele);
            }else if (isEmbeddableElement(ele)){
                arrayNewMenus = await this.getEmbedMenuList(ele);
            }
            else{
                arrayNewMenus = this.getDefaultMenuList()
            }
        }

        //从原始元素中更新下这个
        let selectEle = null;

        if (arraySelectEle.length > 0){
            selectEle = arraySelectEle[0];
        }

        if (selectEle?.groupIds?.length > 0){
            for (let i=0;i<arrayNewMenus.length;i++){
                let item = arrayNewMenus[i];
                if (item.id == 'group'){
                    item.id = 'ungroup';
                    item.icon = "menu_ungroup.png";
                    item.label = i18n.t("Ungroup");
                }
            }
        }

        //是否有align
        if (this.targetElements().length > 1){
            arrayNewMenus.push({id:'align', icon:'menu_layer.png',label:i18n.t("Align")},)
        }

        this.setState({
            arrayMoreMenus: arrayNewMenus
        })
        return arrayNewMenus;
    }

    /**
     * 打开元素
     * @param element
     */
    onOpenAnnoElement = async (element:any)=>{
        let szFilePath = localStorage.getItem(KEY_FILE_DIR) + element.customData.generationData.fileName;
        if (isPdfAnnoElement(element)){
            let dbPdf = await getCardById(element.customData.generationData.id);
            if (dbPdf?.type == 'pdfAnno'){
                dbPdf = await getCardById(dbPdf.libraryId);
                if (dbPdf){
                    element.customData.generationData.id = dbPdf.id;
                    const customData = {...element.customData};
                    customData.generationData.id = dbPdf.id;
                    mutateElement(element,{customData:customData});
                }
            }
            if (dbPdf){
                if (dbPdf.isAbsolutePath){
                    szFilePath = dbPdf.fileName;
                }else{
                    szFilePath = localStorage.getItem(KEY_FILE_DIR) + dbPdf.fileName;
                }
            }
        }

        if (checkIfAbsolute(element.customData.generationData.fileName)){
            szFilePath = element.customData.generationData.fileName;
        }

        if (isPdf(szFilePath)){
            let szId = element.customData.generationData.id;
            //如果这个ID存在文件，使用这个ID,否则使用element.id
            if (!isWebApp()){
                const isFileExist = await ipcInvoke('is-file-exist',{filePath:szFilePath});
                if (!isFileExist){
                    szId = element.id;
                }
            }
            //注记数据，如果有的话....
            mOpenPdfData = element.customData.generationData.pdfData;
            this.props.parentOnOpenPdfFile(szId,szFilePath,element.customData.generationData.name || element.customData.generationData.showName,'slider');
        }else if (isVideoAnnoElement(element) || isAudioAnnoElement(element)){
            //视频注记--打开这个
            const highlight:any = await dbGetHighlight(element.customData?.generationData?.id);
            let szElementType = "embeddable";
            if (highlight.type == 'video' || highlight.type == 'audio'){
                szElementType = 'iframe';
            }
            if (highlight){
                const element00000000 = {
                    id:highlight.id,
                    name:highlight.name,
                    type:szElementType,
                    customData:{
                        generationData:{
                            type:'file',
                            id:highlight.libraryId,
                            name:highlight.name,
                            fileName:highlight.fileName
                        }
                    },
                    link:highlight.url,
                    src:highlight.url,
                    videoNotes:highlight.data,
                    selectedId:element.customData?.generationData?.videoData?.id//element.id
                }
                postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT, {videoNotes: {element: element00000000},breadcrumb:createBreadcrumb('highlight',highlight.name)})
            }else{

            }
        }else if (isCardAnnoElement(element)){
            //卡片...
            this.props.parentOnEditNoteData(element,false,'slider');
        }else if (isMdFileElement(element)){
            //markdown 文件，不需要操作。。。。
            excalidrawAPI.updateScene({
                appState:{
                    activeEmbeddable:{
                        element:element,
                        state:'active'
                    }
                }
            })
        }
        else{
            ipcInvoke('open-url-withwhen',szFilePath).then(res=>{
                if (res == 'error'){
                    message.error(t("Open error"));
                }
            })
        }
    }

    /*菜单点击*/
    onMenuClick =  async (action:any)=>{
        // console.log('onmenuclick....')
        var isHiddenMenu = true;
        var isHiddenMoreMenu = true;
        if ("duplicate" == action){
            excalidrawAPI.getApp().executeContextMenuAction("duplicateSelection");
            if (this.state.mCurrentSelectedElement?.type == 'frame'){
                const nTimeoutId = setTimeout(()=>{
                    postMessage(EVENT_UPDATE_FRAME_LIST);
                },100);
                this.mArrayTimeoutIds.push(nTimeoutId);
            }
        }else if ("link" == action){
            excalidrawAPI.getApp().executeContextMenuAction("hyperlink")
        }else if ("delete" == action){
            //删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除删除
            //如果是mindmap
            var selectEle = this.onGetCurrentSelectedElement();

            if (this.state.mCurrentSelectedElement?.type == 'mindmap' || isMindmapElement(selectEle)){
                // window.showMessageBox(t("Tips"),t("DeleteTheMindmap"),t("Cancel"),t("Delete"),null,async ()=>{
                //
                // });

                postMessage(EVENT_MINDMAP_REMOVE_ATTACH,{node:{isRoot:true,uid:this.state.mCurrentSelectedElement?.id},command:'REMOVE_NODE'});

            }else if (isImageElement(selectEle)){
                const szTrue = localStorage.getItem(KEY_DONOT_SHOW_REMOVE_IMAGE_TIP) || 'false';
                if (szTrue !== 'true'){
                    const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
                    const nImageCount = arraySelectedElements.filter(p=>isImageElement(p)).length;
                    //图片...
                    window.showMessageBox(t("Remove image"),nImageCount>1?t('SureToRemoveImages'):t("SureToRemoveImage"),t("Cancel"),t("Remove"),null,()=>{
                        excalidrawAPI.getApp().executeContextMenuAction("deleteSelectedElements");
                        this.setState({
                            isShowMenu:false
                        })
                    })
                }else{
                    excalidrawAPI.getApp().executeContextMenuAction("deleteSelectedElements");
                    this.setState({
                        isShowMenu:false
                    })
                }
            }
            else{
                excalidrawAPI.getApp().executeContextMenuAction("deleteSelectedElements");
                this.setState({
                    isShowMenu:false
                })

                //删除
                if (isWebApp()){
                    apiDeleteElement(this.state.mCurrentSelectedElement?.id);
                }
            }
            //左侧栏也删除...
            // const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();

            //如果是frame-刷新菜单
            // if (mCurrentSelectedElement?.type == 'frame'){
            //     postMessage(EVENT_UPDATE_FRAME_LIST);
            // }
        }else if ("cut" == action){
            excalidrawAPI.getApp().executeContextMenuAction("cut")
            this.setState({
                isShowMenu:false
            })
            if (this.state.mCurrentSelectedElement?.type == 'frame'){
                const nTimeoutId = setTimeout(()=>{
                    postMessage(EVENT_UPDATE_FRAME_LIST);
                },100);
                this.mArrayTimeoutIds.push(nTimeoutId);
            }
        }else if ("copy" == action){
            if (this.state.mCurrentSelectedElement?.type == 'image'){
                //图片复制为image....
                excalidrawAPI.getApp().executeContextMenuAction("copyAsPng");
            }else{
                excalidrawAPI.getApp().executeContextMenuAction("copy");
            }

        }else if ("lock" == action){
            if (this.state.mCurrentSelectedElement.locked){
                excalidrawAPI.getApp().executeContextMenuAction("toggleElementLock")
            }else{
                excalidrawAPI.getApp().executeContextMenuAction("toggleElementLock")
            }
            this.setState({
                isShowMenu:false
            })
        }else if ("wordCount" == action){
            var selectEle = this.onGetCurrentSelectedElement();
            if (selectEle != undefined){
                dialogWordCountRef.onShowDialog(selectEle.originalText || selectEle.value);
            }
            isHiddenMoreMenu = true;
        }else if ("copy_to_clipboard" === action){
            var selectEle:any= this.onGetCurrentSelectedElement();
            let bCopyed = false;
            if (isImageElement(selectEle)){
                const files = excalidrawAPI.getFiles();
                const file = files[selectEle.fileId];
                if (file.fullPath){
                    copyImageFullPathToClipboard(file.fullPath);
                    bCopyed = true;
                    message.info(t("copyToClipboardAsPng1"))
                }
            }
            if (!bCopyed){
                excalidrawAPI.getApp().executeContextMenuAction("copyAsPng")
            }

        }else if ("copy_to_svg" == action){
            excalidrawAPI.getApp().executeContextMenuAction("copyAsSvg")
        }else if ("copy_pdfanno_to_clipboard" == action){
            const blob = base64ToBlob(this.state.mCurrentSelectedElement.customData.generationData.pdfData.image,'image/png');
            const clipboardItemInput = new ClipboardItem({ 'image/png': blob });
            navigator.clipboard.write([clipboardItemInput]);
        }else if ("copy_pdfanno_to_svg" == action){
            const szSvg = base64ImgToSVGSimple(this.state.mCurrentSelectedElement.customData.generationData.pdfData.image);
            clipboard.write(szSvg);
        }else if ("download_pdfanno_as_png" == action){
            const imageDataUri = this.state.mCurrentSelectedElement.customData.generationData.pdfData.image.split(',')[1];
            ipcSend("saveFile", {filters: [{name: 'Image', extensions: ['png']}], stream: imageDataUri,streamType:'image',fileName:this.state.mCurrentSelectedElement.customData.generationData.pdfData.name});
        }
        else if ("download" == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectedElements.length == 1){
                //保存到本地
                var selectEle = this.onGetCurrentSelectedElement();
                if (selectEle != undefined){
                    if (selectEle.customData?.generationData?.isAbsolutePath){
                        const szImgBase64 = await ipcInvoke('read-file-base64',{filePath:selectEle.customData?.generationData?.fileName})
                        ipcSend("saveFile", {filters: [{name: 'Image', extensions: ['png']}], stream: szImgBase64,streamType:'image'});
                    }else{
                        var file = excalidrawAPI.getFiles()[selectEle.fileId];
                        if (file != undefined){
                            let szFilePath = localStorage.getItem(KEY_FILE_DIR)+file.id+'.'+extFromMineType(file.mimeType);

                            if (file.fullPath){
                                szFilePath = file.fullPath;
                            }
                            const szImgBase64 = await ipcInvoke('read-file-base64',{filePath:szFilePath})
                            const imageDataUri = szImgBase64;//file.dataURL.split(',')[1];
                            ipcSend("saveFile", {filters: [{name: 'Image', extensions: ['png']}], stream: imageDataUri,streamType:'image'});
                        }
                    }

                }
            }else{
                let zip = new JSZip();
                for (let i=0;i<arraySelectedElements.length;i++){
                    var file = excalidrawAPI.getFiles()[arraySelectedElements[i].fileId];
                    if (file != undefined) {
                        const mineType = file.dataURL.split(';')[0];
                        const ext = mineType.replace('data:image/','');
                        zip.file(Date.now() +'.'+ext,base64ToBlob(file.dataURL,'image/'+ext),{});
                    }
                }

                zip.generateAsync({type:"blob"}).then(function (content){
                    saveAs(content,Date.now() +'.zip');
                });
            }
        }else if ("flip_horizontal" == action){
            excalidrawAPI.getApp().executeContextMenuAction("flipHorizontal")
        }else if ("flip_vertical" == action){
            excalidrawAPI.getApp().executeContextMenuAction("flipVertical")
        }else if ("replace" === action){
            excalidrawAPI.getApp().executeContextMenuAction("replaceSelection")
        }else if ("crop" === action){
            excalidrawAPI.getApp().onShowCropImage(this.state.mCurrentSelectedElement);
        }else if ("paste" === action){
            excalidrawAPI.getApp().focusContainer();
            let nTimeoutId = setTimeout(()=>{
                // excalidrawAPI.getApp().executeContextMenuAction("paste",true);
                // excalidrawAPI.getApp().pasteFromClipboard();
                document.execCommand('paste');//
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);

            nTimeoutId = setTimeout(()=>{
                postMessage(EVENT_UPDATE_FRAME_LIST);
            },200);
            this.mArrayTimeoutIds.push(nTimeoutId);
        }else if ("selectAll" === action){
            excalidrawAPI.getApp().executeContextMenuAction("selectAll",true)
        }else if("changeBackgroundImage" == action){
            excalidrawAPI.getApp().executeContextMenuAction("changeBackgroundImage")
        }else if ("selectAllElementsInFrame" == action){
            excalidrawAPI.getApp().executeContextMenuAction("selectAllElementsInFrame",false);
            const nTimeoutId = setTimeout(()=>{
                excalidrawAPI.getApp().focusContainer();
            },100);
            this.mArrayTimeoutIds.push(nTimeoutId);
        }else if ("open" == action){
            //打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开打开
            if (APP_WEB){
                if (isPdfFileElement(this.state.mCurrentSelectedElement)){
                    let szId = this.state.mCurrentSelectedElement.customData.generationData.id;
                    const szUrl = getShareDataUrl() + this.state.projectId + "/notesfile/"+ encodeURIComponent(this.state.mCurrentSelectedElement.customData.generationData.fileName);
                    if (isPdfFileElement(this.state.mCurrentSelectedElement)){
                        //侧栏打开PDF。
                        this.props.parentOnOpenPdfFile(szId,szUrl,this.state.mCurrentSelectedElement.customData.generationData.name || this.state.mCurrentSelectedElement.customData.generationData.showName,'slider');
                    }else{
                        this.downloadFile(szUrl);
                    }
                }else if (isVideoAnnoElement(this.state.mCurrentSelectedElement)){
                    //注记...
                    const library:any = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id);
                    if (library){
                        if (isLiveVideoType(library.type)){
                            const arrayAnnos:any = await getCardListByLibraryId(library.id);
                            let szElementType = "embeddable";
                            if (library.type == 'video' || library.type == 'audio'){
                                szElementType = 'iframe';
                            }
                            const highlight:any = library;
                            if (highlight) {
                                const element = {
                                    id: highlight.id,
                                    name: highlight.name,
                                    type: szElementType,
                                    customData: {
                                        generationData: {
                                            type: 'file',
                                            id: highlight.id,
                                            name: highlight.name,
                                            fileName: highlight.fileName
                                        }
                                    },
                                    link: highlight.url || highlight.fileName,
                                    src: highlight.url || highlight.fileName,
                                    videoNotes: arrayAnnos,
                                    selectedId: this.state.mCurrentSelectedElement.customData?.generationData?.videoData?.id//this.state.mCurrentSelectedElement.id
                                }
                                postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT, {
                                    videoNotes: {element: element},
                                    // breadcrumb: createBreadcrumb('highlight', highlight.name)
                                })
                            }
                        }
                    }
                }
            }else if (isWebApp()){
                this.downloadFile(this.state.mCurrentSelectedElement.customData.generationData.fileName);
            }
            else{
                if (APP_WEB_WWW){
                    if (isPdfAnnoElement(this.state.mCurrentSelectedElement) ||
                        isFileVideoElement(this.state.mCurrentSelectedElement) ||
                    // isVideoAnnoElement(this.state.mCurrentSelectedElement) ||
                    isAudioFileElement(this.state.mCurrentSelectedElement) ||
                    isAudioAnnoElement(this.state.mCurrentSelectedElement) ||
                    isPdfFileElement(this.state.mCurrentSelectedElement)){
                        window.showTipNotSupportWebOfflineVersion();
                        return;
                    }
                }
                setTimeout(async ()=>{
                    this.onOpenAnnoElement(this.state.mCurrentSelectedElement)
                },100)
            }

        }else if ('openInDefaultApp' == action){
          //使用默认应用打开...
            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + this.state.mCurrentSelectedElement.customData.generationData.fileName;
            if (this.state.mCurrentSelectedElement.customData.generationData.isAbsolutePath){
                szFilePath = this.state.mCurrentSelectedElement.customData.generationData.fileName;
            }
            ipcInvoke('open-url-withwhen',szFilePath);
        }else if ('downloadFile' == action){
            if (APP_WEB || APP_WEB_WWW){
                const szUrl = getShareDataUrl() + this.state.projectId + "/notesfile/"+ this.state.mCurrentSelectedElement.customData.generationData.fileName;
                this.downloadFile(szUrl);
            }else {
                //
                let szFilePath = localStorage.getItem(KEY_FILE_DIR) + this.state.mCurrentSelectedElement.customData.generationData.fileName;
                if (this.state.mCurrentSelectedElement.customData.generationData.isAbsolutePath){
                    szFilePath = this.state.mCurrentSelectedElement.customData.generationData.fileName;
                }
                ipcSend('saveFile', {
                    filters: [{name: "All file", extensions: ['*']}],
                    filePath: szFilePath,
                    fileName: getFileName(szFilePath)
                })

                // const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
                // if (arraySelectedElements.length == 1){
                //
                // }else{
                //     //zip....
                // }

            }
        }else if ("showInSystemExporler" == action){
            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + this.state.mCurrentSelectedElement.customData.generationData.fileName;
            if (this.state.mCurrentSelectedElement.customData.generationData.isAbsolutePath){
                szFilePath = this.state.mCurrentSelectedElement.customData.generationData.fileName;
            }
            ipcSend("show-in-exporler",szFilePath)
        }else if ("ocr" == action){
            if (hasLicense()){
                var selectEle = this.onGetCurrentSelectedElement();
                if (selectEle != undefined){
                    var file = excalidrawAPI.getFiles()[selectEle.fileId];
                    if (file != undefined){
                        const szFilePath = localStorage.getItem(KEY_FILE_DIR)+file.id+'.'+extFromMineType(file.mimeType);
                        const szImgBase64 = await ipcInvoke('read-file-base64',{filePath:szFilePath})
                        const imageDataUri = szImgBase64;//file.dataURL.split(',')[1];
                        this.props.parentOnShowTip("ocrResult","",imageDataUri);
                    }
                }
            }else{
                //显示vip界面.....
                this.props.parentOnShowTip("ocr",t("OCR"),t("UseOcrToPrecisely"));
            }
        }else if ('note' == action){
            //直接在画布上创建
            if (!hasLicense() && !isFreeCreateCardMode() && !hasDesktopBaseLicense()){
                getCardCount().then(nCount=>{
                    if (nCount > MAX_CARD_COUNT){
                        window.showMessageBox(i18next.t("Upgrade required"),i18next.t("YouNeedToUpgradeCreateCard"),i18next.t("Cancel"),i18next.t("Learn more"),null,()=>{
                            if (isZh()) {
                                ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                            }else {
                                ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                            }
                        })
                    }else{
                        excalidrawAPI.getApp().insertNoteElement(mContextMenuPosition.x,mContextMenuPosition.y)
                    }
                })
            }else{
                excalidrawAPI.getApp().insertNoteElement(mContextMenuPosition.x,mContextMenuPosition.y)
            }
            // excalidrawAPI.getApp().insertNoteElement(mContextMenuPosition.x,mContextMenuPosition.y)
        }else if ('text' == action){
            this.onSetActiveTool('text')
        }else if ('mindmap' == action){
            // this.onSetActiveTool('mindmap')
            excalidrawAPI.getApp().insertMindmap();

            //插入思维导入图延迟保存.---在右侧栏打开的项目不保存可能有问题.太多点了
            setTimeout(()=>{
                this.props.parentOnSaveNotes();
            },200)
        }else if ('openNoteInPopup' == action){
            //open note
            this.props.parentOnEditNoteData(this.state.mCurrentSelectedElement,false,'dialog',true,false);
        }else if ('openNoteInSide' == action){
            //open note
            this.props.parentOnEditNoteData(this.state.mCurrentSelectedElement,false,'slider');
        }else if ('openInFullScreen' == action){
            // Global.g_currentNoteFullScreen = true;
            // Global.g_isCurrentNoteFullScreenInCanvas = true;
            // triggerEvent('set-fullscreen-atom--------', true);
            // openEditor(this.state.mCurrentSelectedElement?.customData?.generationData.id);
            window.navigate(getCardPath(),{cardId:this.state.mCurrentSelectedElement?.customData?.generationData?.id})
        }else if('hideFromLibrary' == action){
            const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                element.customData.generationData.isHidden = 1;
                const card:any = await getCardById(element.customData.generationData.id);
                card.isHidden = 1;
                await updateCard(card);
            }
            postMessage(EVENT_REFRESH_LIBRARY_LIST);

            // if (this.state.mCurrentSelectedElement){
            //     this.state.mCurrentSelectedElement.customData.generationData.isHidden = 1;
            //     getCardById(this.state.mCurrentSelectedElement.customData.generationData.id)?.then(res=>{
            //         res.isHidden = 1;
            //         updateCard(res).then(r=>{
            //             postMessage(EVENT_REFRESH_LIBRARY_LIST);
            //         });
            //     })
            // }
        }else if ('deleteFromLibrary' == action){
            window.showMessageBox(t("Tips"),t("SureToDeleteTheCard"),t("Cancel"),t("Delete"),null,()=>{
                const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
                for (let i=0;i<arraySelectedElements.length;i++){
                    const element = arraySelectedElements[i];
                    // excalidrawAPI.getApp().removeElementById(element.id);
                    global.g_arrayRemovedFromLibraryIds.push(element.id);
                    getCardById(element.customData?.generationData?.pdfData?.id || element.customData?.generationData?.videoData?.id || element.customData?.generationData?.id)?.then((res:any)=>{
                        if (res){
                            res.isDeleted = 1;
                            updateCard(res).then(ress=>{
                                postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                postMessage(EVENT_FAVIRIATE_CHANGE);
                                postMessage(EVENT_REFRESH_RECENTS);
                            });

                            //也删除highlight中的..
                            dbGetHighlight(res.id).then(ress=>{
                                if (ress){
                                    ress.isDeleted = 1;
                                    ress.deleteTime = res.deleteTime;
                                    updateHighlight(ress);
                                }
                            })

                            //删除这个card所关联的项目
                            // deleteAllCardFromRefProject(item);

                            //如果是视频注记，高亮删除也要更新
                            if (res.type == 'videoAnno' || res.type == 'audioAnno'){
                                dbGetHighlight(res.libraryId || res.id).then(r=>{
                                    if (r){
                                        //删除这个注记
                                        const nIndex = r.data.findIndex(p=>p.id == res.id);
                                        if (nIndex != -1){
                                            r.data.splice(nIndex,1);
                                            updateHighlight(r);
                                        }
                                    }
                                })
                            }

                            //pdf注记删除，高亮删除也更新.
                            if (res.type == 'pdfAnno'){
                                ipcInvoke('remove-one-annotations',{id:res.id,pdfId:res.libraryId})
                            }else if (res.type == 'cardAnno'){
                                //移除卡片上的注记，如果右侧栏打开的情况下，还要更新右侧栏当前卡片的注记
                                if (window[`removeCardHighlight_${res.libraryId}`]){
                                    window[`removeCardHighlight_${res.libraryId}`](res);
                                }else{
                                    window.removeCardHighlight(res,()=>{
                                        postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                    });
                                }

                            }
                        }
                    })
                }
                excalidrawAPI.getApp().executeContextMenuAction("deleteSelectedElements");
                postMessage(EVENT_DELETE_LEFT_CARD_BAT,{elements:arraySelectedElements});
                this.hidePopupMenu();

                // if (this.state.mCurrentSelectedElement){
                //     excalidrawAPI.getApp().removeElementById(this.state.mCurrentSelectedElement.id);
                //     postMessage(EVENT_DELETE_LEFT_CARD,{id:this.state.mCurrentSelectedElement.customData.generationData.id});
                //     getCardById(this.state.mCurrentSelectedElement.customData.generationData.id)?.then(res=>{
                //         res.isDeleted = 1;
                //         updateCard(res);
                //     })
                // }
            })
        }else if('visibleFromLibrary' == action){
            const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                element.customData.generationData.isHidden = 0;
                const card:any = await getCardById(element.customData.generationData.id);
                card.isHidden = 0;
                await updateCard(card);
            }
            postMessage(EVENT_REFRESH_LIBRARY_LIST);
            // if (this.state.mCurrentSelectedElement){
            //     this.state.mCurrentSelectedElement.customData.generationData.isHidden = 0;
            //     getCardById(this.state.mCurrentSelectedElement.customData.generationData.id)?.then(res=>{
            //         res.isHidden = 0;
            //         updateCard(res).then(r=>{
            //             postMessage(EVENT_REFRESH_LIBRARY_LIST);
            //         });
            //     })
            // }
        }else if ('fold' == action){
            //折叠
            const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
            const arrayIds = []
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                if (isNoteElement(element)){
                    const customData = {...element.customData};
                    customData.generationData.originHeight = element.height;
                    customData.generationData.isExpand = false;
                    excalidrawAPI.getApp().onUpdateElement(element, {height: DEFAULT_TOOLBAR_HEIGHT+ 4, customData})
                    // postMessage(EVENT_RESIZING_CARD,{element:element})
                    //这里处理连线问题....
                    if (element.boundElements){
                        excalidrawAPI?.getApp().updateBoundElements(element);
                    }
                    arrayIds.push(element.id);
                }
            }
            postMessage(EVENT_CANVAS_EXPAND_STATS_CHANGED,{isExpand:false,ids:arrayIds})
        }else if ('unfold' == action){
            //展开
            const arrayIds = []
            const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                if (isNoteElement(element)){
                    const customData = {...element.customData};
                    customData.generationData.isExpand = true;
                    let nDefaultHeight = element.customData.generationData.originHeight || 0;
                    if (nDefaultHeight < 50) {
                        nDefaultHeight = 180;
                    }
                    element.height = nDefaultHeight;

                    excalidrawAPI.getApp().onUpdateElement(element, {height: nDefaultHeight, customData})
                    // postMessage(EVENT_RESIZING_CARD,{element:element})
                    //这里处理连线问题....
                    if (element.boundElements){
                        excalidrawAPI?.getApp().updateBoundElements(element);
                    }
                    arrayIds.push(element.id);
                }
            }
            postMessage(EVENT_CANVAS_EXPAND_STATS_CHANGED,{isExpand:true,ids:arrayIds})
        }else if('exportPdf' == action){
            //导出pdf
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            const arrayCards:any = [];
            for (let i=0;i<arraySelectedElements.length;i++){
                if (isNoteElement(arraySelectedElements[i])){
                    const card = await getCardById(arraySelectedElements[i].customData.generationData.id);
                    if (card){
                        arrayCards.push(card);
                    }
                }
            }
            if (arrayCards.length == 0) {
                message.info(t("Please select"));
                return;
            }
            // window.showProgress('Exporting');
            if (arrayCards.length == 1){
                const card0 = arrayCards[0];
                editDoc(card0.id,card0.doc,card0.name).then(res=>{
                    const nTimeoutId = setTimeout(() => {
                        ipcSend('save-pdf-to-system', card0.id, card0.name)
                    }, 10);
                    this.mArrayTimeoutIds.push(nTimeoutId);
                })
            }else{
                ipcInvoke('save-pdf-zip-to-system', JSON.stringify(arrayCards));
            }
        }else if ('exportMarkdown' == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            const arrayCards:any = [];
            for (let i=0;i<arraySelectedElements.length;i++){
                if (isNoteElement(arraySelectedElements[i])){
                    const card = await getCardById(arraySelectedElements[i].customData.generationData.id);
                    if (card){
                        arrayCards.push(card);
                    }
                }
            }
            //导出markdown
            if (arrayCards.length == 1){
                // this.onExportSingleMd(arrayCards[0]);
                window.exportMarkdown(arrayCards[0]);
            }else{
                this.exportMarkdown(arrayCards);
            }
        }else if ('share' == action){
            //卡片分享
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            let szShareId = arraySelectedElements[0].customData.generationData.id;
            window.showDialogPublishCardToWeb(szShareId,async (szId,dialogPublishToWebRef)=>{
                if (szId == 'exportPdf') {
                    this.onMenuClick('exportPdf');
                }else if (szId == 'exportMarkdown'){
                    this.onMenuClick('exportMarkdown');
                }
                else {

                    const card = await getCardById(arraySelectedElements[0].customData.generationData.id);
                    shareCardData(card,null,dialogPublishToWebRef);
                }
            });
        }
        else if ('showInfo' == action){
            this.props.parentOnSaveNotes().then(async(res0)=>{
                if (isImageElement(this.state.mCurrentSelectedElement) || isEmbedableBookmarkElement(this.state.mCurrentSelectedElement)){
                    let library = await getCardById(this.state.mCurrentSelectedElement.customData?.generationData?.id);
                    if (!library){
                        if (isImageElement(this.state.mCurrentSelectedElement)){
                            //是图片，并且没有加入到库中。那么，就自动加入到库中，并且在库中作隐藏...
                            const imageFile = excalidrawAPI.getApp().files[this.state.mCurrentSelectedElement.fileId];
                            let szFileName = imageFile.id+"."+extFromMineType(imageFile.mimeType);
                            if (imageFile.fullPath){
                                szFileName = imageFile.fullPath;
                            }
                            let isAbsolutePath = !isStringNullOrEmpty(imageFile.fullPath);
                            if (isAbsolutePath){
                                const szDir = localStorage.getItem(KEY_FILE_DIR);
                                if (imageFile.fullPath.startsWith(szDir)){
                                    isAbsolutePath = false;
                                    szFileName = getFileName(szFileName);
                                }
                            }
                            const libraryNew = {
                                ...this.state.mCurrentSelectedElement.customData?.generationData || {},
                                id:generateUUID2(),
                                name:this.state.mCurrentSelectedElement.name || t("Untitled"),
                                fileName:szFileName,
                                type:'image',
                                isDeleted:2,//作为不可见的...
                                isAbsolutePath:isAbsolutePath,
                            }
                            await updateCard(libraryNew)
                            //更新元素的ID
                            const customData = {generationData:{...libraryNew}};
                            const ele0 = excalidrawAPI.getApp().getSelectedElements().find(p=>p.id == this.state.mCurrentSelectedElement.id);
                            mutateElement(ele0,{customData:customData});

                            library = libraryNew;
                        }else if (isEmbedableBookmarkElement(this.state.mCurrentSelectedElement)){
                            const item = this.state.mCurrentSelectedElement;
                            //embedable----
                            const libraryNew = {
                                id:item.customData?.generationData?.id,
                                name:item.customData?.generationData?.title,
                                type:'webLink',
                                fileName:item.link,
                                thumbImage:item.customData?.generationData?.image,
                                description:item.customData?.generationData?.description,
                                icon:item.customData?.generationData?.icon,
                                isDeleted:2,//标记为不可见...
                            }
                            await updateCard(libraryNew);

                            library = libraryNew;
                        }
                    }
                    window.showInfo('library',library);

                }else if (this.state.mCurrentSelectedElement.customData?.generationData?.isAbsolutePath){
                    //绝对路径，不在库里
                    const forkLibrary = {...this.state.mCurrentSelectedElement.customData.generationData};
                    forkLibrary.name = forkLibrary.showName;
                    forkLibrary.updateTime = this.state.mCurrentSelectedElement.updated;
                    window.showInfo('library',forkLibrary)
                }else{
                    //注记部分，直接取注记
                    if (isPdfAnnoElement(this.state.mCurrentSelectedElement) || isVideoAnnoElement(this.state.mCurrentSelectedElement) || isAudioAnnoElement(this.state.mCurrentSelectedElement) || isCardAnnoElement(this.state.mCurrentSelectedElement)){
                        getCardById(this.state.mCurrentSelectedElement.id).then(async (res)=>{
                            if (res){
                                window.showInfo('library',res);
                            }else{
                                const library = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.videoData?.id || this.state.mCurrentSelectedElement?.customData?.generationData?.pdfData?.id || this.state.mCurrentSelectedElement.customData?.generationData?.id);
                                window.showInfo('library',library);
                            }
                        })
                    }
                    else{
                        window.methodGetNoteById(this.state.mCurrentSelectedElement.customData?.generationData?.id || this.state.mCurrentSelectedElement.id).then(res=>{
                            if (!res){
                                let szFilePath = '';
                                let isAbsolutePath = false;
                                if (isImageElement(this.state.mCurrentSelectedElement)){
                                    const fileffffffffffff = excalidrawAPI.getFiles()[this.state.mCurrentSelectedElement.fileId];
                                    if (fileffffffffffff){
                                        if (fileffffffffffff.fullPath){
                                            szFilePath = fileffffffffffff.fullPath;
                                            isAbsolutePath = true;
                                        }else{
                                            szFilePath = fileffffffffffff.id+"."+extFromMineType(fileffffffffffff.mimeType);
                                        }
                                    }
                                }
                                res = {
                                    id:this.state.mCurrentSelectedElement.id,
                                    name:this.state.mCurrentSelectedElement.name,
                                    createTime:this.state.mCurrentSelectedElement.created || this.state.mCurrentSelectedElement.updated,
                                    updateTime:this.state.mCurrentSelectedElement.updated,
                                    fileName:szFilePath,
                                    isAbsolutePath:isAbsolutePath,
                                    type:'image',
                                    isFork:true
                                }
                            }
                            window.showInfo('library',res);
                        })
                    }

                }

            })
        }else if ('copyLink' == action){
            let szType = this.state.mCurrentSelectedElement.type;
            if (szType == 'iframe'){
                if (isNoteElement(this.state.mCurrentSelectedElement)){
                    szType = 'card';
                    if (this.state.mCurrentSelectedElement.customData.generationData.libraryType){
                        szType = this.state.mCurrentSelectedElement.customData.generationData.libraryType;
                    }
                }else if (isFileVideoElement(this.state.mCurrentSelectedElement)){
                    szType = 'video';
                }else if (isPdfFileElement(this.state.mCurrentSelectedElement)){
                    szType = 'pdf';
                }else if (isAudioFileElement(this.state.mCurrentSelectedElement)){
                    szType = 'audio'
                }else if (isPdfAnnoElement(this.state.mCurrentSelectedElement)){
                    szType = 'pdfAnno'
                }else if (isCardAnnoElement(this.state.mCurrentSelectedElement)){
                    szType = 'cardAnno'
                }else if (isVideoAnnoElement(this.state.mCurrentSelectedElement)){
                    szType = 'videoAnno'
                }else if (isAudioAnnoElement(this.state.mCurrentSelectedElement)){
                    szType = 'audioAnno'
                }
                else{
                    szType = 'file';
                }
            }
            createCopyLink("project",PROJECT_ID??'','board',this.props.parentOnGetSelectedBoard().key,szType,this.state.mCurrentSelectedElement.id,true,this.state.mCurrentSelectedElement?.customData?.generationData?.id)
        }else if ('manageTags' == action){
            //管理标签
            //取这个note的library ..
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            const arrayCards:any = [];
            for (let i=0;i<arraySelectedElements.length;i++){
                const item = arraySelectedElements[i];
                let card = await getCardById(item.customData?.generationData?.pdfData?.id || item.customData?.generationData?.videoData?.id || item.customData?.generationData?.id || item.id);
                if (card){
                    arrayCards.push(card);
                }
            }
            if (arrayCards.length == 0){
                message.error(t("NoTagsForSet"))
            }else{
                window.showManageTags(arrayCards);
            }
            // getCardById(this.state.mCurrentSelectedElement.customData.generationData.id)?.then(res=>{
            //     window.showManageTags([res]);
            // })
        }else if ('copyText' == action){
            //复制纯文本
            if (isPdfAnnoElement(this.state.mCurrentSelectedElement) || isCardAnnoElement(this.state.mCurrentSelectedElement)){
                let szNote = '';
                if (this.state.mCurrentSelectedElement.customData.generationData.pdfData.comment){
                    szNote = "\n"+t("Note")+":" + this.state.mCurrentSelectedElement.customData.generationData.pdfData.comment;
                }
                clipboard.write(this.state.mCurrentSelectedElement.customData.generationData.pdfData.text+szNote);
            }else if (isVideoAnnoElement(this.state.mCurrentSelectedElement)){
                clipboard.write(this.state.mCurrentSelectedElement.customData.generationData.videoData.title + '\n'+this.state.mCurrentSelectedElement.customData.generationData.videoData.content);
            }else{
                if (this.state.mCurrentSelectedElement.value){
                    let szTxt = removeHtmlTags(this.state.mCurrentSelectedElement.value);
                    clipboard.write(szTxt);
                }else{
                    clipboard.write(this.state.mCurrentSelectedElement.text);
                }

            }

        }else if ('add_to_library' == action){
            //image 添加到library库..
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const item = arraySelectedElements[i];
                if (isImageElement(item)){
                    //region image
                    //判断库里面是否有，如果有的话直接将isDeleted设置为2-因为在画布上，image 没有在库里也可查看info,但是info涉及的关联太多。只能以isDeleted=2的形式隐藏在库中
                    const library = await getCardById(item.customData?.generationData?.id);
                    if (library){
                        library.isDeleted = 0;
                        updateCard(library).then(res=>{
                            //刷新
                            window.globalRefreshList('refreshLibraryList')
                        })
                    }else{
                        const imageFile = excalidrawAPI.getFiles()[arraySelectedElements[i].fileId];
                        if (imageFile){
                            let szFileName = imageFile.id+"."+extFromMineType(imageFile.mimeType);
                            if (imageFile.fullPath){
                                szFileName = imageFile.fullPath;
                            }
                            let isAbsolutePath = !isStringNullOrEmpty(imageFile.fullPath);
                            if (isAbsolutePath){
                                const szDir = localStorage.getItem(KEY_FILE_DIR);
                                if (imageFile.fullPath.startsWith(szDir)){
                                    isAbsolutePath = false;
                                    szFileName = getFileName(szFileName);
                                }
                            }
                            const library = {
                                ...item.customData?.generationData || {},
                                id:generateUUID2(),
                                name:item.name || t("Untitled"),
                                fileName:szFileName,
                                type:'image',
                                isAbsolutePath:isAbsolutePath
                            }
                            //如果文件不存在，则复制到文件.
                            if (imageFile.dataURL){
                                await ipcInvoke('write-base64-image-if-not-exist',{imgBase64:imageFile.dataURL,fileName:szFileName});
                            }

                            //更新这个image的elementId
                            // const customData = item.customData || {};
                            // if (!customData.generationData){
                            //     customData.generationData.id =
                            // }

                            updateCard(library).then(res=>{
                                //刷新
                                window.globalRefreshList('refreshLibraryList')
                            })

                            //更新元素的ID
                            const customData = {generationData:{...library}};
                            mutateElement(item,{customData:customData});
                        }
                    }
                    //endregion
                }else if (isEmbeddableElement(item)){
                    const library = await getCardById(item.customData?.generationData?.id);
                    if (library){
                        library.isDeleted = 0;
                        if (item.customData?.generationData?.image){
                            library.thumbImage = item.customData?.generationData?.image;
                        }
                        if (item.customData?.generationData?.icon){
                            library.icon = item.customData?.generationData?.icon;
                        }
                        if (item.customData?.generationData?.description){
                            library.description = item.customData?.generationData?.description;
                        }

                        updateCard(library).then(res=>{
                            //刷新
                            window.globalRefreshList('refreshLibraryList')
                        })
                    }else{
                        //embedable----
                        const library = {
                            id:item.customData?.generationData?.id,
                            name:item.customData?.generationData?.title,
                            type:'webLink',
                            fileName:item.link,
                            thumbImage:item.customData?.generationData?.image,
                            description:item.customData?.generationData?.description,
                            icon:item.customData?.generationData?.icon,
                        }
                        updateCard(library).then(res=>{
                            message.info(t("BookmarkAddedToLibrary"));
                            //刷新
                            postMessage(EVENT_REFRESH_LIBRARY_LIST,null);
                        })
                    }
                }
            }

        }else if (action == 'copy_to_text'){
            //pdf anno
            clipboard.write(this.state.mCurrentSelectedElement.customData?.generationData?.pdfData?.text);
        }else if (action == 'zenMode'){
            if (this.props.parentOnMenuAction){
                this.props.parentOnMenuAction(action,!excalidrawAPI.getAppState().zenModeEnabled);
            }
            excalidrawAPI.getApp().executeContextMenuAction(action,true);
        }
        else if (action == 'createFrame'){
            this.onSetFrameSize({
                type: "preset",
                width: 16,
                height: 9,
            })
            this.onSetActiveTool('frame');
        }else if (action == 'createProject'){
            //创建一个空白的项目并插入进来...
            let project:any = createEmptyProject(generateUUID2(),'');
            updateNote(project).then(res=>{
                excalidrawAPI.getApp().insertProjectLink(mContextMenuPosition.x,mContextMenuPosition.y,project.id,null);
            })
        }else if(action == 'createBoard'){
            //创建一个新board....
            if (window.onAddNewCanvas){
                const newBoard = window.onAddNewCanvas();

                setTimeout(()=>{
                    this.props.parentOnSaveNotes().then(res=>{
                        const resultElement = excalidrawAPI.getApp().createProjectLink(mContextMenuPosition.x,mContextMenuPosition.y,PROJECT_ID,newBoard.key);
                        excalidrawAPI.getApp().scene.addNewElement(resultElement!);
                    })
                },200)
            }
        }
        else if (action == 'linkToProject'){
            window.showDialogChooseProject([],t("Link to project"),FROM_LINK_TO_PROJECT,(project:any)=>{
                //插入链接
                let xy = excalidrawAPI.getApp().getCurrentCenterPoint();
                excalidrawAPI.getApp().insertProjectLink(xy.x,xy.y,project.id,project.isChild?project.key:null);
            })
        }else if (action == 'addFile'){
            global.g_insertPosition = {x:mContextMenuPosition.x,y:mContextMenuPosition.y};
            this.props.parentOnMenuAction('addFile');
        }else if (action == 'createStickyNotes'){
            // global.g_insertPosition = {x:mContextMenuPosition.x,y:mContextMenuPosition.y};
            excalidrawAPI.getApp().insertStickyNotes(mContextMenuPosition.x,mContextMenuPosition.y,(element)=>{
                this.setState({
                    mCurrentSelectedElement:element
                })
            });
        }else if (action == 'turnEmbedMode'){
            //切换embed的模式
        }
        else if (action == 'deeplinkLink'){

        }else if (action == 'deeplinkEmbed'){
            //转换成embed...
            if (mPasteDeeplinkElement) {
                excalidrawAPI.getApp().removeElementById(mPasteDeeplinkElement.id);

                const deeplink = decodeDeeplink(removeHtmlTags(mPasteDeeplinkElement.originalText));
                const coords = sceneCoordsToViewportCoords({sceneX:mPasteDeeplinkElement.x,sceneY:mPasteDeeplinkElement.y}, excalidrawAPI.getAppState());
                if (deeplink.type == 'highlight' && deeplink.childType == 'videoNote') {
                    dbGetHighlight(deeplink.id).then(res => {
                        const videoNote = res.data.find(p => p.id == deeplink.childId);
                        postMessage(EVENT_TEST_ONDRAG_NOTE, {
                            type: 'videoAnno',
                            id: videoNote.id,
                            libraryId: deeplink.id,
                            name: res.name,
                            videoData: videoNote,
                            x: coords.x,
                            y: coords.y
                        })
                    })
                }
                if (deeplink.type == 'library' && (deeplink.childType == 'pdfAnno' || deeplink.childType == 'cardAnno' || deeplink.childType == 'card' || deeplink.childType == 'video' || deeplink.childType == 'audio' || deeplink.childType == 'pdf' || deeplink.childType == 'youtube' || deeplink.childType == 'bilibili' || deeplink.childType == 'file') ) {
                    if (deeplink.childType == 'card'){
                        //判断如果已存在了card，不让转换
                        // if (excalidrawAPI.getApp().getSceneElements().some(p=>p.id == deeplink.id || p.customData?.generationData?.id == deeplink.id)){
                        //     message.error(t("CardIsAlreadOn").replace("{0}",t("Card")));
                        // }else
                        {
                            //插入卡片
                            const card = await getCardById(deeplink.id);
                            excalidrawAPI.getApp().insertNoteElement(mPasteDeeplinkElement.x, mPasteDeeplinkElement.y,card,true);
                        }
                    }else if (deeplink.childType == 'video' || deeplink.childType == 'pdf' || deeplink.childType == 'audio' || deeplink.childType == 'file'){
                        //插入视频元素
                        // const arrayElements = excalidrawAPI.getApp().getSceneElements();
                        // if (arrayElements.some(p => p.customData?.generationData?.id == deeplink.id)) {
                        //     message.info(t("CardIsAlreadOn").replace('{0}', t(firstLetterUpper(deeplink.childType == 'pdf' ? 'PDF' : deeplink.childType))));
                        // }else
                        {
                            const card: any = await getCardById(deeplink.id);
                            if (card) {
                                excalidrawAPI.getApp().insertFileElement(card.fileName, card.id, {x:mPasteDeeplinkElement.x, y:mPasteDeeplinkElement.y},false,null,null,null,true,false,card.name);
                            }
                        }
                    }
                    else{
                        //粘贴pdf注记
                        postMessage(EVENT_TEST_ONDRAG_NOTE, {
                            type: deeplink.childType,
                            id: deeplink.id,
                            x: coords.x,
                            y: coords.y
                        });
                    }
                }
                if (deeplink.type == 'project' ||
                    deeplink.childType == 'board'){
                    //删除这个元素，重新创建embed
                    excalidrawAPI.getApp().insertProjectLink(mPasteDeeplinkElement.x, mPasteDeeplinkElement.y, deeplink.id, deeplink.childId);
                }
            }
        }else if ('openProjectLink' == action){
            //打开项目
            postMessage(EVENT_NAVIGATE_DEEPLINK,{element:this.state.mCurrentSelectedElement});
        }
        // else if ('sendBackward' == action || 'bringForward' == action || 'sendToBack'==action || 'bringToFront' == action){
        //     this.delayPopoverClose();
        // }
        else if ('openVideoInPopup' == action){
            //
            postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:false,element:this.state.mCurrentSelectedElement})

        }else if ('openVideoInSide' == action){
            //open note---去哪里找这个name,library,highlight,
            let library = await getCardById(this.state.mCurrentSelectedElement.id);
            if (!library){
                library = await getCardById(this.state.mCurrentSelectedElement.customData?.generationData?.id);
            }
            postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT,{isFullScreen:true,videoNotes: {element:this.state.mCurrentSelectedElement},breadcrumb:global.g_isPresentMode?null:createBreadcrumb('highlight',library?.name)})
        }else if ('openVideoInFullScreen' == action){
            postMessage(EVENT_OPEN_VIDEO_IN_POPUP,{isFullScreen:true,element:this.state.mCurrentSelectedElement})
        }else if ('versionHistory' == action){
            window.showDialogCardHistory(this.state.mCurrentSelectedElement?.customData?.generationData?.id,(newCard:any)=>{
                const customData = {...this.state.mCurrentSelectedElement.customData};
                customData.generationData = {
                    ...customData.generationData,
                    name:newCard.name,
                    html:newCard.doc
                }
                excalidrawAPI.getApp().onUpdateElement(this.state.mCurrentSelectedElement,{customData:customData,versionNonce:randomInteger()});
                //强制更新....
                postMessage(EVENT_UPDATE_FORCE_CARD_IIIINNNNNFFFFOOOOOO,{id:this.state.mCurrentSelectedElement.id,customData:customData});
                //更新左侧栏的标题...
                // postMessage(EVENT_UPDATE_NOTE_FROM_CANVAS_EDIT_CARD,{...newCard})
            });
        }else if ('changePdfSource' == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            const hasPdfAnno = arraySelectedElements.some(p=>isPdfAnnoElement(p));
            const hasVideoAnno = arraySelectedElements.some(p=>isVideoAnnoElement(p));
            const hasAudioAnno = arraySelectedElements.some(p=>isAudioAnnoElement(p));
            let filter = [{ name: 'Videos', extensions: ['mp4', 'mov', '3gp','mpeg'] }];
            if (hasPdfAnno){
                filter = [{ name: 'pdf', extensions: ['pdf'] }];
            }else if (hasAudioAnno){
                filter = [{ name: 'audio', extensions: getAudioFilterExt() }];
            }
            //修改源pdf的路径.
            ipcInvoke('getFilePath',{filters:filter}).then(async (res)=>{
                if (res){
                    for (let i=0;i<arraySelectedElements.length;i++){
                        const element = arraySelectedElements[i];
                        if (isPdfAnnoElement(element) || isVideoAnnoElement(element) || isAudioAnnoElement(element)){
                            element.customData.generationData.isAbsolutePath = true;
                            element.customData.generationData.fileName = res;
                            updateChangeSource(element.customData.generationData.id,res);
                        }
                    }
                }
            })
        }else if ('convertToCard' == action){
            //sticknote转换成卡片
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();

            const arrayElements = excalidrawAPI.getSceneElements();

            for (let i=0;i<arraySelectedElements.length;i++){
                const ele = arraySelectedElements[i];
                if (isStickyNotesElement(ele) || isTextElement(ele)){
                    const nIndex = arrayElements.findIndex(p=>p.id == ele.id);
                    //删除这个
                    arrayElements.splice(nIndex,1);
                    //拆分\n，每个一个p
                    let szHtml = '';
                    let szText = '';
                    let arraySplit:any = [];
                    if (isStickyNotesElement(ele)){
                        szText = ele.value;
                        // arraySplit = szText.split('\n');
                    }else if (isTextElement(ele)){
                        if (HAS_ENABLE_TIPTAP_TEXT){
                            szText = ele.value;
                        }else{
                            szText = ele.originalText?.replaceAll('\r','\n');
                        }
                        // arraySplit = szText.split('\n');
                    }
                    // for (let k=0;k<arraySplit.length;k++){
                    //     szHtml += `<p data-id="${crypto.randomUUID()}" style="color: ${ele.strokeColor}">${arraySplit[k]}</p>`
                    // }

                    szHtml = szText;
                    //保存到library
                    const card = {
                        id:generateUUID2(),
                        type:'card',
                        name:'',
                        hasTitle:false,
                        createTime:Date.now(),
                        updateTime:Date.now(),
                        doc:szHtml
                    }
                    await updateCard(card);
                    //创建一个新的card
                    const newElement = excalidrawAPI.getApp().insertNoteElement(ele.x,ele.y,card);
                    arrayElements.push(newElement);
                }
            }

            excalidrawAPI.updateScene({
                elements:arrayElements
            })
        }else if ('showName' == action){
            //显示名称
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            let isShowName = this.state.mCurrentSelectedElement.customData?.generationData?.isShowName || false;
            //    2. 如果当前选中图片部分有标题或全都没有标题，点击“T”，就是显示标题
            let hasAnyShowName = arraySelectedElements.every(p=>p.customData?.generationData?.isShowName);
            isShowName = hasAnyShowName;
            for (let i=0;i<arraySelectedElements.length;i++) {
                const item = arraySelectedElements[i];
                // if (isImageElement(item))
                {
                    let customData;
                    if (!item.customData?.generationData){
                        customData = {generationData:{isShowName:false,originName:item.name||''}}
                    }else{
                        customData = {...item.customData};
                    }
                    customData.generationData.isShowName = !isShowName;
                    mutateElement(item,{customData})
                }

                if (isImageElement(item)){
                    this.props.parentOnSceneElementUpdate('update',{elements:excalidrawAPI.getSceneElements()});
                }
            }
        }else if ('showInfoNotes' == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            let isShowInfoNotes = this.state.mCurrentSelectedElement.customData?.generationData?.isShowInfoNotes || false;
            //    2. 如果当前选中图片部分有标题或全都没有标题，点击“T”，就是显示标题
            let hasAnyShowInfoNotes = arraySelectedElements.every(p=>p.customData?.generationData?.isShowInfoNotes);
            isShowInfoNotes = hasAnyShowInfoNotes;
            for (let i=0;i<arraySelectedElements.length;i++) {
                const item = arraySelectedElements[i];
                let customData;
                if (!item.customData?.generationData){
                    customData = {generationData:{isShowInfoNotes:false,isEditable:true}}
                }else{
                    customData = {...item.customData};
                }
                customData.generationData.isShowInfoNotes = !isShowInfoNotes;
                if (!customData.generationData.inputHeight){
                    let nHeight = calcTextAreaInfoNotesHeight(item.width,item.customData?.generationData?.infoNotes);
                    if (nHeight > MAX_NOTES_HEIGHT){
                        nHeight = MAX_NOTES_HEIGHT;
                    }
                    customData.generationData.inputHeight = nHeight;
                }
                if (!customData.generationData.originHeight){
                    customData.generationData.originHeight = item.height;
                    //计算出原始图片的宽高比
                    customData.generationData.whRate = item.width/item.height;//宽高比
                }
                //从库里面更新一下数据？？？？
                let newHeight = customData.generationData.originHeight;
                if (customData.generationData.isShowInfoNotes){
                    //不一样，并不知道哪里有差异
                    if (isEmbeddableElement(item) || isAudioFileElement(item)){
                        newHeight += customData.generationData.inputHeight + 20;
                    }else{
                        newHeight += customData.generationData.inputHeight + INFO_NOTES_EXTRA_HEIGHT;
                    }

                    customData.generationData.isEditable = true;
                }
                mutateElement(item,{customData,height:newHeight});

                //不得不说。
                const ele = excalidrawAPI.getApp().getSceneElements().find(p=>p.id == item.id);
                if (ele){
                    excalidrawAPI.getApp().onUpdateElement(ele,{customData,height:newHeight});
                }

                //如果这个---需要滚动到底部，不然会超出canvas了...
                if (customData.generationData.isShowInfoNotes){
                    excalidrawAPI.getApp().scrollToElementBottom(item,newHeight);
                }
            }

            if (arraySelectedElements.some(p=>isImageElement(p))){
                this.props.parentOnSceneElementUpdate('update',{elements:excalidrawAPI.getSceneElements()});
            }
        }
        else if ('copyOriginLink' == action){
            if (isEmbeddableElement(this.state.mCurrentSelectedElement)){
                clipboard.write(this.state.mCurrentSelectedElement.link);
                message.info(t("Link copied to clipboard"));
            }else if (isProjectLinkElement(this.state.mCurrentSelectedElement)){
                //复制这个画布的原始链接...
                createCopyLink('project',this.state.mCurrentSelectedElement.customData?.projectId,'board',this.state.mCurrentSelectedElement.customData?.boardId)
            }
            else{
                //复制库里面的链接
                let library = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.pdfData?.id || this.state.mCurrentSelectedElement?.customData?.generationData?.videoData?.id || this.state.mCurrentSelectedElement?.customData?.generationData?.id || this.state.mCurrentSelectedElement.id);
                // if (!library){
                //     library = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id);
                // }
                if (library){
                    createCopyLinkByLibraryItem(library);
                    // clipboard.write(szDeeplink);
                    // message.info(t("Link copied to clipboard"));
                }
            }
        }else if ('openPdfInPopup' == action){
            //open pdf
            // const szFilePath = localStorage.getItem(KEY_FILE_DIR) + this.state.mCurrentSelectedElement.customData.generationData.fileName;
            // if (isPdf(szFilePath)){
            //     this.props.parentOnOpenPdfFile(this.state.mCurrentSelectedElement.id,szFilePath,this.state.mCurrentSelectedElement.customData.generationData.showName,'dialog');
            // }

            getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id).then((res:any)=>{
                window.showPdfPreview(res.name,res.id,res.fileName,false,false);
            })
        }else if ('openPdfInPopupWithAnno' == action){
            //open pdf
            // const szFilePath = localStorage.getItem(KEY_FILE_DIR) + this.state.mCurrentSelectedElement.customData.generationData.fileName;
            // if (isPdf(szFilePath)){
            //     this.props.parentOnOpenPdfFile(this.state.mCurrentSelectedElement.id,szFilePath,this.state.mCurrentSelectedElement.customData.generationData.showName,'dialog');
            // }

            getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id).then((res:any)=>{
                window.showPdfPreview(res.name,res.id,res.fileName,false,true);
            })
        }
        else if ('openPdfInFullScreen' == action){
            getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id).then((res:any)=>{
                window.showPdfPreview(res.name,res.id,res.fileName,true,false);
            })
        }
        else if ('openPdfInSliderRight' == action){
            const library:any = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id);
            if (library){
                let szFilePath = library.fileName;
                if (!library.isAbsolutePath){
                    szFilePath = localStorage.getItem(KEY_FILE_DIR)+library.fileName;
                }
                ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                    const blob = new Blob([res]);
                    const url = URL.createObjectURL(blob);
                    //右侧打开.
                    postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                        pdfPath: url,
                        fileId: library.id,
                        fileName: library.name ?? getFileName(szFilePath),
                        pdfFileName: szFilePath,
                        isViewAllHighlight:false,
                        breadcrumb:createBreadcrumb("library", library.name ?? getFileName(szFilePath))
                    });
                })
            }

        }else if ('openPdfInSliderRightWithAnno' == action){
            const library:any = await getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id);
            if (library){
                let szFilePath = library.fileName;
                if (!library.isAbsolutePath){
                    szFilePath = localStorage.getItem(KEY_FILE_DIR)+library.fileName;
                }
                ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                    const blob = new Blob([res]);
                    const url = URL.createObjectURL(blob);
                    //右侧打开.
                    postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                        pdfPath: url,
                        fileId: library.id,
                        fileName: library.name ?? getFileName(szFilePath),
                        pdfFileName: szFilePath,
                        isViewAllHighlight:true,
                        breadcrumb:createBreadcrumb("library", library.name ?? getFileName(szFilePath))
                    });
                })
            }
        }else if ('openProjectInSiderbar' == action){
            //侧栏打开...
            postMessage(EVENT_PROJECT_ON_SlIDER_RIGHT, {id: this.state.mCurrentSelectedElement.customData?.projectId,boardId:this.state.mCurrentSelectedElement.customData?.boardId,isDeleted:this.state.mCurrentSelectedElement.customData?.isDeleted,isBoardDeleted:this.state.mCurrentSelectedElement.customData?.isBoardDeleted});
        }else if ('openWebInSiderbar' == action){
            //侧栏打开web
            postMessage(EVENT_WEBLINK_ON_SLIDER_RIGHT,{...this.state.mCurrentSelectedElement})
        }
        else if ('project_link_rename' == action){
            //项目link重命名.
            getNoteById(this.state.mCurrentSelectedElement.customData?.projectId,true,true).then((res)=>{
                //重命名..
                if (res){
                    let szName = res.name;
                    const szBoardId = this.state.mCurrentSelectedElement.customData?.boardId;
                    if (szBoardId){
                        loop(res.doc.canvas,szBoardId,(node, i, data, parent)=>{
                            szName = node.title;
                        })
                    }
                    /**
                     * 刷新画布上的数据
                     */
                    const refreshCanvasProjectLink = ()=>{
                        const arrayElements = excalidrawAPI.getSceneElements().filter(p=>p.customData?.projectId == res.id);
                        for (let i=0;i<arrayElements.length;i++){
                            const customData = {...arrayElements[i].customData}
                            mutateElement(arrayElements[i],{customData:customData});
                        }
                        //刷新收藏
                        postMessage(EVENT_FAVIRIATE_CHANGE);
                    }
                    window.showCommonInput(szName,t("Rename"),"",t("Cancel"),t("Save"),async(szContent:string)=>{
                        window.closeCommonInput();

                        if (szBoardId){
                            if (res.id == PROJECT_ID){
                                //本项目的board...
                                if (window.updateBoardName){
                                    await window.updateBoardName(szBoardId,szContent);
                                    refreshCanvasProjectLink();
                                }
                            }else{
                                //别的画布上的.
                                let board;
                                loop(res.doc.canvas,szBoardId,(node, i, data, parent)=>{
                                    node.title = node.editValue = szContent;
                                    //更新projectboard,如果projectboard有的话.
                                    board = node;
                                })
                                if (board){
                                    const projectBoard = await getBoardById(board.key);
                                    if (projectBoard){
                                        projectBoard.name = board.title;
                                        await updateBoard(projectBoard);
                                    }
                                }
                                //保存.
                                updateNote(res).then(rr=>{
                                    //刷新画布.
                                    refreshCanvasProjectLink();
                                })
                            }
                        }else{
                            res.name = res.showName = szContent;
                            //如果是本画布的，还要改本画布的标题。。。。。
                            if (res.id == PROJECT_ID){
                                await this.props.parentOnMenuAction('set_project_name',res.name);
                                //刷新画布.
                                refreshCanvasProjectLink();
                            }else{
                                updateProject(res).then(rr=>{
                                    //刷新画布.
                                    refreshCanvasProjectLink();
                                })
                            }
                        }

                    });
                }
            })
        }
        else if ('linkEmbed' == action){
            //以原始链接方式插入----
            this.insertEmbedElement(this.state.mCurrentSelectedElement.text,generateUUID2(), this.state.mCurrentSelectedElement.x,this.state.mCurrentSelectedElement.y);
            this.onDeleteElement(this.state.mCurrentSelectedElement.id);
        }else if ('linkBookmark' == action) {
            //以书签方式插入----
            let ox = this.state.mCurrentSelectedElement.x;
            let oy = this.state.mCurrentSelectedElement.y;
            excalidrawAPI.getApp().insertEmbeddableElement({sceneX:ox,sceneY:oy,link:this.state.mCurrentSelectedElement.text,embedType:'text',isOriginXY:true});
            this.onDeleteElement(this.state.mCurrentSelectedElement.id);
        }else if ('switchToEmbedMode' == action){
            //转换为embed链接
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                const embedLink = getEmbedLink(element.link);
                let width = embedLink?.intrinsicSize?.w || 840;
                let height = embedLink?.intrinsicSize?.h || 560;
                if (isEmbeddableElement(element)) {

                    let customData = {...element.customData || {}}
                    if (!customData.generationData){
                        customData.generationData = {};
                    }
                    customData.generationData.originHeight = height;
                    //计算出原始图片的宽高比
                    customData.generationData.whRate = width/height;//宽高比
                    customData.generationData.isShowInfoNotes = false;
                    // if (customData.generationData.isShowInfoNotes){
                    //     customData.generationData.originHeight += customData.generationData.inputHeight + 16;
                    // }

                    mutateElement(element,{embedType:'page',height:height,width:width,customData:customData});
                }
            }
        }else if ('switchToBookmarkMode' == action){
            //转换为书签的形式
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            for (let i=0;i<arraySelectedElements.length;i++){
                const element = arraySelectedElements[i];
                if (isEmbeddableElement(element)) {
                    let customData = {...element.customData || {}}
                    if (!customData.generationData){
                        customData.generationData = {};
                    }
                    customData.generationData.originHeight = DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT;
                    //计算出原始图片的宽高比
                    customData.generationData.whRate = DEFAULT_EMBEDABLE_BOOKMARK_WIDTH/DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT;//宽高比
                    customData.generationData.isShowInfoNotes = false;
                    // if (customData.generationData.isShowInfoNotes){
                    //     customData.generationData.originHeight += customData.generationData.inputHeight + 16;
                    // }

                    mutateElement(element,{embedType:'text',
                        height:DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT,
                        width:DEFAULT_EMBEDABLE_BOOKMARK_WIDTH,
                        backgroundColor:getBookmarkBackgroundColor(),
                    customData:customData});

                    const nTimeoutId = setTimeout(()=>{
                        const node = document.getElementById(`${element.id}-card`)!;
                        if (node){
                            cardLink([node],element);
                        }
                    },200);
                    this.mArrayTimeoutIds.push(nTimeoutId);
                }
            }
        }else if ('setCurrentStyleAsDefault' == action){
            //保存样式.
            const defaultStyle = {
                strokeWidth:this.state.mCurrentSelectedElement.strokeWidth,
                strokeColor:this.state.mCurrentSelectedElement.strokeColor,
                backgroundColor:this.state.mCurrentSelectedElement.backgroundColor,
            }
            localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(defaultStyle));
            message.info(t('DefaultStyleUpdated'));
        }else if ('resetToOriginStyle' == action){
            localStorage.removeItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
            //还原这个设置.白色背景，没有边框，圆角8--强制P更新
            excalidrawAPI.getApp().onUpdateElement(this.state.mCurrentSelectedElement,{
                backgroundColor:getNoteElementBackgroundColor(),
                strokeColor:'transparent',
                roundness: {
                    type: ROUNDNESS.ADAPTIVE_RADIUS,
                    value: 8
                },
                strokeWidth:2,
            })

            message.info(t('DefaultStyleUpdated'));
        }
        else if ('project_rename' == action){
            this.props.parentOnMenuAction('project_rename',null);
        }else if ('project_background' == action){
            this.props.parentOnMenuAction('project_background',null);
        }else if ('addToProject' == action){
            //添加到project...
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            const arrayLibrarys:any = [];
            //取所有library...
            for (let i=0;i<arraySelectedElements.length;i++){
                const ele = arraySelectedElements[i];
                const library:any = await getCardById(ele.customData?.generationData?.pdfData?.id || ele.customData?.generationData?.videoData?.id || ele.customData?.generationData?.id);
                if (library){
                    //把颜色也宽度也带上。。。
                    library.strokeWidth = ele.strokeWidth;
                    library.strokeColor = ele.strokeColor;
                    library.backgroundColor = ele.backgroundColor;
                    arrayLibrarys.push(library);
                }
            }
            window.showDialogChooseProject(arrayLibrarys);
        }else if ('rename' == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectedElements.length > 0){
                if (isFrameElement(arraySelectedElements[0])){
                    excalidrawAPI.getApp().setState({
                        editingFrame: arraySelectedElements[0].id,
                    })
                }
            }
        }else if ('addToBookmark' == action){
            //添加到书签...
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectedElements.length > 0){
                let isAdd = true;
                for (let i=0;i<arraySelectedElements.length;i++){
                    const ele = arraySelectedElements[i];
                    if (!ele.extra){
                        ele.extra = {};
                    }
                    const extra = {...ele.extra};
                    if(extra.favor == 1){
                        extra.favor = 0;
                        isAdd = false;
                    }else{
                        extra.favor = 1;
                    }
                    extra.favirateTime = Date.now();

                    ele.extra.favor = extra.favor;
                    ele.extra.favirateTime = extra.favirateTime;

                    mutateElement(ele,{extra:extra})
                }
                setTimeout(()=>{
                    postMessage(EVENT_REFRESH_CONTENT_BOOKMARK_,{elements:excalidrawAPI.getSceneElements()})
                },100);
                if (isAdd){
                    message.info(t('HasAddedBookmark'))
                }
            }
        }else if ('pasteAsMindmap' == action){
            global.g_pasteAs = 'mindmap';
            excalidrawAPI.getApp().pasteFromClipboard(null);
        }else if ('pasteAsPlainText' == action){
            global.g_pasteAs = 'text';
            excalidrawAPI.getApp().pasteFromClipboard(null);
        }else if ('splitView' == action){
            const arraySelectedElements = excalidrawAPI.getApp().getSelectedElements();
            if (arraySelectedElements.length > 0){
                for (let i=0;i<arraySelectedElements.length;i++){
                    const element = arraySelectedElements[i];
                    if (isMdFileElement(element)){
                        const customData = {...element.customData};
                        customData.generationData.isSplitView = !(customData.generationData.isSplitView || false);
                        mutateElement(element,{customData:customData});
                    }
                }
            }
        }
        else if ("more" === action){
            isHiddenMenu = false;
            isHiddenMoreMenu = false;
        }else{
            excalidrawAPI.getApp().executeContextMenuAction(action);
        }

        if (this.state.isOpacityPopover || this.state.isPositionPopover || this.state.isBorderColorPopover || this.state.isBorderStylePopover){

        }else{
            if (this.state.isLayerPopover){
                //先关闭这个，然后才能关闭more的菜单.....!!!!imp
                this.setState({
                    isLayerPopover:false
                })

                const nTimeoutId = setTimeout(()=>{
                    this.setState({
                        isLayerPopover:false,
                        isShowMoreMenu:!isHiddenMoreMenu,
                        isShowFileNoExistMenu:false,
                    })
                },100);
                this.mArrayTimeoutIds.push(nTimeoutId);

            }else{
                this.setState({
                    isLayerPopover:false,
                    isShowMoreMenu:!isHiddenMoreMenu,
                    isShowContextMenu:false,
                    isShowFileNoExistMenu:false
                })
            }
        }

        //发送个消息..
        if (action == 'delete'){
            postMessage(EVENT_CANVAS_REFRESH_ELEMENT_COUNT)
        }
    }

    delayPopoverClose = ()=>{
        //先关闭这个，然后才能关闭more的菜单.....!!!!imp
        this.setState({
            isLayerPopover:false
        })

        const nTimeoutId = setTimeout(()=>{
            this.setState({
                isLayerPopover:false,
                isShowMoreMenu:false,
                isShowFileNoExistMenu:false,
            })
        },200);
        this.mArrayTimeoutIds.push(nTimeoutId);
    }

    targetElements =()=>{
        if (excalidrawAPI){
            return getTargetElements(
                excalidrawAPI?.getSceneElements(),
                excalidrawAPI?.getAppState(),
            );
        }
        return [];
    }

    /**
     * 不存在圆角设置的
     */
    noBorderRadus = ()=>{
        return this.targetElements().some(element=>element.type == 'line' ||
            element.type == 'arrow' ||
            element.type == 'freedraw' ||
            element.type == 'thickArrow'
        );
    }


    exportMarkdown = async (arraySelectCards:any)=>{
        if (arraySelectCards.length == 0){
            message.info(t("Please select"));
            return;
        }

        // window.showProgress(t("Exporting"));

        const arrayBuffers:any = [];
        let zip = new JSZip();

        await this.recursionNext(0,arraySelectCards,arrayBuffers,zip);
        window.closeProgress();

        // for (let i=0;i<arrayBuffers.length;i++){
        //     const item = arrayBuffers[i];
        //     zip.file(item.name + Date.now() +'.md',item.bufs,{});
        // }
        zip.generateAsync({type:"blob"}).then(function (content){
            saveAs(content,getCardTitle(arraySelectCards[0]) +'.zip');
            message.info(t('Markdown exported successfully'))
        });

        // ipcSend('save-markdown-to-system', arrayBuffer, item.name)
    }

    recursionNext = async (nIndex:number,arrayCards:any,arrayBufs:any,zip:any)=>{
        for (let i=0;i<arrayCards.length;i++){
            const item = arrayCards[i];
            const doc:any = await getCardDoc(item.id);
            item.doc = doc;
            const szName = getCardTitle(item);
            const hasEqual = arrayCards.some(p=>p.id != item.id && getCardTitle(p) == szName);
            await this.onExportMd(item,arrayBufs,zip,hasEqual);
        }
    }

    onExportMd = (item:any,arrayBufs:any,zip,hasEqual)=>{
        return new Promise(async (resolve, reject) => {
            window.editorForMd?.commands.setContent(item.doc);

            /*
            window.editorForMd?.chain().export({
                format: 'md',
                onExport(context) {
                    const { blob, error } = context
                    if(error){
                        noteServer.openTip("error", t("ExportMarkdownFail"));
                    }
                    blob?.arrayBuffer().then(async (bufs) => {
                        arrayBufs.push({
                            name:item.name,
                            bufs:bufs
                        });

                        resolve('');
                    });
                },
            })*/

            // 使用自定义的序列化器将 ProseMirror 文档转换为 Markdown
            const { markdown:md, images } = serializeProseMirrorToMarkdown(window.editorForMd?.state.doc);
            let markdown = md;

            let dtNow = '';
            //如果是否有重名的名称...
            if (hasEqual){
                dtNow = '-'+Date.now();
            }
            if (images && images.length > 0){
                const assetFolderName = `${getCardTitle(item)}${dtNow}-assets`;
                const assetFolder = zip.folder(assetFolderName);

                // 下载并添加所有图片
                for (const img of images) {
                    markdown = markdown.replace(
                        `asset/${img.filename}`,
                        `${assetFolderName}/${img.filename}`
                    );
                    try {
                        const blob = await downloadImageAsBlob(img.src);
                        if (blob && assetFolder) {
                            assetFolder.file(img.filename, blob);
                        }
                    } catch (error) {
                        console.error(`Failed to download image: ${img.src}`, error);
                    }
                }

                const encoder = new TextEncoder();
                const arrayBuffer = encoder.encode(markdown).buffer;
                // arrayBufs.push({
                //     name:item.name,
                //     bufs:arrayBuffer
                // });

                zip.file(getCardTitle(item) + dtNow +'.md',arrayBuffer,{});

            }else{
                // 如果没有图片,直接导出 markdown 文件
                const encoder = new TextEncoder();
                const arrayBuffer = encoder.encode(markdown).buffer;
                // arrayBufs.push({
                //     name:item.name,
                //     bufs:arrayBuffer
                // });
                zip.file(getCardTitle(item) + dtNow +'.md',arrayBuffer,{});
            }

            resolve('');
        })
    }

    /**
     * 导出单个md
     * @param item
     */
    onExportSingleMd = async (item:any)=>{
        window.exportMarkdown(item);
        // window.showProgress(t("Exporting"))
        // if (!item.doc){
        //     item.doc = await getCardDoc(item.id);
        // }
        // window.editorForMd?.commands.setContent(item.doc);
        // window.editorForMd?.chain().export({
        //     format: 'md',
        //     onExport(context) {
        //         const { blob, error } = context
        //         if(error){
        //             noteServer.openTip("error", t("ExportMarkdownFail"));
        //             return;
        //         }
        //         blob.arrayBuffer().then(arrayBuffer => {
        //             window.closeProgress();
        //
        //             ipcSend('save-markdown-to-system', arrayBuffer, item.name)
        //         });
        //     },
        // })
    }
    //endregion

    getSelectedElements = ()=>{
        return excalidrawAPI.getApp().getSelectedElements();
    }


    renderMoreLevelMenu = (item:any)=>{
        return <>
            {
                //region ****border color
                item.id == 'border_color' &&
                <Popover trigger={"hover"} placement={"right"}
                         arrow={false}
                         align={{offset:[16,0]}}
                         open={this.state.isBorderColorPopover}
                         onOpenChange={(e) => {
                             if(this.state.mCurrentSelectedElement?.locked) {
                                 e = false;
                             }
                             this.setState({
                                 isBorderColorPopover: e
                             })
                         }}
                         content={
                             excalidrawAPI?.getApp().actionManager.renderAction("changeStrokeColorPopover")
                         }>
                    <div style={{position: 'absolute', width: '100%',left:'0',display:'flex',alignItems:'center',height:'100%'}}>
                        <img className={'img-mini-small-10 flex-right'}
                             src={getImagePathWithTheme('right_arrow')}/>
                    </div>

                </Popover>
                //endregion
            }

            {
                //region ****border style
                item.id == 'border_style' &&
                <Popover trigger={"hover"} placement={"right"}
                         arrow={false}
                         align={{offset:[16,0]}}
                         open={this.state.isBorderStylePopover}
                         onOpenChange={(e) => {
                             if(this.state.mCurrentSelectedElement?.locked) {
                                 e = false;
                             }
                             this.setState({
                                 isBorderStylePopover: e
                             })
                         }}
                         content={
                             <div className={'popover-box-shadow'} style={{
                                 margin: '-12px',
                                 width: '256px',
                                 height: 'auto',
                                 padding: '2px 12px 12px 12px'
                             }}>
                                 <div className='mt-12'>
                                     {
                                         this.targetElements().some(element=>element.type != 'freedraw') &&
                                         excalidrawAPI?.getApp().actionManager.renderAction("changeStrokeStyleHorizontal")
                                     }
                                 </div>
                                 <div className='mt-22'>
                                     {excalidrawAPI?.getApp().actionManager.renderAction("changeStrokeWidthToolbar")}
                                 </div>
                                 {
                                     !this.noBorderRadus() &&
                                     <div className='mt-12'>
                                         {excalidrawAPI?.getApp().actionManager.renderAction("changeCornerWidthToolbar")}
                                     </div>
                                 }
                             </div>
                         }>
                    <div style={{
                        position: 'absolute',
                        width: '100%',
                        left: '0',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%'
                    }}>
                        <img className={'img-mini-small-10 flex-right'}
                             src={getImagePathWithTheme('right_arrow')}/>
                    </div>

                </Popover>
                //endregion
            }

            {
                //region ****opacity
                item.id == 'opacity' &&
                <Popover trigger={"hover"} placement={"right"}
                         arrow={false}
                         align={{offset: [16, 0]}}
                         open={this.state.isOpacityPopover}
                         onOpenChange={(e) => {
                             if (this.state.mCurrentSelectedElement?.locked) {
                                 e = false;
                             }
                             this.setState({
                                 isOpacityPopover: e
                             })
                         }}
                         content={
                             excalidrawAPI?.getApp().actionManager.renderAction("changeOpacityPopoverContent")
                         }>
                    <div style={{position: 'absolute', width: '100%',left:'0',display:'flex',alignItems:'center',height:'100%'}}>
                        <img className={'img-mini-small-10 flex-right'}
                             src={getImagePathWithTheme('right_arrow')}/>
                    </div>

                </Popover>
                //endregion
            }

            {
                //region ****position
                item.id == 'position' &&
                <Popover trigger={"hover"} placement={"right"}
                         arrow={false}
                         align={{offset:[16,0]}}
                         open={this.state.isPositionPopover}
                         onOpenChange={(e) => {
                             if(this.state.mCurrentSelectedElement?.locked) {
                                 e = false;
                             }
                             this.setState({
                                 isPositionPopover: e
                             })
                         }}
                         content={
                             <div className={style.popoverPositon + ' font-size-12'}
                                  style={{
                                      width: '254px',
                                      height: '122px',
                                      padding: '12px 12px 10px 22px',
                                      margin: '-12px'
                                  }}>
                                 <div>
                                     {excalidrawAPI?.getApp().actionManager.renderAction("changePosition")}
                                 </div>
                                 <div>
                                     {excalidrawAPI?.getApp().actionManager.renderAction("changeSize")}
                                 </div>
                                 <div>
                                     {excalidrawAPI?.getApp().actionManager.renderAction("angleCorner")}
                                 </div>
                             </div>
                         }>
                    <div style={{position: 'absolute', width: '100%', left: '0', display: 'flex',alignItems:'center',height:'100%'}}>
                        <img className={'img-mini-small-10 flex-right'}
                             src={getImagePathWithTheme('right_arrow')}/>
                    </div>
                </Popover>
                //endregion
            }
        </>
    }

    /*更多菜单--右键菜单....*/
    renderMoreMenu = ()=>{
        let listItem = [];
        for (var i=0;i<this.state.arrayMoreMenus.length;i++){
            var item = this.state.arrayMoreMenus[i];
            if (item.label != MENU_SEPARATOR){
                listItem.push(
                    <li className={(this.state.mCurrentSelectedElement?.locked && item.id != 'lock')?'disable-hover':((item.id == 'color' || item.disabled)?'':'hovered-blue')}
                        style={{
                            color:'var(--text-color)',
                            minHeight:item.id == 'color'?'56px':(isNoteElement(this.state.mCurrentSelectedElement)?'34px':'34px'),
                            height:item.id == 'color'?'56px':(isNoteElement(this.state.mCurrentSelectedElement)?'34px':'34px'),
                            opacity:(this.state.mCurrentSelectedElement?.locked && item.id !== 'lock')?'0.5':'1.0',
                            display:((item.id==='group' && Object.keys(excalidrawAPI.getAppState().selectedElementIds).length > 1) || item.id != 'group')?'inherit':'none'
                        }} data-id={item.id}
                        key={item.id} onClick={(e)=>this.onMenuClick(e.currentTarget.dataset.id)}>
                        <div className={'flex-row-vertical-center ' + (isDarkMode()?'none':'none')} style={{width:'100%',position:"relative"}} >
                            {
                                <img className='ml-2 img-16 mr-4' style={{opacity:item.showIcon?'100':'0'}} src={getImagePathWithTheme(item.icon.replace('.png',''))}/>
                            }

                            {
                                item.id != 'color' && !item.disabled &&
                                <>
                                    <span style={{marginLeft:item.marginLeft || '6px'}}>{item.id !== 'lock'?item.label:(this.state.mCurrentSelectedElement?.locked?t("Unlock"):t("Lock"))}</span>
                                    {
                                        item.id == 'ocr' && !hasLicense() &&
                                        <img className='img-18 ml-6' src={imgPathPerfix()+'vip.png'}/>
                                    }
                                    {
                                        item.isBeta &&
                                        <label className={'flex-center beta'}>{t("Beta")}</label>
                                    }
                                </>
                            }

                            {
                                item.disabled &&
                                <div className={'no-filter'} style={{}}>
                                    <span
                                         style={{marginLeft:item.marginLeft || '6px',color: 'var(--color-666666)'}}>{item.label}</span>
                                </div>
                            }

                            {
                                //region children
                                item.children &&
                                <Popover trigger={"hover"} placement={"right"}
                                         arrow={false}
                                         overlayInnerStyle={{margin: '0', padding: '0px 0'}}
                                         align={{offset:[16,0]}}
                                         onOpenChange={(e) => {

                                         }}
                                         content={
                                             <div className={'ul-menu default-font-size'} style={{minWidth:'300px',padding:'6px 0'}}>
                                                 {
                                                     item.children.map(childItem=>{
                                                         return childItem.label == MENU_SEPARATOR?<span key={item.id} className='line' style={{margin:'4px 0px'}}/>:
                                                             <li className={(this.state.mCurrentSelectedElement?.locked && childItem.id != 'lock') ? 'disable-hover' : ((childItem.id == 'color' || childItem.disabled) ? '' : 'hovered-blue')}
                                                                 style={{
                                                                     color: 'var(--text-color)',
                                                                     minHeight: childItem.id == 'color' ? '56px' : (isNoteElement(this.state.mCurrentSelectedElement) ? '34px' : '34px'),
                                                                     height: childItem.id == 'color' ? '56px' : (isNoteElement(this.state.mCurrentSelectedElement) ? '34px' : '34px'),
                                                                     opacity: (this.state.mCurrentSelectedElement?.locked && childItem.id !== 'lock') ? '0.5' : '1.0',
                                                                     display: ((childItem.id === 'group' && Object.keys(excalidrawAPI.getAppState().selectedElementIds).length > 1) || childItem.id != 'group') ? 'inherit' : 'none'
                                                                 }} data-id={childItem.id}
                                                                 key={childItem.id}
                                                                 onClick={(e) => this.onMenuClick(e.currentTarget.dataset.id)}>
                                                                 <div
                                                                     className={'flex-row-vertical-center ' + (isDarkMode() ? 'none' : 'none')}
                                                                     style={{width: '100%', position: "relative"}}>
                                                                     {
                                                                         <img className='ml-2 img-16 mr-4'
                                                                              style={{opacity: childItem.showIcon ? '100' : '0'}}
                                                                              src={getImagePathWithTheme(childItem.icon.replace('.png', ''))}/>
                                                                     }

                                                                     {
                                                                         childItem.id != 'color' && !childItem.disabled &&
                                                                         <>
                                                                             <span
                                                                                 style={{marginLeft: childItem.marginLeft || '6px'}}>{childItem.id !== 'lock' ? childItem.label : (this.state.mCurrentSelectedElement?.locked ? t("Unlock") : t("Lock"))}</span>
                                                                             {
                                                                                 childItem.id == 'ocr' && !hasLicense() &&
                                                                                 <img className='img-18 ml-6'
                                                                                      src={imgPathPerfix() + 'vip.png'}/>
                                                                             }
                                                                             {
                                                                                 childItem.isBeta &&
                                                                                 <label
                                                                                     className={'flex-center beta'}>{t("Beta")}</label>
                                                                             }
                                                                         </>
                                                                     }

                                                                     {
                                                                         childItem.disabled &&
                                                                         <div className={'no-filter'} style={{}}>
                                                                             <span style={{
                                                                                 marginLeft: childItem.marginLeft || '6px',
                                                                                 color: 'var(--color-666666)'
                                                                             }}>{childItem.label}</span>
                                                                         </div>
                                                                     }

                                                                     {
                                                                         this.renderMoreLevelMenu(childItem)
                                                                     }
                                                                 </div>
                                                             </li>
                                                     })
                                                 }
                                             </div>
                                         }>
                                    <div style={{position: 'absolute', width: '100%',left:'0',display:'flex',alignItems:'center',height:'100%'}}>
                                        <img className={'img-mini-small-10 flex-right'}
                                             src={getImagePathWithTheme('right_arrow')}/>
                                    </div>

                                </Popover>
                                //endregion
                            }

                            {
                                this.renderMoreLevelMenu(item)
                            }

                            {
                                //region layer...
                                item.id == 'layer' && excalidrawAPI &&
                                <Popover trigger={"hover"} placement={"right"}
                                         arrow={false}
                                         align={{offset:[16,0]}}
                                         open={this.state.isLayerPopover}
                                         onOpenChange={(e) => {
                                             if(this.state.mCurrentSelectedElement.locked) {
                                                 e = false;
                                             }
                                             this.setState({
                                                 isLayerPopover: e
                                             })
                                         }}
                                         content={
                                             <ul className='ul-menu'
                                                 style={{minWidth: '232px', padding: '6px 0', margin: '-12px'}}>
                                                 <li className={'hovered-blue'} onClick={()=>this.onMenuClick("sendBackward")}><span>{t("Send backward")}</span></li>
                                                 <li className={'hovered-blue'} onClick={()=>this.onMenuClick("bringForward")}><span>{t("Bring forward")}</span></li>
                                                 <li className={'hovered-blue'} onClick={()=>this.onMenuClick("sendToBack")}><span>{t("Send to back")}</span></li>
                                                 <li className={'hovered-blue'} onClick={()=>this.onMenuClick("bringToFront")}><span>{t("Bring to front")}</span></li>
                                             </ul>
                                         }>
                                    <div style={{position: 'absolute', width: '100%', left: '0', display: 'flex',alignItems:'center',height:'100%'}}>
                                        <img className={'img-mini-small-10 flex-right'}
                                             src={getImagePathWithTheme('right_arrow')}/>
                                    </div>

                                </Popover>
                                //endregion
                            }

                            {
                                //region aligin...
                                item.id == 'align' && excalidrawAPI &&
                                <Popover trigger={"hover"} placement={"right"}
                                         arrow={false}
                                         align={{offset:[16,0]}}
                                         open={this.state.isAlignPopover}
                                         onOpenChange={(e) => this.setState({
                                             isAlignPopover: e
                                         })}
                                         content={
                                             <div className={isDarkMode()?'filter-all-img-white':'' + ' align-item'} style={{width:'154px',height:'75px',display:'flex',flexWrap:'wrap',margin:'-12px',padding:'8px'}}>
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignLeft")}
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignHorizontallyCentered")}
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignRight")}
                                                 {this.targetElements().length > 2 &&
                                                     excalidrawAPI?.getApp().actionManager.renderAction("distributeHorizontally")}
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignTop")}
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignVerticallyCentered")}
                                                 {excalidrawAPI?.getApp().actionManager.renderAction("alignBottom")}
                                                 {this.targetElements().length > 2 &&
                                                     excalidrawAPI?.getApp().actionManager.renderAction("distributeVertically")}
                                             </div>
                                         }>
                                    <div style={{position: 'absolute', width: '100%', left: '0', display: 'flex',alignItems:'center',height:'100%'}}>
                                        <img className={'img-mini-small-10 flex-right'}
                                             src={getImagePathWithTheme('right_arrow')}/>
                                    </div>

                                </Popover>
                                //endregion
                            }

                            {
                                //region color
                                item.id == 'color' &&
                                <div className={'no-filter'} style={{display:'flex',flexDirection:'column',justifyContent:'flex-start',alignItems:'flex-start',paddingBottom:'4px',width:'100%',marginLeft:item.marginLeft || '6px'}}>
                                    <span style={{marginLeft:'0px'}}>{item.label}</span>
                                    <div className={'flex-row-vertical-center'} style={{justifyContent:'space-between',margin:'0',width:'100%',marginLeft:'0px',paddingRight:'1px'}}>
                                        {
                                            (item.type == 'stickyNote'?this.state.arrayStickyNotesMenuColors:this.state.arrayCardContextMenuColors).map(p=>{
                                                return(
                                                    <div className={'cursor-pointer no-filter'} key={p.useBackgroundColor+p.border} style={{width:'18px',height:'18px',position:'relative'}} onClick={(event:any)=>{
                                                        event.preventDefault();
                                                        event.stopPropagation();
                                                        if (p.useBackgroundColor) {
                                                            const arrayNew = [...ARRAY_CARD_DEFAULT_COLORS];
                                                            for (let i=0;i<arrayNew.length;i++) {
                                                                if (arrayNew[i].useBackgroundColor == p.useBackgroundColor || arrayNew[i].useDarkBackgroundColor == p.useDarkBackgroundColor) {
                                                                    arrayNew[i].isSelected = true;
                                                                    break;
                                                                }
                                                            }
                                                            if (item.type == 'stickyNote') {
                                                                this.setState({
                                                                    arrayStickyNotesMenuColors:arrayNew
                                                                })
                                                            }else{
                                                                this.setState({
                                                                    arrayCardContextMenuColors:arrayNew
                                                                })
                                                            }

                                                            //设置背景色...
                                                            const arraySelectedElements:any = excalidrawAPI.getApp().getSelectedElements();
                                                            for (let i=0;i<arraySelectedElements.length;i++) {
                                                                if (isStickyNotesElement(arraySelectedElements[i])) {
                                                                    localStorage.setItem(KEY_DEFAULT_STICKYNOTE_BACKGROUND_COLOR,p.useBackgroundColor);
                                                                }else if (isNoteElement(arraySelectedElements[i])) {
                                                                    let jsonConfig:any = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
                                                                    if (jsonConfig){
                                                                        jsonConfig = JSON.parse(jsonConfig);
                                                                    }else{
                                                                        jsonConfig = {};
                                                                    }
                                                                    jsonConfig.backgroundColor = p.useBackgroundColor;
                                                                    localStorage.setItem(KEY_CARD_ELEMENT_DEFAULT_STYLE,JSON.stringify(jsonConfig));
                                                                }
                                                                excalidrawAPI?.getApp().onUpdateElement(arraySelectedElements[i],{backgroundColor:isDarkMode()?p.useDarkBackgroundColor:p.useBackgroundColor})
                                                            }
                                                        }
                                                    }}>
                                                        <div style={{borderRadius:'9px',background:p.background,width:'100%',height:'100%',border:'1px solid '+p.border,display:'block'}}></div>
                                                        {
                                                            p.url &&
                                                            <Popover trigger={"click"} placement={"bottom"}
                                                                     arrow={false}
                                                                     align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                                     content={
                                                                         excalidrawAPI.getApp().actionManager.renderAction("changeCardBackgroundColorPopover")}>
                                                                <img id={'img-colour-selectetttttttttttt'} className={'no-filter'} style={{
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    position: 'absolute',
                                                                    left: '0',
                                                                    top: '0',

                                                                    borderRadius: '9.1px',
                                                                    overflow: 'hidden',
                                                                    filter: 'none!important',//这个属性设置不上？？？？？？？？？？？？？、不显示

                                                                }} src={imgPathPerfix() + p.url}/>
                                                            </Popover>

                                                        }
                                                    </div>
                                                );
                                            })
                                        }

                                    </div>
                                </div>
                                //endregion
                            }

                            {
                                //shortcut
                                item.shortcut &&
                                <span style={{position:'absolute',right:'0px', color:'var(--color-9A9A9A)'}}>{getCtrlOrAlt(item.shortcut)}</span>
                            }
                        </div>

                    </li>
                )
            } else {
                listItem.push(
                    <span key={item.id} className='line' style={{margin:'4px 0px'}}/>
                )
            }
        }
        if (this.state.arrayMoreMenus.length == 0 || !this.state.arrayMoreMenus[0]){
            return <></>
        }
        return(
            // this.state.arrayMoreMenus[0].marginLeft? 表示是插入deeplink自动弹出的右键。。。..
            <ul className='ul-menu' style={{minWidth:this.state.arrayMoreMenus[0].width?this.state.arrayMoreMenus[0].width:'312px',padding:'6px 0',margin:'-12px'}}>
                {listItem}
            </ul>
        )
    }

    /**
     * 打开url--下载文件
     * @param url
     */
    downloadFile = (url)=>{
        const eleLink = document.createElement('a');
        eleLink.style.display = 'none';
        eleLink.target = "_self"
        eleLink.href = url;
        // eleLink.href = record;
        document.body.appendChild(eleLink);
        eleLink.click();
        document.body.removeChild(eleLink);
    }

    isFileElementCurrentSelect = ()=>{
        if (!this.state.mCurrentSelectedElement)return false;
        return (this.state.mCurrentSelectedElement?.type == 'iframe' && this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'file');
    }

    hasNoLink = ()=>{
        if (!this.state.mCurrentSelectedElement)return false;
        return (this.state.mCurrentSelectedElement?.type == 'iframe' && this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'file') ||
            this.state.mCurrentSelectedElement.type == 'frame' ||
            this.state.mCurrentSelectedElement.type == 'mindmap' ||
            isNoteElement(this.state.mCurrentSelectedElement) ||
            isArrowElement(this.state.mCurrentSelectedElement) ||
            this.isLiveVideoElementCurrentSelect() ||
            isProjectLinkElement(this.state.mCurrentSelectedElement);
    }

    isPdfFileElementCurrentSelect = ()=>{
        return  (this.isFileElementCurrentSelect() && isPdf(this.state.mCurrentSelectedElement?.customData?.generationData?.fileName));
    }

    isVideoFileElementCurrentSelect = ()=>{
        return isFileVideoElement(this.state.mCurrentSelectedElement);
    }

    isAudioFileElementCurrentSelect = ()=>{
        return isAudioFileElement(this.state.mCurrentSelectedElement);
    }

    isMdFileElementCurrentSelect = ()=>{
        return isMdFileElement(this.state.mCurrentSelectedElement);
    }

    isImageElementCurrentSelect = ()=>{
        return isImageElement(this.state.mCurrentSelectedElement);
    }

    isLiveVideoElementCurrentSelect = ()=>{
        return isSupportVideoAnnoUrl(this.state.mCurrentSelectedElement?.link);
    }

    /**
     * 是否有边框色
     * @param element
     */
    hasStrokeColor = (element:any)=>{
        if (isFileElement(element))return false;

        return (element.type === 'rectangle'
            || element.type === 'roundedRectangle'
            || element.type === 'diamond'
            || element.type === 'ellipse'
            || element.type === 'arrow'
            || element.type === 'line'
            || element.type === 'triangle'
            || element.type === 'bubble'
            || element.type === "parallelogram"
            || element.type === "pentagram"
            || element.type === "thickArrow"
            || element.type == 'iframe'
            // || element.type == 'embeddable'
            || element.type == 'freedraw'
            || element.type == 'highlighter'
            || element.type == 'frame'
            || (element.type == 'image' && element?.extra?.svg))
    }

    hasNoLineMenu = ()=>{
        let hasStroke = this.targetElements().some(element=>this.hasStrokeColor(element));
        if (this.targetElements().length > 1){
            return hasStroke;
        }
        return isMindmapElement(this.state.mCurrentSelectedElement) ||
            isImageElement(this.state.mCurrentSelectedElement) ||
            isFileElement(this.state.mCurrentSelectedElement) ||
            isEmbeddableElement(this.state.mCurrentSelectedElement) ||
            this.state.mCurrentSelectedElement?.locked;
    }

    /*图片预览*/
    renderImagePreview = ()=>{
        return(
            <Image.PreviewGroup
                width={20}
                style={{display: 'none', zIndex: 99}}
                preview={{
                    current:this.state.currentPreviewIndex,
                    visible: this.state.isImagePreviewVisible,
                    onVisibleChange: (value) => {
                        this.setState({
                            isImagePreviewVisible: value
                        });
                    },
                    onChange:((current, prevCurrent) => {
                        this.setState({
                            currentPreviewIndex:current
                        })
                    })
                }}>
                {this.state.arrayImages.map(ele => <Image width={20} style={{zIndex:'99'}} src={ele.dataURL || ele.src}/>)}
            </Image.PreviewGroup>
        )
    }

    /**
     * 更改连接线的曲线-直线
     */
    onChangeLineType = (el:any,value)=>{
        let arrayElements = excalidrawAPI.getSceneElements();
        const arraySelectedItem = excalidrawAPI.getApp().getSelectedElements();

        var arrayNew = [...arrayElements];
        const updates = {
            roundness:
                value === "round"
                    ? {
                        type: isUsingAdaptiveRadius(el.type)
                            ? ROUNDNESS.ADAPTIVE_RADIUS
                            : ROUNDNESS.PROPORTIONAL_RADIUS,
                    }
                    : (value == 'elbow'?{type:ROUNDNESS.ELBOW}:null),
        };
        for (let i=0;i<arraySelectedItem.length;i++){
            let item = arraySelectedItem[i];
            if (isArrowElement(item)){
                item = {
                    ...item,
                    ...updates,
                }
                const nIndex = arrayNew.findIndex(p=>p.id == item.id);
                arrayNew.splice(nIndex,1,item);
            }
        }

        excalidrawAPI.updateScene({
            elements:arrayNew
        })

        // excalidrawAPI.getApp().onUpdateElement(el, {
        //     roundness:
        //         value === "round"
        //             ? {
        //                 type: isUsingAdaptiveRadius(el.type)
        //                     ? ROUNDNESS.ADAPTIVE_RADIUS
        //                     : ROUNDNESS.PROPORTIONAL_RADIUS,
        //             }
        //             : null,
        // })
    }

    onChangeArrowheadStyle = (position: 'start' | 'end', type: string | null) => {
        let arrayElements = excalidrawAPI.getSceneElements();
        const arraySelectedItem = excalidrawAPI.getApp().getSelectedElements();
        var arrayNew = [...arrayElements];
        let lastModifiedItem: any = null;
        for (let i = 0; i < arraySelectedItem.length; i++) {
            let item = arraySelectedItem[i];
            if (isArrowElement(item)) {
                const updates = position === 'start'
                    ? { startArrowhead: type }
                    : { endArrowhead: type };
                item = { ...item, ...updates };
                delete Global.g_elementWithCanvasCache00000[item.id];
                const nIndex = arrayNew.findIndex(p => p.id == item.id);
                arrayNew.splice(nIndex, 1, item);
                lastModifiedItem = item;
            }
        }
        excalidrawAPI.updateScene({ elements: arrayNew });
        if (lastModifiedItem) {
            this.setState({ mCurrentSelectedElement: lastModifiedItem });
        }
    }

    onReverseArrowDirection = () => {
        let arrayElements = excalidrawAPI.getSceneElements();
        const arraySelectedItem = excalidrawAPI.getApp().getSelectedElements();
        var arrayNew = [...arrayElements];
        let lastModifiedItem: any = null;
        for (let i = 0; i < arraySelectedItem.length; i++) {
            let item = arraySelectedItem[i];
            if (isArrowElement(item)) {
                item = {
                    ...item,
                    startArrowhead: item.endArrowhead,
                    endArrowhead: item.startArrowhead,
                };
                delete Global.g_elementWithCanvasCache00000[item.id];
                const nIndex = arrayNew.findIndex(p => p.id == item.id);
                arrayNew.splice(nIndex, 1, item);
                lastModifiedItem = item;
            }
        }
        excalidrawAPI.updateScene({ elements: arrayNew });
        if (lastModifiedItem) {
            this.setState({ mCurrentSelectedElement: lastModifiedItem });
        }
    }

    renderArrowheadIcon = (type: string | null, direction: 'start' | 'end', color: string) => {
        const w = 22, h = 18;
        const sw = 1.5;
        if (direction === 'end') {
            switch (type) {
                case null:
                    return <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="Group 427322993">
                            <rect id="Rectangle 34625540" width="30" height="30" rx="6.42857" fill="#D9D9D9"
                                  fill-opacity="0.01"/>
                            <g id="Frame" clip-path="url(#clip0_6_8318)">
                                <g id="Group 427323211">
                                    <path id="Vector" d="M22.5 15.5H7.5" stroke={color} stroke-width="1.2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_6_8318">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 24 6.5)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                case 'triangle':
                    return <svg width={w} height={h} viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g id="Frame" clip-path="url(#clip0_6_9988)">
                            <g id="Group 427323211">
                                <path id="Vector" d="M16.5 9H1.5" stroke={color} stroke-width="1.2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Vector 1231"
                                      d="M16.9729 8.98304L13.0306 6.51912C13.0173 6.5108 13 6.52038 13 6.53608V9V11.4639C13 11.4796 13.0173 11.4892 13.0306 11.4809L16.9729 9.01696C16.9854 9.00913 16.9854 8.99087 16.9729 8.98304Z"
                                      fill={color} stroke={color}/>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_6_9988">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                case 'arrow':
                case 'arrow_line':
                    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g id="Frame" clip-path="url(#clip0_6_9996)">
                            <g id="Group 427323211">
                                <path id="Vector" d="M13.5 6L16.5 9L13.5 12" stroke={color} stroke-width="1.2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                                <path id="Vector_2" d="M16.5 9H1.5" stroke={color} stroke-width="1.2"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_6_9996">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                case 'triangle_concave':
                    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g id="Group 427323212">
                            <g id="Frame" clip-path="url(#clip0_6_9999)">
                                <g id="Group 427323211">
                                    <path id="Vector" d="M16.5 9H1.5" stroke={color} stroke-width="1.2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                            </g>
                            <path id="Vector 1231"
                                  d="M16.9729 8.98304L13.0996 6.56223C13.0805 6.5503 13.0593 6.5741 13.0733 6.59168L14.99 8.98751C14.9958 8.99481 14.9958 9.00519 14.99 9.01249L13.0733 11.4083C13.0593 11.4259 13.0805 11.4497 13.0996 11.4378L16.9729 9.01696C16.9854 9.00913 16.9854 8.99087 16.9729 8.98304Z"
                                  fill="#393834" stroke={color}/>
                        </g>
                        <defs>
                            <clipPath id="clip0_6_9999">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                        ;
                default:
                    return <svg width={w} height={h} viewBox="0 0 22 14" fill="none">
                        <line x1="2" y1="7" x2="20" y2="7" stroke={color} strokeWidth={sw} strokeLinecap="round"/>
                    </svg>;
            }
        } else {
            switch (type) {
                case null:
                    return <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g id="Group 427322993">
                            <rect id="Rectangle 34625540" width="30" height="30" rx="6.42857" fill="#D9D9D9"
                                  fill-opacity="0.01"/>
                            <g id="Frame" clip-path="url(#clip0_6_8318)">
                            <g id="Group 427323211">
                                    <path id="Vector" d="M22.5 15.5H7.5" stroke={color} stroke-width="1.2"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </g>
                            </g>
                        </g>
                        <defs>
                            <clipPath id="clip0_6_8318">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 24 6.5)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                case 'triangle':
                    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_14_3896)">
                            <path d="M16.5 9H1.5" stroke={color} stroke-width="1.2" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                            <path
                                d="M1.02714 8.98304L4.9694 6.51912C4.98272 6.5108 5 6.52038 5 6.53608V9V11.4639C5 11.4796 4.98272 11.4892 4.9694 11.4809L1.02714 9.01696C1.0146 9.00913 1.0146 8.99087 1.02714 8.98304Z"
                                fill={color} stroke={color}/>
                        </g>
                        <defs>
                            <clipPath id="clip0_14_3896">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                        ;
                case 'arrow':
                case 'arrow_line':
                    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_14_3924)">
                            <path d="M4.5 6L1.5 9L4.5 12" stroke={color} stroke-width="1.2" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                            <path d="M16.5 9H1.5" stroke={color} stroke-width="1.2" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_14_3924">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                case 'triangle_concave':
                    return <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_14_3907)">
                            <path d="M16.5 9H1.5" stroke={color} stroke-width="1.2" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </g>
                        <path
                            d="M1.02714 8.98304L4.90044 6.56223C4.91953 6.5503 4.94072 6.5741 4.92666 6.59168L3.01 8.98751C3.00415 8.99481 3.00415 9.00519 3.01 9.01249L4.92666 11.4083C4.94072 11.4259 4.91953 11.4497 4.90044 11.4378L1.02714 9.01696C1.0146 9.00913 1.0146 8.99087 1.02714 8.98304Z"
                            fill={color} stroke={color}/>
                        <defs>
                            <clipPath id="clip0_14_3907">
                                <rect width="18" height="18" fill="white" transform="matrix(0 1 -1 0 18 0)"/>
                            </clipPath>
                        </defs>
                    </svg>;
                default:
                    return <svg width={w} height={h} viewBox="0 0 22 14" fill="none">
                        <line x1="2" y1="7" x2="20" y2="7" stroke={color} strokeWidth={sw} strokeLinecap="round"/>
                    </svg>;
            }
        }
    }

    /**
     * 取frame的比率
     */
    getFrameRate = (element: any) => {
        const nRate = element.width / element.height;
        for (let i = 0; i < ARRAY_IFRAME_SIZE.length; i++) {
            const item = ARRAY_IFRAME_SIZE[i];
            if (item.pageSize) {
                let nR = item.pageSize[0] / item.pageSize[1];
                if (nRate.toFixed(1) == nR.toFixed(1)) {
                    return item.title;
                }
            }
        }
        return t("Custom size")
    }
    getFrameRateImage = (element:any)=>{
        const nRate = element.width/element.height;
        for (let i=0;i<ARRAY_IFRAME_SIZE.length;i++){
            const item = ARRAY_IFRAME_SIZE[i];
            if (item.pageSize){
                let nR = item.pageSize[0]/item.pageSize[1];
                if (nRate.toFixed(1) == nR.toFixed(1)){
                    return item.imageName;
                }
            }
        }
        return "page_size_custom.png";
    }


    getElementHighlightTooltips = ()=>{
        if (this.isPdfFileElementCurrentSelect()) {
            return t("PDF Highlight");
        }
        return t("Video notes")
    }
    //是书签的embed
    isBookmarkEmbedable = ()=>{
        return isEmbeddableElement(this.state.mCurrentSelectedElement) && !isSupportVideoAnnoUrl(this.state.mCurrentSelectedElement?.link)
    }

    /**
     * 元素的tags...
     */
    updateElementTagList = (element:any)=>{
        getCardById(element?.customData?.generationData?.pdfData?.id || element?.customData?.generationData?.id || element.id).then(library=>{
            this.setState({
                arrayCurrentElementTags:library?.tags || []
            })
        });
    }

    isAllTextOrShape = ()=>{
        const arraySelectEle = excalidrawAPI.getApp().getSelectedElements();
        const nTextElement = arraySelectEle.filter(p=>isTextElement(p) || isStickyNotesElement(p)).length;
        return nTextElement == arraySelectEle.length;
    }

    /**
     * 图标颜色
     */
    getIconColor = ()=>{
        return isDarkMode() ? '#ffffff' : '#747471';
    }


    isGifElement = ()=>{
        const element = this.state.mCurrentSelectedElement;
        if (isImageElement(element)){
            const file = excalidrawAPI.getFiles()[element.fileId];
            if (file && file.mimeType == MIME_TYPES.gif){
                return true;
            }
        }
        return false;
    }

    isElementTitle = (element)=>{
        return isImageElement(element) ||
            isPdfFileElement(element) ||
            isFileVideoElement(element) ||
            isLiveVideoElement(element) ||
            isAudioFileElement(element) ||
            isEmbeddableElement(element);
    }

    /**
     * 有标题或者是notes的
     */
    isAllSelectedHasTitleOrNotesElement = ()=>{
        const arrayElements = this.getSelectedElements();
        return (arrayElements.every(p=>this.isElementTitle(p)));
    }

    /**
     * 所有的元素都是带边框的...
     */
    isAllElementBorderColor = ()=>{
        const arrayElements = this.getSelectedElements();
        return arrayElements.every(p=>isPdfFileElement(p) ||
            isFileVideoElement(p) ||
            isAudioFileElement(p) ||
            isLiveVideoElement(p) ||
            isAnnoElement(p) || isImageElement(p) || isFileElement(p) || isEmbedableBookmarkElement(p))
    }

    /**
     * 当前激活的是绘制工具
     */
    isActiveToolDrawing = ()=>{
        return (excalidrawAPI.getApp().state.activeTool.type == 'freedraw' || excalidrawAPI.getApp().state.activeTool.type == 'highlighter' || excalidrawAPI.getApp().state.activeTool.type == 'eraser')
    }

    /**
     * 多选对齐方式
     */
    renderLayoutAlign = ()=>{
        return <Popover arrow={false}
                 placement={'bottom'}
            // align={{offset: [6, 0]}}
                 overlayInnerStyle={{margin: '0',padding:'6px 0',minWidth:'220px'}}
                 trigger={['hover']} content={
            <div>
                {
                    ARRAY_LAYOUT_ITEM().map(p=>{
                        return(<div className={'flex-row-vertical-center dropdown-item'} style={{padding:'0 16px',minHeight:'36px'}} onClick={()=>{
                            const action = excalidrawAPI.getApp().actionManager.actions[p.id];
                            excalidrawAPI.getApp().actionManager.executeAction(action)
                        }}>
                            <img className={'img-16'} src={getImagePathWithTheme(p.image)}/>
                            <span className={'ml-12 default-font-size'}>{p.name}</span>
                        </div>)
                    })
                }
            </div>
        }>
            <div className=' flex-center'
                 style={{width: '30px', height: '100%', margin: '0px'}}>
                <Tooltip title={t("Layout")} arrow={false}>
                    <img className='img-30 hovered'
                         src={getImagePathWithTheme('toolbar_auto_layout.svg')}/>
                </Tooltip>
            </div>
        </Popover>
    }

    render() {
        return (
            <>
                {
                    <Excalidraw
                        handleKeyboardGlobally={false}
                        initialData={
                            {
                                elements:[
                                ],
                                appState:{
                                    currentItemStrokeWidth:1,
                                    currentItemRoughness:0,
                                    // theme:isDarkMode()?'dark':'light',  //如此dark theme中的styles.scss 中的&.theme--dark 去不掉？filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);filter: var(--theme-filter);去不掉！！！！！！！！！
                                    viewBackgroundColor: isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND,
                                    width:400,
                                    height:600,
                                    // gridModeEnabled:true,
                                    // gridSize:10
                                    viewModeEnabled:APP_WEB,
                                    leftMenuWidth:LEFT_MENU_WIDTH,//左边栏宽度---

                                    zoom:{value:1.0}
                                },
                                scrollToContent:false,
                                libraryItems:[]
                            }
                        }
                        onPointerDown={this.onPointerDown}
                        onPointerMove={this.onPointerMove}
                        onPointerUp={this.onPointerUp}
                        onDrag={this.onDrag}
                        onDoubleClick={this.onExcalidrawDoubleClick}
                        onContextMenuOpen={this.onContextMenuOpen}
                        excalidrawAPI={(api => this.excalidrawFirstAfter(api))}
                        onZoomChanged={this.props.parentOnZoomChanged}
                        onChange={(elements, state) => {
                            // console.info("State : ", state);
                            global.g_canvasZoomValue = state.zoom.value;
                            if (this.props.parentOnCanvasChange != null) {
                                this.props.parentOnCanvasChange(elements, state);
                            }
                        }}
                        onScrollChange={(scrollX, scrollY, zoom)=>{
                            if (this.state.isShowMenu){
                                var elements = excalidrawAPI.getSceneElements();
                                for(var i=0;i<elements.length;i++){
                                    var item = elements[i];
                                    if(excalidrawAPI.getAppState().selectedElementIds[item.id] != undefined){
                                        this.onUpdateMenuPosition(item);
                                        break;
                                    }
                                }
                            }
                            this.setState({
                                isOutsideContent:excalidrawAPI?.getAppState().scrolledOutside
                            })
                        }}
                        onLinkOpen={((element, event) => {
                            event.preventDefault();
                            let isInSlider = false;
                            if (event instanceof MouseEvent){
                                isInSlider = event.metaKey || event.ctrlKey;
                            }else if (event instanceof CustomEvent){
                                isInSlider = (event.detail.nativeEvent.metaKey || event.detail.nativeEvent.ctrlKey);
                            }
                            this.onLinkOpenClick(element.link as string,isInSlider);
                        })}
                        onClickElement={async (element,isShowMenu=false,event:any)=>{
                            if (event?.metaKey || event?.ctrlKey){
                                if (excalidrawAPI.getApp().getSelectedElements().length >= 1)return;
                                global.g_isCtrlPressed = true;
                                setTimeout(()=>{
                                    global.g_isCtrlPressed = false;
                                    if (isInSidebar()){
                                        // window.parent.postMessage({action:'setCtrlPressed',isPressed:false})
                                        localStorage.setItem(KEY_ISCTRL_CMD_PRESSED,'false');
                                    }
                                },2000);

                                if (isNoteElement(element)){
                                    if (isInSidebar()){
                                        // window.parent.postMessage({action:'setCtrlPressed',data:{isPressed:true}})
                                        localStorage.setItem(KEY_ISCTRL_CMD_PRESSED,'true');
                                    }
                                    //浮窗打开...
                                    this.props.parentOnEditNoteData(element,false,'dialog',true,false);
                                    return;
                                }else if (isPdfFileElement(element)){
                                    //浮窗打开//浮窗打开//浮窗打开//浮窗打开//浮窗打开
                                    setTimeout(()=>{
                                        window.showPdfPreview(element?.customData?.generationData?.name, element?.customData?.generationData?.id, element?.customData?.generationData?.fileName);
                                    },200)

                                    return;
                                }else if (isFileVideoElement(element) || isAudioFileElement(element) || isLiveVideoElement(element)){
                                    const highlight = await getCardById(element?.customData?.generationData?.id);
                                    if (highlight) {//有视频注记，用视频注记打开
                                        if (!highlight.name) {
                                            highlight.name = element?.customData?.generationData?.name;
                                        }
                                        window.showVideoNotes(highlight);
                                    }
                                }else if (isMdFileElement(element)) {
                                    //打开编辑...
                                    window.showDialogTiptapTextEditorView(element);
                                }
                            }
                            this.props.parentOnSelectElement(element);
                            if (isFrameElement(element) && !element.locked) {
                                // if (element.locked) {
                                //     this.onSetContextMenu(element);
                                //     this.onUpdateMenuPosition(element);
                                // }

                                this.setState({
                                    mCurrentSelectedElement:element,
                                    isFramePopoverOpen:false,
                                    isShowStrokeColorPopup:false,
                                });

                                return;
                            }
                            if (isNoteElement(element))return;

                            if (element) {
                                let selectElementIds = {[element.id]: true};
                                if (event?.metaKey || event?.ctrlKey){
                                    selectElementIds = {
                                        ...excalidrawAPI.getAppState().selectedElementIds,
                                        [element.id]: true
                                    }
                                }
                                const nTimeoutId = setTimeout(() => {
                                    excalidrawAPI.updateScene({
                                        appState: {
                                            ...excalidrawAPI.getAppState(),
                                            selectedElementIds: selectElementIds
                                        }
                                    })
                                }, 300);//多延迟点，不然别的地方有问题，比如响应的link链接的点击判断--app.tsx   private handleCanvasPointerUp = (


                                this.mArrayTimeoutIds.push(nTimeoutId);

                                this.setState({
                                    mCurrentSelectedElement:element,
                                    isFramePopoverOpen:false,
                                    isShowStrokeColorPopup:false
                                })

                                if (isShowMenu) {
                                    this.onSetContextMenu(element);
                                    this.onUpdateMenuPosition(element);
                                }

                                if (element.locked) {
                                    this.onSetContextMenu(element);
                                    this.onUpdateMenuPosition(element);
                                }
                            }else{

                                const nTimeoutId = setTimeout(() => {
                                    //取最后一个元素...
                                    const arrayElements = excalidrawAPI.getSceneElements();
                                    if (arrayElements.length > 0){
                                        const lastEle = arrayElements[arrayElements.length-1];
                                        if ((Date.now() - lastEle.created) < 2000){
                                            return;
                                        }
                                    }

                                    excalidrawAPI.updateScene({
                                        appState: {
                                            ...excalidrawAPI.getAppState(),
                                            selectedElementIds: {}
                                        }
                                    })
                                }, 100);
                                this.mArrayTimeoutIds.push(nTimeoutId);
                            }
                        }}

                        onElementChangedCallback={()=>{
                            //元素更改了，要保存..
                            this.props.parentOnSelectElementChanged();
                        }}

                        onSceneElementUpdate={(action,extra)=>{
                            this.props.parentOnSceneElementUpdate(action,extra);
                        }}

                        onSelectedElementChanged={()=>{
                            this.setState({
                                isShowStrokeColorPopup:false
                            })
                            //如果没有选中的就隐藏该隐藏的
                            const nSelectLength = Object.keys(excalidrawAPI.getApp().state.selectedElementIds).length;
                            if (nSelectLength == 0) {
                                this.setState({
                                    isShowMenu:false,
                                })
                            }
                            //只有选中1个的时候保存到数据库。
                            if (nSelectLength == 0 && !excalidrawAPI.getApp().mIsMouseMoving) {
                                this.props.parentOnSelectElementChanged();
                            }
                        }}

                        name="Drawing"
                        autoFocus={this.state.excalidrawAutofocus}
                        UIOptions={{
                            canvasActions: {loadScene: false}
                        }}>

                        {/*<LiveCollaborationTrigger*/}
                        {/*    isCollaborating={false}*/}
                        {/*    onSelect={() => {*/}
                        {/*        window.alert("You clicked on collab button");*/}

                        {/*    }}*/}
                        {/*/>*/}

                        {/*{renderMenu()}*/}
                    </Excalidraw>
                }


                {excalidrawAPI?.getAppState()?.scrolledOutside && (
                    <button
                        className="button-border-gray-style"
                        style={{zIndex:'99',position:'absolute',bottom:isInSidebar()?'56px':`${isMac()?'20px':'50px'}`,left:'50%',translate:'translationX(-50%)',padding:'0 16px',background:isDarkMode()?DEFAULT_CANVAS_BACKGROUND_DARK:DEFAULT_CANVAS_BACKGROUND}}
                        onClick={() => {
                            const nTimeoutId = setTimeout(()=>{
                                this.setState({
                                    isOutsideContent:false
                                })
                            },10);
                            this.mArrayTimeoutIds.push(nTimeoutId);

                            excalidrawAPI?.getApp().setAppState((appState) => ({
                                ...calculateScrollCenter(excalidrawAPI.getSceneElements(), appState),
                            }));

                        }}
                    >
                        {t("Back to content")}
                    </button>
                )}


                {/*图片预览*/}
                {this.renderImagePreview()}
                {/*<Image*/}
                {/*    width={20}*/}
                {/*    style={{display: 'none', zIndex: 99}}*/}
                {/*    preview={{*/}
                {/*        visible: this.state.isImagePreviewVisible,*/}
                {/*        src: this.state.imagePreviewData,*/}
                {/*        onVisibleChange: (value) => {*/}
                {/*            this.setState({*/}
                {/*                isImagePreviewVisible: value*/}
                {/*            });*/}
                {/*        },*/}
                {/*    }}*/}
                {/*/>*/}

                {
                    this.state.isShowMenu &&
                    <div key={this.state.randomKey} style={{
                        backgroundColor: 'var(--background-color)',
                        zIndex: '5',
                        boxShadow: 'var(--menu-box-shadow)',
                        borderRadius: '10px',
                        border: '0px solid var(--setting-button-border-color)',
                        position: "absolute", left: this.state.menuPosition.left, top: this.state.menuPosition.top
                    }}>
                        {
                            ((Object.keys(excalidrawAPI.getApp().state.selectedElementIds).length == 1 || this.isAllTextOrShape()) || (excalidrawAPI.getAppState().editingElement && Object.keys(excalidrawAPI.getApp().state.selectedElementIds).length == 1)) ?
                            <div style={{position: 'relative'}}>
                                <div className='menu'>
                                    {
                                        isMdFileElement(this.state.mCurrentSelectedElement) &&
                                        <>
                                            <Tooltip title={<div className={'flex-column-center'}>
                                                <span>{t("Open in popup")}</span><span>{isMac() ? t("CmdCtrlToOpenInFloatingWindow").replace("Ctrl", "Cmd") : t("CmdCtrlToOpenInFloatingWindow")}</span>
                                            </div>} arrow={false}>
                                                <div className={style.toolbarItem + ' hovered'}
                                                     style={{
                                                         background: COLOR_TRANSPARENT,
                                                         flexShrink: '0',
                                                         width: '32px',
                                                         height: '32px'
                                                     }} onClick={(event)=>{
                                                    let isCtrl = event.ctrlKey || event.metaKey;
                                                    Global.g_isCtrlPressed = isCtrl;
                                                    //打开编辑...
                                                    window.showDialogTiptapTextEditorView(this.state.mCurrentSelectedElement);
                                                    setTimeout(()=>{
                                                        Global.g_isCtrlPressed = false;
                                                    },2000);
                                                }}>
                                                    <img className='img-28 hovered renderbackgroundcolor-myexcalidraw'
                                                         style={{flexShrink: '0', width: '30px', height: '30px'}}
                                                         src={getImagePathWithTheme('toolbar_element_openin_dialog.svg')}/>
                                                </div>
                                            </Tooltip>
                                            <div className={'line-split-width1'}></div>
                                        </>
                                    }
                                    {
                                        (this.state.mCurrentSelectedElement?.type === 'image' && !this.state.mCurrentSelectedElement.extra?.svg && !this.state.mCurrentSelectedElement?.locked) &&
                                        <>
                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName ? t("Hide title") : t("Show title")}
                                                arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showName")}>
                                                    <img className={'img-30 menu-text-name-0'}
                                                         src={getImagePathWithTheme('menu_text_name')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowInfoNotes?t("Hidden notes"):t("Notes1")}
                                                arrow={false}>
                                                <div className='hovered flex-center menu_text_note-1' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showInfoNotes")}>
                                                    <img className={'img-30'}
                                                         src={getImagePathWithThemeSvg('menu_text_note')}/>
                                                </div>
                                            </Tooltip>

                                            <div className={'line-split-width1'}></div>

                                            {
                                                !this.isGifElement() &&
                                                <Tooltip title={t("Crop")} arrow={false}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        flexShrink: '0',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("crop")}>
                                                        <img style={{width: '31px', height: '31px'}}
                                                             src={getImagePathWithTheme('menu_crop')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                            {/*<div className={'line-split-width1 line1'}></div>*/}
                                        </>
                                    }

                                    {
                                        //又改为了和本地视频一样的菜单。这个单独的不要
                                        false && (isSupportVideoAnnoUrl(this.state.mCurrentSelectedElement?.link) || isAudioFileElement(this.state.mCurrentSelectedElement)) &&
                                        <Tooltip arrow={false} overlayStyle={{maxWidth: '2000px'}}
                                                 title={<div className={'flex-column-center'}>
                                                     {/*<span>{isAudioFileElement(this.state.mCurrentSelectedElement) ? t("Audio notes") : t("Video notes")}</span><span>{isMac() ? t("CmdCtrlToAddSlider").replace("Ctrl", "Cmd") : t("CmdCtrlToAddSlider")}</span>*/}
                                                     <span>{t("Open in popup")}</span><span>{isMac() ? t("CmdCtrlToOpenInFloatingWindow").replace("Ctrl", "Cmd") : t("CmdCtrlToOpenInFloatingWindow")}</span>
                                                 </div>}>
                                            <div className='hovered flex-center' style={{
                                                width: '30px',
                                                height: '30px',
                                                display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                            }} onClick={(event) => {
                                                if (event.metaKey || event.ctrlKey) {
                                                    // this.onMenuClick("openVideoInSide")
                                                    global.g_isCtrlPressed = true;
                                                    this.onMenuClick("openVideoInPopup");
                                                    const nTimeoutId = setTimeout(() => {
                                                        global.g_isCtrlPressed = false;
                                                    }, 1000);
                                                    this.mArrayTimeoutIds.push(nTimeoutId);
                                                } else {
                                                    this.onMenuClick("openVideoInPopup")
                                                }
                                            }}>
                                                <img className='img-30' src={getImagePathWithTheme('menu_video_note')}/>
                                            </div>
                                        </Tooltip>
                                    }

                                    {
                                        isFrameElement(this.state.mCurrentSelectedElement) && !this.state.mCurrentSelectedElement.locked &&
                                        <div className={'flex-row-vertical-center'}>
                                            <Popover
                                                arrow={false}
                                                placement={"bottom"}
                                                onOpenChange={(e) => {
                                                    this.setState({
                                                        isFramePopoverOpen: e
                                                    })
                                                }}
                                                align={{offset: [39, 4]}}
                                                open={this.state.isFramePopoverOpen}
                                                trigger={'click'}
                                                content={
                                                    <div className='div-tool-style font-size-12'
                                                         style={{minWidth: '240px'}}>
                                                        {
                                                            ARRAY_IFRAME_SIZE.map(p => (
                                                                p.id != 'Custom Size' &&
                                                                <div key={'frame-rate-' + p.id} data-id={p.id}
                                                                     className='flex-row-vertical-center hovered-filter-img'
                                                                     onClick={() => {
                                                                         let nHeight = this.state.mCurrentSelectedElement.width * (p.pageSize[1] / p.pageSize[0]);
                                                                         mutateElement(this.state.mCurrentSelectedElement, {height: nHeight});
                                                                         this.setState({
                                                                             isFramePopoverOpen: false
                                                                         })
                                                                     }}>
                                                                    <img className='img-16'
                                                                         src={getImagePathWithTheme(p.imageName.replaceAll(".png", ""))}/>
                                                                    <span style={{flexGrow: '1'}}>{p.title}</span>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                }
                                            >
                                                <div className={'flex-row-vertical-center input-border cursor-pointer '}
                                                     style={{minWidth: '140px', height: '28px'}}>
                                                    <img className='img-16'
                                                         src={getImagePathWithTheme(this.getFrameRateImage(this.state.mCurrentSelectedElement).replaceAll(".png", ""))}/>
                                                    <span className={'flex-center ml-4 '} style={{
                                                        color: 'var(--text-color)',
                                                    }}>{this.getFrameRate(this.state.mCurrentSelectedElement)}</span>
                                                    <img style={{marginLeft: 'auto'}} className='img-mini-small-10 ml-6'
                                                         src={getImagePathWithTheme('drop_down_home')}/>
                                                </div>
                                            </Popover>
                                            {/*<div className={'line-split-width1'}></div>*/}
                                        </div>
                                    }

                                    {
                                        isProjectLinkElement(this.state.mCurrentSelectedElement) &&
                                        <>
                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Add to sidebar")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("openProjectInSiderbar");
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('element_pop_menu_slideright')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                    }

                                    {
                                        //bookmark---emebed
                                        this.isBookmarkEmbedable() &&
                                        <Tooltip
                                            title={this.state.mCurrentSelectedElement.embedType == 'text' ? t("SwitchToEmbedMode") : t("SwitchToBookmarkMode")}
                                            arrow={false}>
                                            <div className='flex-center cursor-pointer' style={{
                                                display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit',
                                                flexShrink: '0',
                                            }}
                                                 onClick={() => this.onMenuClick(this.state.mCurrentSelectedElement.embedType == 'text' ? "switchToEmbedMode" : "switchToBookmarkMode")}>
                                                <div style={{
                                                    padding: '0 8px',
                                                    color: 'var(--text-color)'
                                                }}>{this.state.mCurrentSelectedElement.embedType == 'text' ? t("Embed") : t("Bookmark")}</div>
                                                <div className={'line-split-width1'}></div>
                                            </div>
                                        </Tooltip>
                                    }

                                    {
                                        //增加右侧栏打开.
                                        this.isBookmarkEmbedable() &&
                                        <>
                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Add to sidebar")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("openWebInSiderbar");
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('element_pop_menu_slideright')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                    }

                                    {
                                        //embed的链接，又在背景颜色前面----每一次设计图都重新改一个图标？？？？？？？!
                                        this.isBookmarkEmbedable() &&
                                        <Tooltip title={t("Link")} arrow={false}>
                                            <div className=' flex-center' style={{
                                                display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                            }} onClick={() => this.onMenuClick("link")}>
                                                <img className='img-30 hovered'
                                                     src={getImagePathWithTheme('menu_link_3')}/>
                                            </div>
                                        </Tooltip>
                                    }

                                    {
                                        excalidrawAPI?.getApp() && !this.state.mCurrentSelectedElement?.locked &&
                                        <ActionToolbar_Menu appState={excalidrawAPI?.getAppState()}
                                                            elements={excalidrawAPI.getSceneElements()}
                                                            app={excalidrawAPI.getApp()}
                                                            renderAction={excalidrawAPI.getApp().actionManager.renderAction}/>
                                    }

                                    {
                                        // !this.hasNoLineMenu() &&
                                        // <div datatype={'ActionToolbar_Menu-after'} className={'line-split-width1 line2'}></div>
                                    }

                                    {
                                        (isArrowElement(this.state.mCurrentSelectedElement)) && !this.state.mCurrentSelectedElement?.locked &&
                                        <>
                                            <Popover arrow={false} placement={"bottom"}
                                                     open={this.state.isShowPopoverLineType}
                                                     onOpenChange={(e) => {
                                                         this.setState({
                                                             isShowPopoverLineType: e,
                                                         })
                                                     }} align={{offset: [0, 6]}}
                                                     overlayInnerStyle={{padding: '4px 6px'}}
                                                     trigger={['click']} content={() => {
                                                return <div className={'flex-row-vertical-center'}>
                                                    <Tooltip title={t("Curve")} arrow={false}>
                                                        <img className='img-30 hovered'
                                                             src={getImagePathWithTheme('line_type')} onClick={() => {
                                                            localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'curve');
                                                            this.onChangeLineType(this.state.mCurrentSelectedElement, 'round')
                                                        }}/>
                                                    </Tooltip>
                                                    <Tooltip title={t("Elbow")} arrow={false}>
                                                        <img className='img-30 hovered'
                                                             src={getImagePathWithTheme('line_type_wan.svg')} onClick={() => {
                                                            localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'elbow');
                                                            this.onChangeLineType(this.state.mCurrentSelectedElement, 'elbow')
                                                        }}/>
                                                    </Tooltip>
                                                    <Tooltip title={t("Straight")} arrow={false}>
                                                        <img className='img-30 hovered ml-4'
                                                             src={getImagePathWithTheme('line_type_straight')}
                                                             onClick={() => {
                                                                 localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'straight');
                                                                 this.onChangeLineType(this.state.mCurrentSelectedElement, 'sharp');
                                                             }}/>
                                                    </Tooltip>
                                                </div>
                                            }}>
                                                <div className='flex-center'
                                                     style={{width: '30px', height: '100%', margin: '0px'}}
                                                >
                                                    <Tooltip title={t("Line type")} arrow={false}>
                                                        <img className='img-30 hovered'
                                                             src={getImagePathWithTheme('line_type')}/>
                                                    </Tooltip>
                                                </div>
                                            </Popover>

                                            <div className={'line-split-width1'}></div>

                                            {/* 起点箭头样式下拉 */}
                                            <Popover arrow={false} placement={"bottom"}
                                                     open={this.state.isShowStartArrowPopover}
                                                     onOpenChange={(e) => this.setState({ isShowStartArrowPopover: e })}
                                                     align={{offset: [0, 6]}}
                                                     overlayInnerStyle={{padding: '4px 6px'}}
                                                     trigger={['click']} content={() => {
                                                const types: {key: string|null, tip: string}[] = [
                                                    {key: null, tip: t("None arrow")},
                                                    {key: 'triangle', tip: t("Solid arrow")},
                                                    {key: 'arrow_line', tip: t("Line arrow")},
                                                    {key: 'triangle_concave', tip: t("Concave arrow")},
                                                ];
                                                return <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
                                                    {types.map(item => (
                                                        <Tooltip key={item.key||'none'} title={item.tip} arrow={false} placement="left">
                                                            <div className='hovered flex-center' style={{
                                                                width:'30px',height:'30px',borderRadius:'8px',
                                                                background: this.state.mCurrentSelectedElement?.startArrowhead === item.key ? 'var(--hover-background-color)' : 'transparent'
                                                            }} onClick={() => {
                                                                this.onChangeArrowheadStyle('start', item.key);
                                                                this.setState({isShowStartArrowPopover: false});
                                                            }}>
                                                                {this.renderArrowheadIcon(item.key, 'start', this.getIconColor())}
                                                            </div>
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            }}>
                                                <div className='hovered flex-center' style={{width:'30px',height:'30px'}}>
                                                    {this.renderArrowheadIcon(this.state.mCurrentSelectedElement?.startArrowhead || null, 'start', this.getIconColor())}
                                                </div>
                                            </Popover>

                                            {/* 转换方向 */}
                                            <Tooltip title={t("Reverse")} arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px', height: '30px'
                                                }} onClick={() => this.onReverseArrowDirection()}>
                                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                                         xmlns="http://www.w3.org/2000/svg">
                                                        <g id="Group 427322994">
                                                            <rect id="Rectangle 34625540" width="30" height="30"
                                                                  rx="6.42857" fill="#D9D9D9" fill-opacity="0.01"/>
                                                            <g id="Frame" clip-path="url(#clip0_6_8322)">
                                                                <g id="Group 427323214">
                                                                    <path id="Vector"
                                                                          d="M21.75 15.5C21.75 13.7098 21.0388 11.9929 19.773 10.727C18.5071 9.46116 16.7902 8.75 15 8.75C13.113 8.7571 11.3017 9.49342 9.945 10.805L8.25 12.5"
                                                                          stroke={this.getIconColor()} stroke-width="1.2"
                                                                          stroke-linecap="round"
                                                                          stroke-linejoin="round"/>
                                                                    <path id="Vector_2" d="M8.25 8.75V12.5H12"
                                                                          stroke={this.getIconColor()} stroke-width="1.2"
                                                                          stroke-linecap="round"
                                                                          stroke-linejoin="round"/>
                                                                    <path id="Vector_3"
                                                                          d="M8.25 15.5C8.25 17.2902 8.96116 19.0071 10.227 20.273C11.4929 21.5388 13.2098 22.25 15 22.25C16.887 22.2429 18.6983 21.5066 20.055 20.195L21.75 18.5"
                                                                          stroke={this.getIconColor()} stroke-width="1.2"
                                                                          stroke-linecap="round"
                                                                          stroke-linejoin="round"/>
                                                                    <path id="Vector_4" d="M18 18.5H21.75V22.25"
                                                                          stroke={this.getIconColor()} stroke-width="1.2"
                                                                          stroke-linecap="round"
                                                                          stroke-linejoin="round"/>
                                                                </g>
                                                            </g>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_6_8322">
                                                                <rect width="18" height="18" fill="white"
                                                                      transform="translate(6 6.5)"/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                </div>
                                            </Tooltip>

                                            {/* 终点箭头样式下拉 */}
                                            <Popover arrow={false} placement={"bottom"}
                                                     open={this.state.isShowEndArrowPopover}
                                                     onOpenChange={(e) => this.setState({isShowEndArrowPopover: e})}
                                                     align={{offset: [0, 6]}}
                                                     overlayInnerStyle={{padding: '4px 6px'}}
                                                     trigger={['click']} content={() => {
                                                const types: { key: string | null, tip: string }[] = [
                                                    {key: null, tip: t("None arrow")},
                                                    {key: 'triangle', tip: t("Solid arrow")},
                                                    {key: 'arrow_line', tip: t("Line arrow")},
                                                    {key: 'triangle_concave', tip: t("Concave arrow")},
                                                ];
                                                return <div style={{display:'flex',flexDirection:'column',gap:'2px'}}>
                                                    {types.map(item => (
                                                        <Tooltip key={item.key||'none'} title={item.tip} arrow={false} placement="right">
                                                            <div className='hovered flex-center' style={{
                                                                width:'30px',height:'30px',borderRadius:'8px',
                                                                background: (this.state.mCurrentSelectedElement?.endArrowhead ?? 'arrow') === item.key ? 'var(--hover-background-color)' : 'transparent'
                                                            }} onClick={() => {
                                                                this.onChangeArrowheadStyle('end', item.key);
                                                                this.setState({isShowEndArrowPopover: false});
                                                            }}>
                                                                {this.renderArrowheadIcon(item.key, 'end', this.getIconColor())}
                                                            </div>
                                                        </Tooltip>
                                                    ))}
                                                </div>
                                            }}>
                                                <div className='hovered flex-center' style={{width:'30px',height:'30px'}}>
                                                    {this.renderArrowheadIcon(this.state.mCurrentSelectedElement?.endArrowhead, 'end', this.getIconColor())}
                                                </div>
                                            </Popover>

                                            <div className={'line-split-width1'}></div>
                                        </>
                                    }

                                    {
                                        this.isFileElementCurrentSelect() &&
                                        !this.isPdfFileElementCurrentSelect() &&
                                        !this.isVideoFileElementCurrentSelect() &&
                                        !this.isAudioFileElementCurrentSelect() &&
                                        !this.isMdFileElementCurrentSelect() &&
                                        <>
                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName ? t("Hide title") : t("Show title")}
                                                arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showName")}>
                                                    <img className={'img-30 menu-text-name-1'}
                                                         src={getImagePathWithTheme('menu_text_name')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowInfoNotes?t("Hidden notes"):t("Notes1")}
                                                arrow={false}>
                                                <div className='hovered flex-center menu_text_note-1' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showInfoNotes")}>
                                                    <img className={'img-30'}
                                                         src={getImagePathWithThemeSvg('menu_text_note')}/>
                                                </div>
                                            </Tooltip>

                                            <div className={'line-split-width1'}/>
                                            {/*<div className='hovered flex-center' style={{*/}
                                            {/*    width: '30px',*/}
                                            {/*    height: '100%',*/}
                                            {/*    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'*/}
                                            {/*}} onClick={() => this.onMenuClick("open")}>*/}
                                            {/*    <img className='img-28' src={imgPathPerfix() + 'menu_open.png'}/>*/}
                                            {/*</div>*/}
                                            <Tooltip title={t("Download")} arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("downloadFile")}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('menu_download_file')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                    }

                                    {
                                        //pdf--本地视频--在线视频--
                                        (this.isPdfFileElementCurrentSelect() || this.isVideoFileElementCurrentSelect() || this.isLiveVideoElementCurrentSelect() || this.isAudioFileElementCurrentSelect()) &&
                                        <>
                                            <Tooltip arrow={false} overlayStyle={{maxWidth: '2000px'}}
                                                     title={<div className={'flex-column-center'}>
                                                         <span>{this.getElementHighlightTooltips()}</span><span>{isMac() ? t("CmdCtrlToAddSlider").replace("Ctrl", "Cmd") : t("CmdCtrlToAddSlider")}</span>
                                                         {/*<span>{t("Open in popup")}</span><span>{isMac() ? t("CmdCtrlToOpenInFloatingWindow").replace("Ctrl", "Cmd") : t("CmdCtrlToOpenInFloatingWindow")}</span>*/}
                                                     </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {

                                                    if (event.metaKey || event.ctrlKey) {
                                                        if (this.isPdfFileElementCurrentSelect()) {
                                                            this.onMenuClick("openPdfInSliderRightWithAnno")
                                                        } else if (this.isVideoFileElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInSide")
                                                        } else if (this.isLiveVideoElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInSide")
                                                        } else if (this.isAudioFileElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInSide")
                                                        }
                                                        //下面是以浮窗的方式打开.
                                                        // global.g_isCtrlPressed = true;
                                                        // if (this.isPdfFileElementCurrentSelect()) {
                                                        //     this.onMenuClick('openPdfInPopupWithAnno')
                                                        // }else if (this.isVideoFileElementCurrentSelect()) {
                                                        //     this.onMenuClick("openVideoInPopup")
                                                        // }
                                                        // setTimeout(()=>{
                                                        //     global.g_isCtrlPressed = false;
                                                        // },1000)
                                                    } else {
                                                        if (this.isPdfFileElementCurrentSelect()) {
                                                            this.onMenuClick('openPdfInPopupWithAnno')
                                                        } else if (this.isVideoFileElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInPopup")
                                                        } else if (this.isLiveVideoElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInPopup")
                                                        } else if (this.isAudioFileElementCurrentSelect()) {
                                                            this.onMenuClick("openVideoInPopup")
                                                        }
                                                    }
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('menu_video_note')}/>
                                                </div>
                                            </Tooltip>
                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Add to sidebar")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    if (this.isPdfFileElementCurrentSelect()) {
                                                        this.onMenuClick("open")
                                                    } else if (this.isVideoFileElementCurrentSelect()) {
                                                        this.onMenuClick("openVideoInSide")
                                                    } else if (this.isLiveVideoElementCurrentSelect()) {
                                                        this.onMenuClick("openVideoInSide")
                                                    } else if (this.isAudioFileElementCurrentSelect()) {
                                                        this.onMenuClick("openVideoInSide")
                                                    }
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('element_pop_menu_slideright')}/>
                                                </div>
                                            </Tooltip>

                                            {/*********颜色和tag************/}
                                            <Popover trigger={"click"} placement={"bottom"}
                                                     arrow={false}
                                                     align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                     open={this.state.isShowStrokeColorPopup}
                                                     onOpenChange={(e) => {
                                                         this.setState({
                                                             isShowStrokeColorPopup: e
                                                         })
                                                     }}
                                                     content={
                                                         excalidrawAPI.getApp().actionManager.renderAction("changeStrokeColorPopover")}>
                                                <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                    <span>{t("Border")}</span>
                                                </div>}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={(event) => {

                                                    }}>
                                                        <img className='img-30 toolbar_element_background_new--1'
                                                             src={getImagePathWithTheme('toolbar_element_background_new')}/>
                                                    </div>
                                                </Tooltip>
                                            </Popover>

                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName ? t("Hide title") : t("Show title")}
                                                arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showName")}>
                                                    <img className={'img-30 menu-text-name-2'}
                                                         src={getImagePathWithTheme('menu_text_name')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowInfoNotes?t("Hidden notes"):t("Notes1")}
                                                arrow={false}>
                                                <div className='hovered flex-center menu_text_note-2' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showInfoNotes")}>
                                                    <img className={'img-30'}
                                                         src={getImagePathWithThemeSvg('menu_text_note')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip arrow={false} title={<div>
                                                {
                                                    this.state.arrayCurrentElementTags.length == 0 ?
                                                        <span>{t("Tags")}</span> :
                                                        this.state.arrayCurrentElementTags.map((item, index) => {
                                                            return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                        })
                                                }
                                            </div>} onOpenChange={(e) => {
                                                if (e) {
                                                    this.updateElementTagList(this.state.mCurrentSelectedElement)
                                                }
                                            }}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("manageTags")
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Info")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("showInfo")
                                                }}>
                                                    <img className='img-30 element_pop_menu_info-1'
                                                         src={getImagePathWithTheme('element_pop_menu_info')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                    }

                                    {
                                        //region mdfile
                                        isMdFileElement(this.state.mCurrentSelectedElement) &&
                                        <>
                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Split View")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("splitView")
                                                }}>
                                                    <img className='img-30 element_pop_menu_info-1'
                                                         src={getImagePathWithTheme('element_md_file_split.svg')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Info")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("showInfo")
                                                }}>
                                                    <img className='img-30 element_pop_menu_info-1-1'
                                                         src={getImagePathWithTheme('element_pop_menu_info')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                        //endregion
                                    }


                                    {
                                        (this.state.mCurrentSelectedElement?.customData?.generationData?.type != 'pdfAnno' &&
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type != 'videoAnno' &&
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type != 'audioAnno' &&
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type != 'cardAnno') &&

                                        <>
                                            {
                                                !isSupportVideoAnnoUrl(this.state.mCurrentSelectedElement?.link) &&
                                                !isArrowElement(this.state.mCurrentSelectedElement) &&
                                                !this.isPdfFileElementCurrentSelect() &&
                                                !this.isVideoFileElementCurrentSelect() &&
                                                !this.isAudioFileElementCurrentSelect() &&
                                                !this.isMdFileElementCurrentSelect() &&
                                                !isProjectLinkElement(this.state.mCurrentSelectedElement) &&
                                                !this.isBookmarkEmbedable() &&
                                                !this.isActiveToolDrawing() &&
                                                <Tooltip title={t("Duplicate")} arrow={false}>
                                                    <div className='hovered flex-center' style={{
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("duplicate")}>
                                                        {/*menu_duplicate_1*/}
                                                        <img className='img-30 hovered toolbar_menu_dup-1'
                                                             src={getImagePathWithTheme('toolbar_menu_dup.svg')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                            {
                                                // isImageElement(this.state.mCurrentSelectedElement) &&
                                                // <Tooltip title={t("Duplicate")} arrow={false}>
                                                //     <div className=' flex-center' style={{
                                                //         display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                //     }} onClick={() => this.onMenuClick("duplicate")}>
                                                //         <img className='img-30 hovered'
                                                //              src={getImagePathWithTheme('toolbar_menu_dup.svg')}/>
                                                //     </div>
                                                // </Tooltip>
                                            }
                                            {
                                                !this.hasNoLink() && !this.isBookmarkEmbedable() && !this.isActiveToolDrawing() &&
                                                <Tooltip title={t("Link")} arrow={false}>
                                                    <div className=' flex-center' style={{
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("link")}>
                                                        <img className='img-30 hovered'
                                                             src={getImagePathWithTheme('menu_link_1')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                            {
                                                isImageElement(this.state.mCurrentSelectedElement) &&
                                                <>
                                                    <div className={'line-split-width1'}></div>
                                                    {/*********颜色和tag************/}
                                                    <Popover trigger={"click"} placement={"bottom"}
                                                             arrow={false}
                                                             align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                             open={this.state.isShowStrokeColorPopup}
                                                             onOpenChange={(e) => {
                                                                 this.setState({
                                                                     isShowStrokeColorPopup: e
                                                                 })
                                                             }}
                                                             content={
                                                                 excalidrawAPI.getApp().actionManager.renderAction("changeStrokeColorPopover")}>
                                                        <Tooltip arrow={false}
                                                                 title={<div className={'flex-column-center'}>
                                                                     <span>{t("Border")}</span>
                                                                 </div>}>
                                                            <div className='hovered flex-center' style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                            }} onClick={(event) => {

                                                            }}>
                                                                <img className='img-30' id={'img-element-background toolbar_element_background_new-3'}
                                                                     src={getImagePathWithTheme('toolbar_element_background_new')}/>
                                                            </div>
                                                        </Tooltip>
                                                    </Popover>



                                                    <Tooltip arrow={false} title={<div>
                                                        {
                                                            this.state.arrayCurrentElementTags.length == 0 ?
                                                                <span>{t("Tags")}</span> :
                                                                this.state.arrayCurrentElementTags.map((item, index) => {
                                                                    return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                                })
                                                        }
                                                    </div>} onOpenChange={(e) => {
                                                        if (e) {
                                                            this.updateElementTagList(this.state.mCurrentSelectedElement)
                                                        }
                                                    }}>
                                                        <div className='hovered flex-center' style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                        }} onClick={async (event) => {
                                                            if (isImageElement(this.state.mCurrentSelectedElement)) {
                                                                const library = await getCardById(this.state.mCurrentSelectedElement.customData?.generationData?.id || this.state.mCurrentSelectedElement.id);
                                                                if (!library || library?.isDeleted == 2) {
                                                                    message.error(t("PleaseAddImageToLibrary"))
                                                                    return;
                                                                }
                                                            }
                                                            this.onMenuClick("manageTags")
                                                        }}>
                                                            <img className='img-30'
                                                                 src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                        </div>
                                                    </Tooltip>
                                                </>
                                            }

                                            {
                                                isImageElement(this.state.mCurrentSelectedElement) &&
                                                <Tooltip title={t("Remove")} arrow={false}>
                                                    <div className=' flex-center' style={{
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("delete")}>
                                                        <img className='img-30 hovered menu_delete_1-1'
                                                             src={getImagePathWithTheme('menu_delete_1')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                            {//文件的.
                                                this.isFileElementCurrentSelect() &&
                                                !this.isPdfFileElementCurrentSelect() &&
                                                !this.isVideoFileElementCurrentSelect() &&
                                                !this.isAudioFileElementCurrentSelect() &&
                                                !this.isMdFileElementCurrentSelect() &&
                                                <>
                                                    {/*********颜色和tag************/}
                                                    <Popover trigger={"click"} placement={"bottom"}
                                                             arrow={false}
                                                             align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                             open={this.state.isShowStrokeColorPopup}
                                                             onOpenChange={(e) => {
                                                                 this.setState({
                                                                     isShowStrokeColorPopup: e
                                                                 })
                                                             }}
                                                             content={
                                                                 excalidrawAPI.getApp().actionManager.renderAction("changeStrokeColorPopover")}>
                                                        <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                            <span>{t("Border")}</span>
                                                        </div>}>
                                                            <div className='hovered flex-center' style={{
                                                                width: '30px',
                                                                height: '30px',
                                                                display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                            }} onClick={(event) => {

                                                            }}>
                                                                <img className='img-30 toolbar_element_background_new-4' id={'file-background'}
                                                                     src={getImagePathWithTheme('toolbar_element_background_new')}/>
                                                            </div>
                                                        </Tooltip>
                                                    </Popover>


                                                    <Tooltip arrow={false} title={<div>
                                                        {
                                                            this.state.arrayCurrentElementTags.length == 0 ?
                                                                <span>{t("Tags")}</span> :
                                                                this.state.arrayCurrentElementTags.map((item, index) => {
                                                                    return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                                })
                                                        }
                                                    </div>} onOpenChange={(e) => {
                                                        if (e) {
                                                            this.updateElementTagList(this.state.mCurrentSelectedElement)
                                                        }
                                                    }}>
                                                        <div className='hovered flex-center' style={{
                                                            width: '30px',
                                                            height: '30px',
                                                            display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                        }} onClick={(event) => {
                                                            this.onMenuClick("manageTags")
                                                        }}>
                                                            <img className='img-30'
                                                                 src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                        </div>
                                                    </Tooltip>
                                                </>
                                            }

                                            {
                                                this.isAllTextOrShape() && Object.keys(excalidrawAPI.getApp().state.selectedElementIds).length > 1 &&
                                                this.renderLayoutAlign()
                                            }

                                            {
                                                !isEmbeddableElement(this.state.mCurrentSelectedElement) &&
                                                !this.isPdfFileElementCurrentSelect() &&
                                                !this.isVideoFileElementCurrentSelect() &&
                                                !this.isAudioFileElementCurrentSelect() &&
                                                !this.isImageElementCurrentSelect() &&
                                                !this.isMdFileElementCurrentSelect() &&
                                                !isProjectLinkElement(this.state.mCurrentSelectedElement) &&
                                                <Tooltip title={t("Remove")} arrow={false}>
                                                    <div className=' flex-center' style={{
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("delete")}>
                                                        <img className='img-30 hovered menu_delete_1-2'
                                                             src={getImagePathWithTheme('menu_delete_1')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                            {//图片的info....
                                                this.isImageElementCurrentSelect() &&
                                                <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                    <span>{t("Info")}</span>
                                                </div>}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={(event) => {
                                                        this.onMenuClick("showInfo")
                                                    }}>
                                                        <img className='img-30 element_pop_menu_info-2'
                                                             src={getImagePathWithTheme('element_pop_menu_info')}/>
                                                    </div>
                                                </Tooltip>
                                            }

                                        </>
                                    }

                                    {
                                        this.state.mCurrentSelectedElement?.locked &&
                                        <Tooltip title={t("Lock")} arrow={false}>
                                            <div className='hovered flex-center' style={{
                                                width: '30px',
                                                height: '30px',
                                                display: this.state.mCurrentSelectedElement?.locked ? 'inherit' : 'none'
                                            }} onClick={() => this.onMenuClick("lock")}>
                                                <img className='img-18' src={getImagePathWithTheme('menu_lock_1')}/>
                                            </div>
                                        </Tooltip>
                                    }

                                    {
                                        (this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'pdfAnno' ||
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'videoAnno' ||
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'audioAnno' ||
                                            this.state.mCurrentSelectedElement?.customData?.generationData?.type == 'cardAnno') &&
                                        <>
                                            <Tooltip title={t("Locate")} arrow={false}>
                                                <div className=' flex-center' style={{
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("open")}>
                                                    <img className='img-30 hovered'
                                                         src={getImagePathWithTheme('menu_location')}/>
                                                </div>
                                            </Tooltip>

                                            {/*********颜色和tag************/}
                                            <Popover trigger={"click"} placement={"bottom"}
                                                     arrow={false}
                                                     align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                     open={this.state.isShowStrokeColorPopup}
                                                     onOpenChange={(e) => {
                                                         this.setState({
                                                             isShowStrokeColorPopup: e
                                                         })
                                                     }}
                                                     content={
                                                         excalidrawAPI.getApp().actionManager.renderAction("changeStrokeColorPopover")}>
                                                <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                    <span>{t("Border")}</span>
                                                </div>}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={(event) => {

                                                    }}>
                                                        <img className='img-30 toolbar_element_background_new-5'
                                                             src={getImagePathWithTheme('toolbar_element_background_new')}/>
                                                    </div>
                                                </Tooltip>
                                            </Popover>


                                            <Tooltip arrow={false} title={<div>
                                                {
                                                    this.state.arrayCurrentElementTags.length == 0 ?
                                                        <span>{t("Tags")}</span> :
                                                        this.state.arrayCurrentElementTags.map((item, index) => {
                                                            return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                        })
                                                }
                                            </div>} onOpenChange={(e) => {
                                                if (e) {
                                                    this.updateElementTagList(this.state.mCurrentSelectedElement)
                                                }
                                            }}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("manageTags")
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                </div>
                                            </Tooltip>


                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Info")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("showInfo")
                                                }}>
                                                    <img className='img-30 element_pop_menu_info-3'
                                                         src={getImagePathWithTheme('element_pop_menu_info')}/>
                                                </div>
                                            </Tooltip>
                                        </>
                                    }

                                    {
                                        //连接线--箭头--的菜单
                                        // (this.targetElements().some(p => isArrowElement(p)) || isArrowElement(this.state.mCurrentSelectedElement)) &&
                                        // <Popover arrow={false} placement={"bottom"}
                                        //          open={this.state.isShowPopoverLineType}
                                        //          onOpenChange={(e) => {
                                        //              this.setState({
                                        //                  isShowPopoverLineType: e,
                                        //              })
                                        //          }} align={{offset: [0, 6]}}
                                        //          overlayInnerStyle={{padding: '4px 6px'}}
                                        //          trigger={['click']} content={() => {
                                        //     return <div className={'flex-row-vertical-center'}>
                                        //         <Tooltip title={t("Curve")} arrow={false}>
                                        //             <img className='img-30 hovered'
                                        //                  src={getImagePathWithTheme('line_type')} onClick={() => {
                                        //                 localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'curve');
                                        //                 this.onChangeLineType(this.state.mCurrentSelectedElement, 'round')
                                        //             }}/>
                                        //         </Tooltip>
                                        //         <Tooltip title={t("Elbow")} arrow={false}>
                                        //             <img className='img-30 hovered'
                                        //                  src={getImagePathWithTheme('line_type_wan.svg')} onClick={() => {
                                        //                 localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'elbow');
                                        //                 this.onChangeLineType(this.state.mCurrentSelectedElement, 'elbow')
                                        //             }}/>
                                        //         </Tooltip>
                                        //         <Tooltip title={t("Straight")} arrow={false}>
                                        //             <img className='img-30 hovered ml-4'
                                        //                  src={getImagePathWithTheme('line_type_straight')}
                                        //                  onClick={() => {
                                        //                      localStorage.setItem(KEY_GLOBAL_CONNECTOR_TYPE,'straight');
                                        //                      this.onChangeLineType(this.state.mCurrentSelectedElement, 'sharp');
                                        //                  }}/>
                                        //         </Tooltip>
                                        //     </div>
                                        // }}>
                                        //     <div className=' flex-center'
                                        //          style={{width: '30px', height: '100%', margin: '0px'}}
                                        //     >
                                        //         <Tooltip title={t("Line type")} arrow={false}>
                                        //             <img className='img-30 hovered'
                                        //                  src={getImagePathWithTheme('line_type')}/>
                                        //         </Tooltip>
                                        //     </div>
                                        // </Popover>
                                    }

                                    {
                                        //书签的notes-tags-info
                                        isEmbeddableElement(this.state.mCurrentSelectedElement) && !isSupportVideoAnnoUrl(this.state.mCurrentSelectedElement.link) &&
                                        <>
                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName ? t("Hide title") : t("Show title")}
                                                arrow={false}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showName")}>
                                                    <img className={'img-30 menu-text-name-3'}
                                                         src={getImagePathWithTheme('menu_text_name')}/>
                                                </div>
                                            </Tooltip>

                                            <Tooltip
                                                title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowInfoNotes?t("Hidden notes"):t("Notes1")}
                                                arrow={false}>
                                                <div className='hovered flex-center menu_text_note-3' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    flexShrink: '0',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={() => this.onMenuClick("showInfoNotes")}>
                                                    <img className={'img-30'}
                                                         src={getImagePathWithThemeSvg('menu_text_note')}/>
                                                </div>
                                            </Tooltip>
                                            <Tooltip arrow={false} title={<div>
                                                {
                                                    this.state.arrayCurrentElementTags.length == 0 ?
                                                        <span>{t("Tags")}</span> :
                                                        this.state.arrayCurrentElementTags.map((item, index) => {
                                                            return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                        })
                                                }
                                            </div>} onOpenChange={(e) => {
                                                if (e) {
                                                    getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id).then(res=>{
                                                        if (res){
                                                            this.setState({
                                                                arrayCurrentElementTags:res.tags || []
                                                            })
                                                        }
                                                    })
                                                }
                                            }}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    getCardById(this.state.mCurrentSelectedElement?.customData?.generationData?.id).then(res=>{
                                                        if (!res || res?.isDeleted == 2){
                                                            message.error(t('PleaseAddWeblinkToLibrary'));
                                                            return;
                                                        }
                                                        this.onMenuClick("manageTags")
                                                    })
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                </div>
                                            </Tooltip>


                                            <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                                <span>{t("Info")}</span>
                                            </div>}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={(event) => {
                                                    this.onMenuClick("showInfo")
                                                }}>
                                                    <img className='img-30 element_pop_menu_info-4'
                                                         src={getImagePathWithTheme('element_pop_menu_info')}/>
                                                </div>
                                            </Tooltip>
                                        </>

                                    }

                                    {
                                        //修改缩略图----先隐藏了。 更改缩略图
                                        isProjectLinkElement(this.state.mCurrentSelectedElement) &&
                                        <div className=' flex-center'
                                             style={{width: '30px', height: '100%', margin: '0px'}}>
                                            <Tooltip title={t("Thumbnail")} arrow={false}>
                                                <img className='img-30 hovered'
                                                     src={getImagePathWithTheme('toolbar_element_image')} onClick={()=>{
                                                         getNoteById(this.state.mCurrentSelectedElement.customData?.projectId,true,true).then((project:any)=>{
                                                             if (!project)return;
                                                             let szThumbUrl = '';
                                                             if (!ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG.includes(project.thumbUrl)){
                                                                 szThumbUrl = project.thumbUrl;
                                                             }
                                                             if (this.state.mCurrentSelectedElement?.customData?.boardId) {
                                                                 loop(project.doc.canvas, this.state.mCurrentSelectedElement.customData?.boardId, async (node) => {
                                                                     szThumbUrl = node.thumbUrl;
                                                                 })
                                                             }

                                                             window.showDialogChooseProjectLinkImage(szThumbUrl,async (data)=>{
                                                                 const isSameBoard = (p)=>{
                                                                     let hasSameBoard = true;
                                                                     if (this.state.mCurrentSelectedElement?.customData?.boardId){
                                                                         hasSameBoard = p.customData?.boardId == this.state.mCurrentSelectedElement?.customData?.boardId;
                                                                     }
                                                                     return hasSameBoard;
                                                                 }
                                                                 if (data.action == 'ok'){
                                                                     if (this.state.mCurrentSelectedElement.customData?.boardId){//更新board的缩略图.
                                                                         loop(project.doc.canvas,this.state.mCurrentSelectedElement.customData?.boardId,async (node)=>{
                                                                             node.thumbUrl = data.imagePath;
                                                                             await updateNote(project);

                                                                             //这里要把board单独保存出来...
                                                                             let board = await getBoardById(this.state.mCurrentSelectedElement.customData?.boardId);
                                                                             if (!board){
                                                                                 board = {
                                                                                     id:node.key,
                                                                                     name:node.title,
                                                                                     projectId:project.id,
                                                                                     sort:0,
                                                                                     type:'board',
                                                                                     isFavirated:0,
                                                                                 }//跟favirate保持数据一致
                                                                             }
                                                                             board.thumbUrl = data.imagePath;
                                                                             await updateBoard(board);

                                                                             if (window.updateBoardThumbUrl){
                                                                                 window.updateBoardThumbUrl(this.state.mCurrentSelectedElement.customData?.boardId,data.imagePath);
                                                                             }

                                                                         })
                                                                     }else{
                                                                         //直接改这个项目的缩略图.
                                                                         const project = await getNoteById(this.state.mCurrentSelectedElement.customData?.projectId,false);
                                                                         if (project){
                                                                             project.thumbUrl = data.imagePath;
                                                                             await updateProject(project);
                                                                         }
                                                                     }

                                                                     //更新画布上这个引用的所有
                                                                     const arrayElements = excalidrawAPI.getSceneElements().filter(p=>isProjectLinkElement(p) && p?.customData?.projectId == this.state.mCurrentSelectedElement.customData?.projectId && isSameBoard(p));
                                                                     for (let i=0;i<arrayElements.length;i++){
                                                                         const element = arrayElements[i];
                                                                         const customData = {...element.customData};
                                                                         customData.thumbImage = data.imagePath;
                                                                         mutateElement(element,{customData:customData});
                                                                     }
                                                                     //更新当前缩略图.
                                                                     if (PROJECT_ID == this.state.mCurrentSelectedElement.customData?.projectId && !this.state.mCurrentSelectedElement.customData?.boardId){
                                                                         this.props.parentOnMenuAction('updateThumbUrl',data.imagePath);
                                                                     }
                                                                 }else if (data.action == 'remove'){
                                                                     //移除这个项目的缩略图.
                                                                     //直接改这个项目的缩略图.
                                                                     if (this.state.mCurrentSelectedElement.customData?.boardId){//更新board的缩略图.
                                                                         loop(project.doc.canvas,this.state.mCurrentSelectedElement.customData?.boardId,async (node, i, data, parent)=>{
                                                                             node.thumbUrl = '';
                                                                             await updateNote(project);
                                                                             if (window.updateBoardThumbUrl){
                                                                                 window.updateBoardThumbUrl(this.state.mCurrentSelectedElement.customData?.boardId,'');
                                                                             }
                                                                         })
                                                                                     //projectBoard里面的图..
                                                                         const projectBoard = await getBoardById(this.state.mCurrentSelectedElement.customData?.boardId);
                                                                         if (projectBoard){
                                                                             projectBoard.thumbUrl = '';
                                                                             await updateBoard(projectBoard);
                                                                         }
                                                                     }else{
                                                                         //直接改这个项目的缩略图.
                                                                         const project = await getNoteById(this.state.mCurrentSelectedElement.customData?.projectId,false);
                                                                         if (project){
                                                                             project.thumbUrl = ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0];
                                                                             await updateProject(project);
                                                                         }
                                                                     }

                                                                     //更新画布上这个引用的所有
                                                                     const arrayElements = excalidrawAPI.getSceneElements().filter(p=>isProjectLinkElement(p) && p?.customData?.projectId == this.state.mCurrentSelectedElement.customData?.projectId && isSameBoard(p));
                                                                     for (let i=0;i<arrayElements.length;i++){
                                                                         const element = arrayElements[i];
                                                                         const customData = {...element.customData};
                                                                         customData.thumbImage = '';
                                                                         mutateElement(element,{customData:customData});
                                                                     }
                                                                     if (PROJECT_ID == this.state.mCurrentSelectedElement.customData?.projectId && !this.state.mCurrentSelectedElement.customData?.boardId){
                                                                         this.props.parentOnMenuAction('updateThumbUrl',ARRAY_DEFAULT_PROJECT_ITEM_THUMB_BIG[0]);
                                                                     }
                                                                 }else if (data.action == "reduceHeight"){
                                                                     // mutateElement(this.state.mCurrentSelectedElement,{height:this.state.mCurrentSelectedElement.height})
                                                                 }
                                                             })
                                                         })
                                                }}/>
                                            </Tooltip>
                                        </div>
                                    }

                                    <Popover arrow={false} placement={"rightBottom"} open={this.state.isShowMoreMenu}
                                             onOpenChange={(e) => {
                                                 this.setState({
                                                     isShowMoreMenu: e,
                                                     isShowContextMenu: false,
                                                 })
                                             }} align={{offset: [6, 0]}}
                                             trigger={['click']} content={this.renderMoreMenu()}>
                                        <div className=' flex-center'
                                             style={{width: '30px', height: '100%', margin: '0px'}}
                                        >
                                            <Tooltip title={t("More")} arrow={false}>
                                                <img id={'hor_more_single'} className='img-30 hovered'
                                                     src={getImagePathWithTheme('horizontal_more_1')}/>
                                            </Tooltip>
                                        </div>
                                    </Popover>

                                </div>
                                {/*<div className={this.state.mCurrentSelectedElement?.locked?'menu-more-locked':'menu-more'} style={{visibility:this.state.isShowMoreMenu?"visible":'hidden',top:this.state.menuPosition.moreTop,left:this.state.menuPosition.moreLeft}}>*/}
                                {/*    {this.renderMoreMenu()}*/}
                                {/*</div>*/}
                            </div>:
                                // 多元素选中的菜单 多选菜单
                            <div style={{position: 'relative'}}>
                                <div className='menu'>
                                    {
                                        <>
                                        {
                                            //又开始各种混加...
                                            this.isAllSelectedHasTitleOrNotesElement() &&
                                            <>
                                                <Tooltip
                                                    title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowName ? t("Hide title") : t("Show title")}
                                                    arrow={false}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        flexShrink: '0',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("showName")}>
                                                        <img className={'img-30 menu-text-name-4'}
                                                             src={getImagePathWithTheme('menu_text_name')}/>
                                                    </div>
                                                </Tooltip>

                                                <Tooltip
                                                    title={this.state.mCurrentSelectedElement?.customData?.generationData?.isShowInfoNotes?t("Hidden notes"):t("Notes1")}
                                                    arrow={false}>
                                                    <div className='hovered flex-center menu_text_note-1' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        flexShrink: '0',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={() => this.onMenuClick("showInfoNotes")}>
                                                        <img className={'img-30'}
                                                             src={getImagePathWithThemeSvg('menu_text_note')}/>
                                                    </div>
                                                </Tooltip>

                                                <div className={'line-split-width1'}/>
                                            </>
                                        }
                                            {/*********颜色和tag************/}
                                            <Popover trigger={"click"} placement={"bottom"}
                                                     arrow={false}
                                                     align={{offset: [0, ELEMENT_POPOVER_TOOLS_OFFSET_Y]}}
                                                     open={this.state.isShowStrokeColorPopup}
                                                     onOpenChange={(e) => {
                                                         this.setState({
                                                             isShowStrokeColorPopup: e
                                                         })
                                                     }}
                                                     content={
                                                         // changeStrokeColorPopover
                                                         //同一个操作，有的是背景，有的是边框，都是同一个button样式,,,,,,如果是改边框的就按边框的来。如果是改背景的就按背景来..---
                                                         this.isAllElementBorderColor()?excalidrawAPI.getApp().actionManager.renderAction("changeStrokeColorPopover"):
                                                         excalidrawAPI.getApp().actionManager.renderAction("changeBackgroundColorPopover")}>
                                                <Tooltip arrow={false}
                                                         title={<div className={'flex-column-center'}>
                                                             <span>{t("Color")}</span>
                                                         </div>}>
                                                    <div className='hovered flex-center' style={{
                                                        width: '30px',
                                                        height: '30px',
                                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                    }} onClick={(event) => {

                                                    }}>
                                                        <img className='img-30 toolbar_element_background_new-0' id={'other-1-background'}
                                                             src={getImagePathWithTheme('toolbar_element_background_new')}/>
                                                    </div>
                                                </Tooltip>
                                            </Popover>
                                            <Tooltip arrow={false} title={<div>
                                                {
                                                    this.state.arrayCurrentElementTags.length == 0 ?
                                                        <span>{t("Tags")}</span> :
                                                        this.state.arrayCurrentElementTags.map((item, index) => {
                                                            return <span>{item + ((index == this.state.arrayCurrentElementTags.length - 1) ? '' : ' , ')}</span>
                                                        })
                                                }
                                            </div>} onOpenChange={(e) => {
                                                // if (e) {
                                                //     this.updateElementTagList(this.state.mCurrentSelectedElement)
                                                // }
                                            }}>
                                                <div className='hovered flex-center' style={{
                                                    width: '30px',
                                                    height: '30px',
                                                    display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                                }} onClick={async (event) => {
                                                    this.onMenuClick("manageTags")
                                                }}>
                                                    <img className='img-30'
                                                         src={getImagePathWithTheme('toolbar_element_tags')}/>
                                                </div>
                                            </Tooltip>

                                            {
                                                this.renderLayoutAlign()
                                            }

                                            <Popover arrow={false} placement={"rightBottom"} open={this.state.isShowMoreMenu}
                                                     onOpenChange={(e) => {
                                                         this.setState({
                                                             isShowMoreMenu: e,
                                                             isShowContextMenu: false,
                                                         })
                                                     }} align={{offset: [6, 0]}}
                                                     trigger={['click']} content={this.renderMoreMenu()}>
                                                <div className=' flex-center'
                                                     style={{width: '30px', height: '100%', margin: '0px'}}
                                                >
                                                    <Tooltip title={t("More")} arrow={false}>
                                                        <img id={'more-mul'} className='img-30 hovered'
                                                             src={getImagePathWithTheme('horizontal_more_1')}/>
                                                    </Tooltip>
                                                </div>
                                            </Popover>
                                        </>
                                    }
                                </div>
                            </div>
                        }

                    </div>
                }

                {
                    //控制一堆要删除的，不如直接新建2个
                    this.state.isShowFileNoExistMenu &&
                    <div key={this.state.randomKey} style={{
                        backgroundColor: 'var(--background-color)',
                        zIndex: '5',
                        boxShadow: 'var(--menu-box-shadow)',
                        borderRadius: '10px',
                        border: '0px solid var(--setting-button-border-color)',
                        position: "absolute", left: this.state.menuPosition.left, top: this.state.menuPosition.top
                    }}>
                        <div style={{position: 'relative'}}>
                            <div className='menu'>
                                <Tooltip arrow={false} title={<div className={'flex-column-center'}>
                                    <span>{t("Video notes")}</span><span>{isMac() ? t("CmdCtrlToAddSlider").replace("Ctrl", "Cmd") : t("CmdCtrlToAddSlider")}</span>
                                </div>}>
                                    <div className='hovered flex-center' style={{
                                        width: '30px',
                                        height: '30px',
                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                    }} onClick={(event) => {
                                        if (event.metaKey || event.ctrlKey) {
                                            this.onMenuClick("openVideoInSide")
                                        } else {
                                            this.onMenuClick("openVideoInPopup")
                                        }

                                    }}>
                                        <img className='img-30' src={getImagePathWithTheme('menu_video_note')}/>
                                    </div>
                                </Tooltip>

                                <Tooltip title={t("Remove")} arrow={false}>
                                    <div className=' flex-center' style={{
                                        display: this.state.mCurrentSelectedElement?.locked ? 'none' : 'inherit'
                                    }} onClick={() => this.onMenuClick("delete")}>
                                        <img className='img-30 hovered menu_delete_1-3'
                                             src={getImagePathWithTheme('menu_delete_1')}/>
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    </div>
                }


                {/*右键*/}
                {
                    this.state.isShowContextMenu &&
                    <div className={(isDarkMode() ? 'filter-all-img-white-1' : '') + ' menu-more'} style={{
                        width: 'auto',
                        zIndex: '100',
                        left: this.state.contextMenuPosition.left,
                        top: this.state.contextMenuPosition.top
                    }}>
                        {this.renderMoreMenu()}
                    </div>
                }


                {
                    //右下角水印
                    // (!hasLicense()) && isCanvasReadonly &&
                    // <div className='watermark'>
                    //     <img style={{width: '19px', height: '18px'}} src={imgPathPerfix() + 'watermark_1.png'}/>
                    //     <img style={{width: '84px', height: '18px'}} src={imgPathPerfix() + 'watermark_2.png'}/>
                    // </div>
                }


                <DialogWordCount ref={(ref) => this.onDialogWordCountRef(ref)}/>
            </>
        );
    }
}

export default React.memo(MyExcalidraw, areEqual);

function areEqual(prevProps: any, nextProps: any) {
    // if (JSON.stringify(prevProps.element) == JSON.stringify(nextProps.element)){
    //     return true;
    // }
    return false
}
